export default {
  common: {
    noFace: 'Без лицевой стороны',
    noPermissionTip: 'У вас нет разрешения на использование этой функции. Пожалуйста, приобретите или продлите для продолжения.',
    selected: 'Выбран',
    continue: 'Продолжить',
    open1: 'Открыть',
    doubleClick: 'Двойной клик',
    inputKeywordSearch: 'Введите ключевое слово для поиска',
    inputKeywordStartSearch: 'Введите ключевое слово для начала поиска',
    searchHistory: 'История поиска',
    clearHistory: 'Очистить историю',
    notFoundRelatedResults: 'Не найдено связанных результатов',
    switch: 'Переключить',
    searchProductionLine: 'Производственная линия',
    selectProductionLine: 'Выбрать производственную линию',
    rotateAngleTip: 'Повернуть {angle}',
    plankText: 'Доска',
    sendToEzSort: 'Отправить в EzSort',
    downloadEzSort: 'Скачать EzSort',
    notDownloadTip: 'Если EzSort не может открыться нормально, возможно, вы не скачали его. Пожалуйста, нажмите кнопку ниже, чтобы скачать EzSort',
    updateTip: 'Обнаружено обновление программного обеспечения. Пожалуйста, перезапустите Guigui!',
    betaTest: 'Бесплатно во время бета-тестирования',
    ersortSpecail: 'Эксклюзивно для цветных меток',
    exclusiveFeature: 'Эксклюзивная функция',
    elementCanBeDragTip: 'Элемент можно перетаскивать',
    checkPlankIsConflict: 'Проверка состояния доски',
    preferenceSaveErr: 'Ошибка сохранения настроек',
    guimen: 'Дверь шкафа',
    preferenceLoadTip: 'Загрузка ваших настроек',
    preferenceLoadErrTip: 'Не удалось загрузить настройки. Пожалуйста, обновите страницу и попробуйте снова, чтобы избежать ошибок в настройках!',
    localFileIsBeingWrite: 'Локальный файл записывается',
    unnamedFile: 'Безымянный файл',
    taskMonitor: 'Мониторинг задач',
    downloadByType: 'Скачать {type}',
    slotKnifeErr: 'Отсутствует инструмент для обработки конкретного паза. Пожалуйста, проверьте настройки производственной линии! 【{msg}】',
    anewChooseCatalog: 'Выбрать каталог',
    downloadSetting: 'Скачать настройки',
    attention: 'Внимание',
    unit: 'Штук',
    defaultUse: 'По умолчанию использовать',
    defaultChooseUse: 'По умолчанию выбрать',
    requestFail: 'Запрос не выполнен',
    downloadDoneByType: '{type} загружен',
    sysTip: 'Системное уведомление',
    pleaseChoose: 'Пожалуйста, выберите',
    confirmDelete: 'Подтвердить удаление',
    notDataTipByType: 'Нет данных, пожалуйста, {msg} сначала',
    paginationTotalTip: 'Элементы {current}-{page} из {total} всего',
    chooseAmountData: 'Выбрано {number} элементов данных',
    moreOperate: 'Больше',
    transferByType: 'Передать {type}',
    clickCopy: 'Нажмите, чтобы скопировать {type}',
    currentLine: 'Текущая строка',
    remark: 'Примечание',
    customFunction: 'Настраиваемая функция',
    limitedTimeTrial: 'Limited Free',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    startTime: 'Время начала',
    endTime: 'Время окончания',
    lastMonth: 'Последний месяц',
    lastSixMonth: 'Последние полгода',
    lastYear: 'Последний год',
    searchByType: 'Пожалуйста, введите {type} для поиска',
    addTime: 'Время добавления',
    startArrange: 'Начать верстку',
    select: 'Выбрать',
    search: 'Поиск',
    name: 'Название',
    plankNo: 'Номер доски',
    plankName: 'Название доски',
    orderNo: 'Номер заказа',
    order: 'Заказ',
    partNameWithoutRoomCabinet: 'Название доски (без комнаты/корпуса)',
    plankRemark: 'Примечание доски',
    room: 'Комната',
    orderAddress: 'Адрес проекта',
    matCode: 'Материал',
    matCode2: 'Материал',
    plankMatCode: 'Материал доски',
    count: 'Количество',
    customer: 'Клиент',
    customerInfo: 'Информация о клиенте',
    factoryOrderNo: 'Номер заказа фабрики',
    roomName: 'Комната',
    color: 'Цвет',
    plankColor: 'Цвет доски',
    plankThick: 'Толщина доски',
    plankHighGloss: 'Свойства подсветки',
    thick: 'Толщина',
    front: 'Передняя сторона',
    back: 'Задняя сторона',
    slot: 'Канал',
    hole: 'Отверстие',
    hsInfo: '{hole} отверстие {slot} канал',
    diameter: 'Диаметр',
    finishedWidth: 'Готовая ширина',
    finishedHeight: 'Готовая длина',
    finishedArea: 'Площадь готового изделия (㎡)',
    remarks: 'Примечание',
    remark1: 'Примечание 1',
    remark2: 'Примечание 2',
    remark3: 'Примечание 3',
    remark4: 'Примечание 4',
    remark5: 'Примечание 5',
    remark6: 'Примечание 6',
    remark7: 'Примечание 7',
    remark8: 'Примечание 8',
    remark9: 'Примечание 9',
    remark10: 'Примечание 10',
    remark11: 'Примечание 11',
    remark12: 'Примечание 12',
    remark13: 'Примечание 13',
    remark14: 'Примечание 14',
    remark15: 'Примечание 15',
    remark16: 'Примечание 16',
    texture: 'Текстура',
    normal: 'Вертикальная текстура',
    reverse: 'Горизонтальная текстура',
    notCare: 'Без текстуры',
    holeSlotsStastic: 'Количество отверстий и каналов',
    edge: {
      title: 'Край',
      info: 'Информация о крае',
      front: 'Передний край',
      back: 'Задний край',
      left: 'Левый край',
      right: 'Правый край',
      up: 'Верхний край',
      down: 'Нижний край'
      },
    isSpecial: 'Нестандартный',
    notSpecial: 'Нестандартный',
    textOfDoorPlank: 'Дверная доска',
    textOfNotDoorPlank: 'Не дверная доска',
    isDoorPlank: 'Дверная доска',
    notDoorPlank: 'Не дверная доска',
    width: 'Ширина',
    long: 'Длина',
    plankWidth: 'Ширина доски',
    plankHeight: 'Длина доски',
    shortLong: 'Длина короткой стороны',
    shortWidth: 'Ширина короткой стороны',
    plankShape: 'Форма доски',
    detail: 'Подробнее',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    alreadyKnow: 'Я уже знаю',
    Noprompts: 'Больше не напоминать',
    deep: 'Глубина',
    other: 'Другое',
    heighGloss: 'Высокий блеск',
    heighGlossPlank: 'Высокий блеск доски',
    heighGlossSide: 'Высокий блеск сторона',
    notHeighGloss: 'Не высокий блеск',
    notHeighGlossPlank: 'Не высокий блеск доски',
    saveSuccess: 'Сохранено успешно',
    deleteSuccess: 'Удалено успешно',
    addSuccess: 'Добавлено успешно',
    editSuccess: 'Изменено успешно',
    engraving: 'Фрезерный станок',
    electronicSaw: 'Электропила',
    glassEquip: 'Машина для резки стекла',
    labelingMachine: 'Машина для наклейки этикеток',
    copy: 'Копировать',
    paste: 'Вставить',
    undo: 'Отменить',
    move: 'Переместить',
    PTP: 'PTP',
    dock56FDrill: 'Машина для сверления пяти-шести сторон',
    sideHoleDrill: 'Машина для сверления боковых отверстий',
    combination: 'Машина для комбинирования',
    integration: 'Машина для интеграции',
    standardPlank: 'Стандартная большая доска',
    standardMaterial: 'Стандартный материал',
    standardMaterialTip: 'Примечание: После завершения корректировки информации о большой доске пользователи, использующие производство раскроя шкафов, должны перезапустить клиент шкафа для применения последних изменений!',
    specialMaterial: 'Специальный материал',
    specialPlank: 'Специальная большая доска',
    singlePlank: 'Однопанельный',
    previous: 'предыдущий',
    plankInfo: 'Большая доска Подробнее',
    moreResult: 'Больше программ',
    moreResultTip: 'Большая доска с наклейкой в канавке, большая доска не будет участвовать в переформатировании',
    ok: 'определить',
    dispersePaibanTip: 'Обнаружив, что некоторые большие платы не могут быть децентрализованы, вы можете настроить или переключить схему набора вручную, чтобы избежать создания беговой платы!',
    next: 'следующий',
    rate: 'Коэффициент использования',
    paibanBatch: 'Типографская партия',
    return: 'возвращаться',
    FGNo: 'Номер контракта',
    refresh: 'обновить',
    inde: 'номер',
    productionLine: 'Производственная линия',
    operation: 'операция',
    colorPlaceHolder: 'Нажмите обратно, чтобы автоматически создать цветовую карту',
    saveAndContinue: 'Сохранить и продолжить',
    reset: 'Сброс',
    check: 'запрос',
    inputPlaceholder: 'Пожалуйста, введите',
    filter: 'отбор',
    all: 'все',
    exportPDF: 'Экспорт PDF',
    exportPic: 'Экспорт изображений',
    add: 'добавить',
    edit: 'редактировать',
    delete: 'удалить',
    restore: 'восстановление',
    save: 'сохранить',
    saveSetting: 'сохранить настройки',
    isHeightGloss: 'Выберите высотный',
    noSync: 'Несинхронизация',
    sync: 'синхронизация',
    formatSuccess: '{type} успешно',
    dataLoading: 'Данные загружаются. ......',
    warmTip: 'Доброе напоминание',
    importantTip: 'Важные советы',
    wellcome: 'Добро пожаловать в облако',
    timeOut: 'Время ожидания типографии, переформатирование',
    notSawKnifeTip: 'Примечание: Пиловая гравировальная машина не устанавливает « поперечную пилу», что приводит к невозможности типографии, пожалуйста, перейдите к добавлению!',
    doorFrameKnifeRadiusErr: 'Вы включили функцию «Пиловая гравировальная машина — резка дверных наличников». Радиус режущего инструмента больше толщины пилы, компоновка невозможна!',
    doorFrameIrregularPlankErr: 'Вы включили функцию «Пиловая гравировальная машина — резка дверных наличников». Эта функция пока не поддерживает компоновку нестандартных панелей!',
    warning: 'Предупреждение',
    export: 'экспорт',
    mark: 'метка',
    noMark: 'Не маркировать',
    sawArrange: 'Пильный набор',
    directArrange: 'Прямая типография',
    area: 'площадь',
    plankNum: 'Штрих - код',
    loc: 'корпус',
    cutHeight: 'Длина раскроя',
    cutWidth: 'Ширина разреза',
    defaultProduction: 'Производственная линия по умолчанию',
    surplusNum: 'Остаточный штрих - код',
    tip: 'подсказка',
    history: 'история',
    hinge: 'Шарнирное отверстие',
    hingeScrew: 'Отверстие на шарнирную дверь',
    CCPXHole: 'Экстрацентрическое отверстие',
    stretchHinge: 'Ручка выпрямителя и отверстие шарнирного стакана',
    stretch: 'Прямое устройство',
    stretcher: 'желоб выпрямителя',
    eccHole: 'эксцентричное отверстие',
    preHole: 'Предварительное погребение отверстия',
    clothole: 'Одежда.',
    backPlank: 'Паз задней панели',
    ALS: 'Тёмная ручка',
    doorSlot: 'Металлический лоток для дверей',
    drawerSlot: 'Металлический лоток ящика',
    lkSlot: 'Лазурный жёлоб',
    KC: 'Дыра в брюках.',
    stealth: 'Невидимый элемент',
    lightSlot: 'Лампа',
    ConventionalHole: 'Обычное отверстие',
    Keyhole: 'Замочное отверстие',
    allHole: 'Все отверстия на панели',
    allSlot: 'Все пазы на фасонной панели',
    freedomAllHoleSlot: 'Все отверстия и пазы на фасонной панели',
    freedomAllHoleSlotTip: 'Фасонная панель: панель с углом, не являющимся прямым',
    millInfo: 'Ручная рука',
    haiTang: 'Бегония (мыс)',
    FSDrill: 'Пять / шесть буров',
    engraving2: 'Раскрыватель',
    xyReverse: 'Обмен осями XY',
    autoXYReverse: 'Автоматическая адаптация оборудования для обработки отверстий',
    autoXYReverseTip: 'После включения данные обработки пяти/шестиугольных сверлильных станков и сверлильных станков автоматически адаптируются к обмену осями XY сверлильного станка',
    autoXYReverseTip2: 'Примечание: PTP не поддерживаются',
    xyReverseTip: 'Функция обмена осями XY пока не совместима с L - образным разрывом, правильно размещайте, будьте осторожны',
    rect: 'прямоугольник',
    Ltype: 'L - образный',
    archive: 'Archive',
    tellPlaceholder: 'Пожалуйста, введите номер телефона.',
    knivesStore: 'магазин инструментов',
    roll: 'опрокидывание листов',
    pause: 'Пауза',
    editTrans: 'Редактировать перевод',
    translateManager: 'Управление переводом',
    grating: 'Решётка',
    addressEditErr: 'Несколько заказов не поддерживают изменение адреса проекта',
    customerEditErr: 'Многочисленные заказы не поддерживают изменение данных клиентов',
    factoryEditErr: 'Несколько заказов не поддерживают изменение заводского номера',
    roomNameEditErr: 'Несколько заказов не поддерживают изменение названия комнаты',
    remarkEditErr: 'Множественные заказы временно не поддерживаются для изменения комментариев к заказам',
    toMaterialList: 'Перейти к списку',
    deleteFail: 'Ошибка удаления, повторите попытку позже!',
    batchRestore: 'Пакетное восстановление',
    batchDelete: 'Удаление пакетов',
    workShop: 'Ремонтное производство',
    FGAdrress: 'Адрес проекта / номер контракта',
    cuttingSize: 'Размер резания',
    finishedSize: 'Размер готовой продукции',
    labelImg: 'Изображение с наклейкой',
    layoutImg: 'Типограмма',
    file: 'документ',
    folder: 'папка',
    reName: 'Переименовать',
    to: 'до',
    plankUnit: 'Чжан',
    tagTemp: 'Шаблоны: Метки',
    roomRemark: 'Комната примечания',
    noModificationPermission: 'Нет прав на изменение',
    modificationRecord: 'Изменить запись',
    page: 'страница',
    strip: 'Статья',
    jump: 'прыгать',
    freeAgreement: 'Соглашение об освобождении программного обеспечения от ответственности',
    preStep: 'Предыдущий шаг',
    nextStep: 'следующий шаг',
    upload: 'загрузить',
    uploading: 'Загрузка',
    iAgree: 'Согласен.',
    pleaseSelectPlank: 'Пожалуйста, выберите хотя бы одну доску.',
    saveToStoreTip: 'Пожалуйста, выберите хотя бы одну не обрезанную доску.',
    fileIsNotExist: 'Файл не существует',
    selectAll: 'Полная выборка',
    pdfTag: 'Метки PDF',
    tagImage: 'Фотографии с метками',
    guigui: 'Guigui',
    gratingSlot: 'паз решетки',
    deleteTip: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    deleteError: 'Произошла неизвестная ошибка, ошибка удаления',
    cancelDelete: 'Отменено Удалено',
    confirmDeleteTip: 'Удаление задней панели войдет в нижний правый угол страницы в « Библиотека листов, подлежащих набору - не в библиотеку», подтвердит ли удаление данных?',
    confirmDeleteBujianTip: 'После удаления деталь будет помещена в правый нижний угол страницы в "Библиотеку деталей", подтвердить удаление данных?',
    confirmSureDeleteTip: 'Обнаружено, что в текущей библиотеке, готовой к форматированию, есть небольшая доска из того же материала, после удаления будет отображаться соответствующая доска в библиотеке, пожалуйста, убедитесь, что вы продолжаете удалять большую доску?',
    deleteEmptyTip: 'Удалить эту доску',
    notCanDelete: 'Отрезанные остатки не поддерживаются',
    new: 'New',
    innerBluneFailure: 'Встроенное облако не работает.',
    deleteBigPlankTip: 'На последней большой доске есть небольшая доска, которую нельзя удалить!',
    continueExport: 'Игнорировать, продолжить вывод файла',
    toCheck: 'Проверьте.',
    pleaseCheck: 'Текущий результат типографии имеет конфликт отверстий / вылет из маленькой доски / аномалию глубины, пожалуйста, проверьте!',
    clampHandCheck: 'Обнаружено, что отверстие в части вашей панели не может избежать положения зажима, пожалуйста, отрегулируйте вручную',
    conflictPartDetail: 'Подробности конфликта',
    colorNotUndefined: 'Цвет не может быть пустым',
    materialNotUndefined: 'Материал не может быть пустым.',
    newSetting: 'Новые функции',
    downImageErrTip: 'Не удалось экспортировать изображение, так как изображение с наклейкой было разделено на разные папки в соответствии',
    downNcErrTip: 'Не удалось загрузить NC, так как изображение с наклейкой было разделено на разные папки в соответствии',
    downNcErrTipForSurFolder: 'Ошибка загрузки NC, изображение с наклейкой разделено на различные папки в соответствии с большой доской, а настройки файла большой доски не могут быть открыты одновременно',
    yes: 'да',
    no: 'Нет',
    checkColorPrint: 'В настоящее время включена цветная метка, пожалуйста, используйте цветной принтер для печати.',
    colorRules: 'После открытия сгенерированной цветной вкладки заказ / комната / шкаф / дверная панель будут различаться по цвету, в настоящее время цветная вкладка поддерживает один и тот же тип данных до 12, конкретные правила заключаются в следующем:',
    greyPart: 'Серая часть правой метки:',
    region: 'регион',
    notSame: 'Цвет {regionName} отличается',
    doorTip: 'Серый для дверных панелей, белый для дверных панелей',
    exist: 'Наличие',
    limitNotEffect: 'Более 12 данных, цветные метки не действуют',
    hoverTip: 'Изображения, которые в настоящее время являются суффиксами bmp, кодируются в черно - белом формате и не могут экспортировать изображения с цветными метками',
    lock: 'блокировка',
    unlock: 'разблокировать',
    batchLock: 'Блокировка / разблокировка пакетов',
    surplusLock: 'Блокировка излишков',
    surplusUnlock: 'Разблокировка излишков',
    is: 'да',
    not: 'Нет',
    savingHistory: 'Сохраняются исторические документы',
    saveHistorySuccess: 'Сохранить исторический файл успешно',
    saveHistoryFail: 'Ошибка сохранения исторического файла',
    bw: 'Экспорт черно - белых меток',
    modular: 'Блочный шкаф',
    autoAdjust: 'Автонастройка',
    cutOrderTip: 'Обнаружена ошибка в порядке резки {errorCutOrdersString} листов! Пожалуйста, внесите корректировки перед загрузкой файла NC',
    lockedCutOrderTip: '【{errorCutOrdersString} лист】 заблокирован, пожалуйста, перейдите вручную для его изменения',
    paibanImgCutOrderTip1: 'Обнаружен ваш',
    paibanImgCutOrderTip: 'Ошибка в порядке резки! Перейдите на страницу набора, прежде чем экспортировать файл набора',
    goAdjust: 'Перейти к настройке',
    autoAdjustWarning: 'Текущий набор не поддерживает автоматическую настройку',
    checkNetwork: 'Проверьте сеть.',
    moreInfo: 'Узнать больше',
    continueLayout: 'Продолжить набор',
    adjustPosition: 'Настройка',
    specialAndFiveSix: 'При фасонном оформлении листов для обработки пятигранного бурения открытие фасонной вставки может привести к резанию листов, пожалуйста, убедитесь, что типография продолжается?',
    plankPathErr: 'Ошибка данных неправильной формы внутри плиты, пожалуйста, проверьте, соответствует ли она спецификации инструмента! 【{plankIDList}】',
    edgeCheck: 'Система обнаружила наличие больших панелей, которые были изменены, пожалуйста, переформатируйте, чтобы обеспечить точное производство',
    iKnow: 'Я понял.',
    versionErrTip: 'Пожалуйста, обновите шкаф до последней версии!',
    annualFeeExpired: 'Ваш годовой сбор истек, пожалуйста, сделайте продление!',
    holeEquipment: 'Сверлильное оборудование {num}',
    customizedService: 'Поддержка индивидуального обслуживания, создание вашего эксклюзивного производственного решения',
    exampleCombination1: 'Скульптор + пятигранное / шестигранное сверло + боковое отверстие',
    exampleCombination2: 'Электронная пила + пятигранное / шестигранное сверло + боковое отверстие',
    exampleCombination3: 'Полностью автоматизированная производственная линия + пятигранная / шестигранная буровая комбинация',
    feedback: 'Вы можете напрямую сообщить о своих потребностях продавцу программного обеспечения или послепродажному персоналу.',
    markModifiedBoards: 'Измененная табличка',
    showMoveStep: 'Настраивать шаг движения клавиатуры',
    moveStep: 'Шаг движения клавиатуры',
    existChangeBoards: 'Существуют видоизмененные панели',
    crossMaterialBoard: 'Панель другого материала/цвета',
    skipCrossMaterialTip: 'Не показывать снова для этой раскладки',
    crossMaterialConfirmTip: 'Вы перемещаете малую панель через разные материалы или цвета. {highlight} Продолжить?',
    crossMaterialConfirmTipHighlight: 'Произведенная панель может не совпадать с материалом/цветом разделенного заказа',
    exportHoleSlotPDF: 'Рисунок выходного отверстия',
    pdfFormat: 'Формат PDF',
    dxfFormat: 'Формат DXF',
    specialShapeKnivesInfo: 'Экзотический выбор ножей',
    specialShapeKnivesInfoTips: 'Панель {stockNum}:',
    specialShapeKnivesInfoTips2: 'Включите инструмент автоматического выбора фасона, данные набора ненормальные, пожалуйста, переформатируйте из открытого списка или отключите функцию автоматического выбора фасона',
    default: 'по умолчанию',
    exportLanguage: 'Язык экспорта',
    exportLanguageTip: 'Примечание: часть текстовой информации экспортируется в pdf не может быть переведена',
    highGlossNameTip: 'Высокие световые панели, синхронизированные из шкафа, могут быть описаны как другие копии, не влияющие на их свойства высокого света',
    mixPaibanPlanSetting: 'Параметры смешанной схемы',
    mixPaibanPlanSettingTip: 'Системное обнаружение изменений в настройках схемы смешивания, пожалуйста, выберите эту схему смешивания!',
    mixPaibanPlanSettingOk: 'Установить схему смешивания',
    mixPaibanPlanSettingCancel: 'Нет, прямая типография',
    noMixPaibanPlan: 'Отсутствует схема смешивания',
    mixColors: 'Смешанные цвета',
    mixPai: 'Смешанный ряд',
    plan: 'решение',
    mixPaibanTitle: 'Разные цветные доски вместе.',
    mixColorsTip: 'Можно определить, какие цвета могут быть изготовлены на одной большой доске в качестве одного и того же цвета без изменения первоначальной информации о цвете панели.',
    mixColorsTip2: 'После добавления схемы необходимо включить в список открытых материалов, прежде чем она вступит в силу.',
    mixColorsTip3: 'Функция гетерохроматического уплотнения не работает одновременно.',
    mixErrTip: 'Программа смешивания отсутствовала, проверьте',
    addPlan: 'Добавить программу',
    chooseMatcode: 'Выберите материал',
    chooseColor: 'Выбор цвета',
    defineColor: 'Выберите цвет',
    confirmDeletePlan: 'Удалить программу?',
    trimmingMethod: 'Порядок обрезки',
    followStandardTrim: 'Следуйте за значением обрезки стандартной пластины в оригинале',
    trimToast: 'Примечание: Вы используете функцию настройки обрезки излишков, только при выборе пилы',
    individualTrimValue: 'Установить значение кромки отдельно',
    topTrimEmptyToast: 'Верхний ремонт не может быть пустым!',
    bottomTrimEmptyToast: 'Нижний ремонт не может быть пустым!',
    leftTrimEmptyToast: 'Левая сторона не может быть пустой!',
    rightTrimEmptyToast: 'Правая сторона не может быть пустой!',
    topTrimBlurToast: 'Введите значение кромки',
    bottomTrimBlurToast: 'Введите значение кромки',
    leftTrimBlurToast: 'Введите значение левого края',
    rightTrimBlurToast: 'Введите значение правого края',
    effectToast: 'Пользовательские функции обрезки вступают в силу только для сварных пластин',
    defaultTrimSetting: 'Параметры обрезки по умолчанию',
    enterHere: 'введите здесь',
    permissionTipExportDxf: 'Экспорт схемы отверстий и пазов DXF',
    permissionTipSurplusRecycleBin: 'Станция переработки остатков',
    permissionTipAdvancedNesting: 'Продвинутое вложение неправильных форм',
    permissionTipPanelGrainAlign: 'Выравнивание волокон панели',
    permissionSeparator: ', ',
    missingPermissionTip: 'Отсутствуют следующие разрешения: {permissions}'
    },
  home: {
    head: {
      production: 'Описание продукта',
      resolve: 'решение',
      about: 'О нас',
      equipment: 'Машины и оборудование',
      tell: 'Жалобы по телефону',
      enter: 'Введите облачную версию'
      },
    swiper: {
      case1: {
        tag: 'Новое обновление',
        subTitle: 'Умный мозг машины.',
        description: 'Программное обеспечение для оптимизации облачной онлайн - типографии в реформированной отрасли'
        },
      case2: {
        title: 'Производство шкафов',
        subTitle: 'Технические новшества',
        description: 'Поддержка различных маркировочных машин, распылителей, боковых отверстий, пятистороннего PTP, стыковки пятистороннего / шестистороннего бурения'
        },
      case3: {
        title: 'Промышленный мозг',
        subTitle: 'решение',
        description: 'Интеллектуальные алгоритмы получают более высокий коэффициент использования листов'
        }
      },
    statistics: {
      today: 'Сегодняшняя смена.',
      toMounth: 'Ежемесячный тираж',
      outturn: 'Коэффициент выхода',
      cumulative: 'Совокупные пользователи'
      },
    intro: {
      title: 'Корпоративное облачное программное обеспечение для форматирования больших данных',
      subTitle: 'Понимание ситуации в отрасли, сосредоточение внимания на потребностях клиентов, расширение возможностей предприятий для цифровой трансформации и модернизации, содействие преобразованию индустрии автоматизации производства мебели в Интернете для существующих сценариев производства мебели из листовых панелей, внедрение алгоритмов помощи ИИ, непрерывное внесение вклада в предприятия для достижения нового роста',
      menue: {
        case1: {
          title: 'Онлайновая типография',
          subTitle: 'Их можно печатать в любое время.',
          description: 'Нет необходимости загружать программное обеспечение, вы можете редактировать его в любое время, удаленное управление не должно зависеть от компьютера'
          },
        case2: {
          title: 'Многолинейное производство',
          subTitle: 'Быстрое переключение производственных линий',
          description: 'Поддержка быстрой одновременной обработки нескольких производственных линий, быстрое переключение между производственными линиями'
          },
        case3: {
          title: 'Тщательное производство',
          subTitle: 'Тщательная типография, тонкие параметры',
          description: 'Тщательная типография, тонкая настройка параметров, чтобы сделать производство листов более точным'
          },
        case4: {
          title: 'Пользовательское производство',
          subTitle: 'Настройка этикетки, пятигранное сверло, форма остатка',
          description: 'Настройка этикетки, Настройка пятигранного бурения, Настройка формы остатка, Комбинированная обработка оборудования'
          }
        }
      },
    fangan: {
      title: 'Профессиональные отраслевые решения',
      subTitle: 'Низкая стоимость, высокая производительность, интеллектуальные алгоритмы для улучшения использования панелей, совместимые с различными программными средствами проектирования, для пользователей, чтобы обеспечить оптимальное производство',
      menue: {
        case1: {
          title: 'Интеграция линейного производства',
          description: 'Удаленная онлайновая работа, преодоление пространственных препятствий, выход заказов в любое время синхронизация завода, проектирование и производство синхронизация завершения'
          },
        case2: {
          title: 'Переключить производственную линию',
          description: 'Настройка производственных линий, поддержка многопроизводственных линий, стыковка многотипного оборудования'
          },
        case3: {
          title: 'Интеллектуальные алгоритмы улучшают использование листов',
          description: 'Низкое использование традиционных алгоритмических панелей, тонкие параметры интеллектуальных алгоритмов, индивидуальные производственные схемы'
          },
        case4: {
          title: 'Программа профессиональной резки',
          description: 'Оптимизируйте порядок резки, точку падения, так что путь короче и резка более стабильна'
          }
        }
      },
    aboutUs: {
      title1: 'Технология « Нью - Гэл»',
      subTitle: 'Менеджеры мебельной индустрии',
      description: 'Компания New Geel Enterprise, специализирующаяся на интернет - изменениях в традиционном производстве мебели',
      culture: {
        case1: {
          title: 'Цель предприятия',
          subTitle: 'Помочь заводу, утроить рост'
          },
        case2: {
          title: 'Культурные ценности',
          subTitle: 'Клиенты как центр, борцы как центр, упорная борьба на благо людей'
          },
        case3: {
          title: 'Руководящая идеология',
          subTitle: 'Массовые маршруты, создание элитной команды с способностью продавать, производительностью, организационной силой'
          }
        },
      feature: {
        case1: 'Техническое обслуживание профессиональных групп',
        case2: 'Постоянно обновлять итерацию',
        case3: 'Одноразовое послепродажное обслуживание',
        case4: 'Услуги по настройке функций'
        }
      },
    cooperation: {
      title: 'Честное сотрудничество ради будущего.',
      subTitle: 'Бренд стыковочного оборудования покрывает 90% отечественного коммунистического оборудования, 107 554 продавца идут с нами'
      },
    footer: {
      contact: {
        title: 'Свяжитесь с нами',
        adrres: 'Адрес: район Биньху, город Уси, провинция Цзянсу',
        subAdrres: 'K - Park Service Center, дом 1, 16.',
        tell: 'телефон'
        },
      business: {
        title: 'Основные операции & lt; & lt; Нойгель & gt; & gt;',
        department1: 'Отдел оконного программного обеспечения',
        department2: 'Министерство мебельного программного обеспечения',
        department3: 'Министерство сборочного строительства',
        department4: 'Официальный сайт штаб - квартиры'
        },
      brand: {
        title: 'Марки компании New Girl',
        brand1: 'Золотой костюм бога',
        brand2: 'Сеть дверей',
        brand3: 'Инвестиции ↑',
        brand4: 'Три технологии.',
        brand5: 'Шанхайская технология'
        },
      organization: {
        title: 'Глобальное отделение & lt; & lt; Нойгель & gt; & gt;',
        organization1: 'Бюро Сингер - Южный Китай (филиал Фошань)',
        organization2: 'Сингер - Северное бюро (Линьийский филиал)',
        organization3: 'Сингер - Юго - Западное бюро (Чэндуский филиал)',
        organization4: 'Нойгель - Западный сервисный центр',
        organization5: 'Нойгель - Восточный сервисный центр',
        organization6: 'Новогерско - агентский кластер',
        organization7: 'Нью - Гэлл - Департамент международных рынков'
        },
      follow: {
        title: 'подметать "Шкаф внимания"'
        },
      friendLink: {
        link1: 'Новое программное обеспечение Гейла',
        link2: 'Программное обеспечение K - шоу',
        link3: 'Сеть дверей',
        link4: 'Программное обеспечение полностью алюминиевого шкафа',
        link5: 'Скачать программное обеспечение ZOL',
        link6: 'Китайский парк программного обеспечения',
        link7: 'Загрузить дом',
        link8: 'Скачать программное обеспечение ZOL',
        link9: 'Сеть & lt; & lt; Зеленые ресурсы & gt; & gt;',
        link10: 'Шкаф присоединяется',
        link11: 'Домой Присоединение',
        link12: 'Красивые ванны присоединяются'
        }
      }
    },
  login: {
    title: 'Войти',
    tell: 'номер телефона',
    password: 'пароль',
    passwordPlaceholder: 'Введите пароль',
    forget: 'Забыли пароль',
    registerAccount: 'Регистрационный счет',
    backLog: 'Вернуться в Регистрация',
    verifyCode: 'капча',
    getVerifyCode: 'Получить код подтверждения',
    verifyCodeErr: 'Неверный код проверки',
    confimPassword: 'Подтверждение пароля',
    confimPasswordPlaceholder: 'Подтвердите пароль.',
    editPassword: 'изменить пароль',
    register: 'регистрация',
    reSend: 'После повторного приобретения',
    loginLoadText: 'В процессе входа, пожалуйста, подождите. Это...',
    loadingPageTextL: 'Войти успешно, загружается структура страницы. Это...',
    loginSuccess: 'Вход выполнен успешно',
    tellErr: 'Номера телефонов неправильные.',
    passwordErr: 'Введите пароль'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'Принять задание.',
      arrange: 'верстка',
      surplus: 'Оставшиеся материалы',
      setting: 'настройка',
      find: 'Обнаружено',
      upgrade: 'Немедленное повышение',
      editNickName: 'Изменить псевдоним',
      editPassword: 'изменить пароль',
      logout: 'Выйти из системы',
      notice: 'Объявление',
      enterOfficial: 'Перейти на официальный сайт',
      equipment: 'Машины и оборудование',
      help: 'помощь',
      importFunc: 'Посмотреть эксклюзивные функции',
      enterThinkerOfficial: 'Доступ к официальному сайту Новой Зеландии',
      history: 'Сохранить историю',
      plankManager: 'Управление оригиналами',
      tagManager: 'Управление метками',
      suplumentManager: 'Библиотека дополнений и форматов',
      fileManager: 'Управление документацией',
      productionLine: 'Стыковка оборудования',
      workeShop: 'Облачное производство',
      useLesson: 'Использование учебного пособия',
      videoLesson: 'видеоурок',
      prolineManager: 'Управление производственными линиями',
      materialManager: 'Управление панелями',
      productManual: 'Руководство по эксплуатации',
      medialRelated: 'Выпуск градиента'
      },
    sideBar: {
      title: 'Оптимизация производства',
      materialList: 'Открытый список',
      paibanTask: 'Задание набора',
      paibanResult: 'Типограмма',
      printTag: 'Печать тегов',
      history: 'Сохранить историю',
      limitDate: 'Limited Free',
      surplusManager: 'Управление излишками',
      translateManager: 'Управление переводом',
      moreSettings: 'Больше настроек',
      deepSeekTitle: 'Консультанты',
      paibanCommune: 'Группа обмена наборами'
      },
    allRead: 'Все прочитано',
    learnMore: 'Узнать подробности',
    noticeEmpty: 'Нет объявлений. И...',
    noticeErr: 'Ошибка получения подробных объявлений',
    feedBack: {
      tab1: 'Представление отзывов',
      tab2: 'Запись обратной связи',
      type: 'Тип замечания',
      typePlaceholder: 'Выберите функцию',
      description: 'описание',
      descriptionPlaceholder: 'hi - Пожалуйста, заполните подробное описание сценария использования не менее 15 слов, чтобы мы могли лучше помочь вам, спасибо за сотрудничество!',
      uploadPic: 'Добавить изображение можно до 6, размер одного изображения не превышает 10 м)',
      tell: 'Контактный телефон',
      submit: 'отправить',
      admin: 'Облачный редактор:',
      picTip: 'Фото: (Нажмите для расширения, чтобы увидеть детали изображения)',
      empty: 'Нет данных обратной связи',
      picErr: 'Размер изображения не превышает 10 м',
      contentErr: 'Количество слов должно быть от 15 до 300.',
      necessary: 'Эта опция должна быть заполнена'
      }
    },
  taskPage: {
    tab1: 'Производственные задачи',
    tab2: 'Очередь серийного производства',
    filter: {
      title: 'отбор',
      unArrange: 'Без типографии',
      arranged: 'Серия',
      allArranged: 'Все напечатано',
      preLayout: 'Предварительная типография'
      },
    search: {
      placeholder: 'Введите содержимое поиска',
      orderName: 'Название заказа',
      sender: 'Отправитель'
      },
    importTask: 'Импорт задач',
    refuseTask: 'Отказ от задания',
    refreshList: 'Обновить список',
    refuseRecord: 'Отказ в записи',
    taskCard: {
      sender: 'Импортированные накладные',
      delivery: 'срок поставки',
      delete: 'удалить',
      addToBatch: 'Добавить партию',
      save: 'архив',
      arrange: 'Прямая типография',
      deleteTitle: 'Удалить задачу',
      checkDetail: 'Нажмите для просмотра деталей',
      refuse: 'отказ',
      refuseTime: 'Время отказа',
      refuseReason: 'Причины отказа',
      refuseTask: 'Отказ от задания',
      refuseTaskPlaceholder: 'Пожалуйста, укажите причину отказа.',
      addErr: 'Добавить неудачу, попробуйте позже!'
      },
    batchNo: 'номер партии',
    batchArrange: 'Массовая типография',
    clearBatch: 'Очистить очередь',
    taskCount: 'Количество текущих задач:',
    checkAllTask: 'Посмотреть все листы',
    clearSuccess: 'Удалить',
    record: {
      batchNo: 'Партии',
      saveDate: 'сохранение времени',
      materialList: 'Список материалов',
      arrangedRecord: 'Типограмма',
      searchPlaceholder: 'Введите номер партии.',
      tipText: 'Удалить ли архив этой статьи?'
      },
    errTip: 'Необработанные данные миссии, пожалуйста, перейдите к списку задач для добавления!',
    emptyErr: 'Заказ миссии не имеет данных о доске, не может быть типографским производством!',
    operationSuccess: 'Операция успешна',
    operationFail: 'Операция не удалась, попробуйте позже!',
    saveSuccess: 'Архив успешно',
    plankMaxLimit: 'Количество листов превышает максимальный лимит',
    batchWorning: 'Пожалуйста, сделайте это партиями.',
    batchEmptyErr: 'Список заказов не имеет данных о досках, не может быть массового производства!',
    noRoomTip: 'Нет комнаты, не может быть массового производства!',
    refuseHistory: 'Отказ от истории'
    },
  materialPage: {
    specialProcess: 'Специальные технологии',
    distanceFromTop: 'На расстоянии',
    distanceFromRight: 'Расстояние вправо',
    hingeData: 'Данные петли',
    labelBackProcTip: 'Это обновление оптимизировало обратный способ маркировки большой доски, теперь в соответствии с информацией на этикетке непосредственно запечатать край, перфорировать канавку можно, надеюсь, вы знаете!',
    openDir: 'Направление открытия.',
    edgeEmptyTip: 'Ремонт не может быть пустым',
    edgeNumberLimit: 'Значение кромки можно вводить только в цифры.',
    chooseSurplusQuantity: 'Доступно {total} типов остаточных материалов, выбрано {quantity} типов',
    noCanSaveInfo: 'Нет информации, которую можно сохранить',
    chooseBujianStoreQuantity: 'Доступно {total} типов дополнений, {quantity} типов дополнений можно добавить, выбрано {chooseQuantity} типов',
    isConfirmPushToAwaitStore: 'Подтверждаете ли вы добавление выбранной панели в библиотеку, подлежащую набору?',
    enterAutoCreateMatCode: 'Нажмите обратно, чтобы создать материал автоматически.',
    chooseAwaitStoreQuantity: 'В библиотеке ожидания набора {total} малых панелей, {quantity} панелей можно включить в набор, выбрано {chooseQuantity} панелей',
    defaultFold: 'Убрать данные по умолчанию',
    startArrange: 'Начать типографию',
    importMaterial: 'Импорт списка открытых материалов',
    saveToHistory: 'Сохранить в историю',
    addPlank: 'Добавить панель',
    addBujian: 'Добавить дополнение',
    deletePlank: 'Удалить панель',
    batchEdit: 'Пакетное изменение',
    moreSetting: 'Больше настроек',
    plankSize: 'Размеры листов',
    plankSize2: 'Размер (длина * ширина * толщина)',
    searchPlaceholder: 'Имя панели поиска / номер панели',
    checkArranged: 'Просмотреть набор',
    checkErr: 'Не проведена типография, невозможно просмотреть!',
    downloadSheet: 'Загрузить таблицу образцов',
    downloadSheetShowScientific: 'Загрузить таблицу образцов (показать метод научного подсчета)',
    exportHoleSlotPDF: 'Диаграмма отверстий для экспортируемых элементов',
    style1: 'Стиль 1',
    style2: 'Стиль 2',
    style2PDF: 'Стиль 2 (PDF)',
    style2DXF: 'Стиль 2 (DXF)',
    style3: 'Стиль 3',
    importNoCover: 'Импорт листа не покрывается',
    openBujianPlankRecommend: 'Открываем дополнения, рекомендуем.',
    openAwaitStorePlankRecommend: 'Откройте библиотеку для просмотра.',
    openSurplusPlankRecommend: 'Открываем доску рекомендуем.',
    pushToAwaitStore: 'Хранить в библиотеке',
    setTableHead: 'Настройка заголовка списка открытых материалов',
    syncConfirm: 'Шкафы не совпадают с данными облачной типографии! Синхронизировать исходные данные для шкафа?',
    handleSync: 'Примечание: ручная синхронизация может быть выполнена в управлении оригиналом',
    noMoreTip: 'Больше никаких подсказок',
    checkMore: 'Посмотреть больше',
    noHistory: 'Без сохранения истории...',
    sameOrder: 'Есть заказы, которые экспортировали производственную документацию, обратите внимание на проблему дублирования производства!',
    markOrder: 'Отмечено ли производство на странице заказа?',
    editErrTip: 'Несколько заказов временно не поддерживают изменение информации',
    autoSaveSuccess: 'Автоматически сохранены в истории!',
    goAdd: 'Перейти к Добавить',
    noProductionLine: 'Эта запись о производственной линии была удалена, пожалуйста, перейдите к списку открытых материалов для переформатирования',
    fileErr: 'Ошибка анализа содержимого файла, пожалуйста, подтвердите содержимое файла!',
    noCheckData: 'Нет запросов на данные!',
    noArrangeTip: 'Невозможно увидеть программу набора напрямую, нажмите, чтобы начать набор!',
    tooOld: '5 - 6 Старение.',
    contactUs: 'Пожалуйста, свяжитесь с продавцом для повторной стыковки.',
    pathErr: 'Внутри панели обнаружены нестандартные данные (номер панели: {errorPathPlankID}). Пожалуйста, проверьте!',
    sizeErr: 'Внутри панели обнаружены нестандартные данные, пожалуйста, проверьте! Размер панели: {width}-{height}',
    noKnife: 'Не установите диаметр разрезного ножа, пожалуйста, идите в гравировальную машину, чтобы установить нож!',
    noKnifeDiameter: 'Диаметр ножа производственной линии ({name}) пуст, пожалуйста, добавьте соответствующий диаметр ножа',
    openDifferentMaterialCuttingKnives: 'Открываются ножи из разных материалов.',
    sendFactorySuccess: 'Отправить в мастерскую успешно',
    sendFactoryErr: 'Не удалось отправить цех, пожалуйста, свяжитесь с послепродажным персоналом, чтобы попросить помощи',
    createTaskCard: 'Создать соответствующую карту задач?',
    surplusStatistics: 'Всего имеющихся остатков',
    surplusStatistics2: 'Выбранные',
    suplementStatistic: 'Блоки, которые можно использовать вместе с дополнительными панелями, всего',
    expand: 'развернуть',
    packUp: 'свернуть',
    importErr: 'Пожалуйста, выберите правильный документ!',
    sendLoadingText: 'Обрабатывается и отправляется файл NC. ......',
    arrangeLoading: 'всего',
    arrangeLoading2: 'Панель находится в процессе оптимизации. ......',
    dealing: 'В процессе обработки. Это...',
    deleteConfirm: 'После удаления остаток будет перемещен в Корзину. Вы уверены, что хотите удалить этот остаток?',
    copyTip: 'Будет выполнена операция копирования выбранного остатка.',
    copyTip2: 'Подтвердите количество копий',
    surplusHead: {
      shape: 'форма',
      type: 'тип',
      remark: 'примечание',
      area: 'Площадь (м²)',
      area1: 'площадь'
      },
    surplusTip: 'Пока нет свободных остатков, вы можете пойти первым',
    creatSurplus: 'Новые излишки',
    orderInfo: 'Информация о заказе',
    suplement: {
      statistic: 'Всего {total} дополнений, из которых {useable} можно использовать в качестве дополнительных панелей, и {selected} выбраны',
      exportSuplement: 'Экспорт списка дополнений',
      suplementLoading: 'Данные дополнения загружаются',
      exportSuplementIng: 'Список дополнений экспортируется',
      noMatchSup: 'Не удалось согласовать данные с имеющимися дополнениями',
      exportTip: 'Выберите хотя бы одно дополнение для экспорта'
      },
    empty: 'Нет данных',
    paibanSetting: {
      title: 'Параметры набора',
      createTask: 'Создать задачу набора',
      selectProduction: 'Выбор производственных линий',
      arrangeWay: 'Выбор типографского варианта',
      suitText: 'подходит для：',
      surplusTrimTip: 'Примечание: Вы используете функцию настройки обрезки излишков, вы можете выбрать только пилу',
      suitEquipmentNormal: 'Обычная гравировальная машина',
      suitEquipmentSpecial: 'Стеклорежущий станок',
      lessRoll: 'Меньше копий',
      computedSpecial: 'Расчетный гетероморфизм',
      specialTip: 'Влияние на скорость набора',
      irregularNesting: 'Экзотическая вставка',
      primaryNesting: 'Обычная вставка',
      specialShapedPanel: 'фасонная вставка',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'Расширенная вставка',
      heteromorphicInlay: 'Асимметричная мозаика',
      autoCutSurplus: 'Автообрезка излишков',
      cutWay: 'Способ обрезки',
      maxRect: 'Вырезать максимальный прямоугольник',
      fixedRect: 'Вырезать в фиксированный размер',
      minRectSetting: 'Минимальный размер',
      firstCutL: 'Приоритетное формирование L - образного остатка',
      firstCutLTip: 'После открытия приоритет отдается выполнимой комбинации прямоугольных пластин в L - образный остаток.',
      shortLine: 'Короткая сторона больше',
      longLine: 'Длинная сторона больше',
      setDifferentThickness: 'Минимальный размер обрезки листов различной толщины',
      defaultRuleTip: 'Если толщина пластины не соответствует правилу попадания, вырезайте по умолчанию',
      panelThickness: 'Толщина плиты',
      duplicateMinCutSize: 'В настоящее время существует такой же минимальный размер разреза.',
      templateEmpty: '« Установите минимальный размер обрезки листов различной толщины» Данные шаблона не могут быть пустыми!',
      duplicateThicknessData: 'В данных шаблона « Установите минимальный размер обрезки листов различной толщины» есть повторяющиеся данные толщины!',
      atLeastOne: 'Сохранить хотя бы одну!',
      maxAddFive: 'Добавьте максимум пять!',
      surplusTemplate: 'Обычные шаблоны',
      add: 'добавить',
      templateErr: 'Выберите обычный размер для обрезки и выберите хотя бы один шаблон данных',
      cutLong: 'Длина обрезки',
      cutWidth: 'Ширина обрезки',
      baseInfo: 'Основная информация',
      continue: 'Подтвердить и продолжить',
      standardSelect: 'Выбор стандартной доски',
      customPlankOrder: 'Настройка порядка форматирования больших панелей',
      customPlankOrderDetail: 'Перечень неотредактированных досок',
      customPlankOrderTip: 'Встроенное облако не работает.',
      customPlankOrderBrandTip: 'В заказах, ожидающих раскладки, присутствуют плиты с фирменной цветовой картой, эта функция используется по умолчанию',
      surplusPlank: 'Список оставшихся листов',
      overSizePlank: 'Перечень надлинейных панелей',
      plankOrder: 'Порядок набора',
      plankType: 'Типы листов',
      plankSize: 'Размеры листов',
      plankEdgeOff: 'значение обрезки',
      amount: 'Количество раскроек',
      amountMax: 'Наибольшее количество загрузок.',
      numAndOverSizeTip: 'Есть небольшой размер, и большая доска не может быть напечатана.',
      numErrorTip: 'Недостаточно большой набор не доступен.',
      overSizeTip: 'Есть маленькие доски, которые не могут быть напечатаны.',
      restPartList: 'Перечень неотредактированных досок',
      layoutOrder: 'Порядок набора',
      arrangeAmount: 'Количество раскроек',
      specialShapeTip: 'Ассортимент не может быть запрещён.',
      surplusConflictTip: 'Разрежьте остаточный материал и контур пластины, пожалуйста, перекройте',
      stackingMethod: {
        title: 'Метод укладки',
        long: 'Укладка по длинной стороне',
        short: 'Укладка по короткой стороне'
        },
      seniorShapeTip: '【Расширенное вложение】Срок бесплатной пробы истек, вы можете предварительно просмотреть результаты раскладки расширенного вложения; если вам нужно экспортировать файл производства расширенного вложения, свяжитесь с отделом продаж для покупки~'
      },
    filter: {
      title: 'Скрининг панелей',
      search: 'поиск',
      all: 'Полная выборка',
      diskSize: 'Пространство, используемое для хранения истории макета, уже использовано',
      resetFilter: 'Отменить фильтрацию'
      },
    edit: {
      title: 'Пакетное изменение',
      target: 'Изменить объект',
      onlineSelectRow: 'Выбрать только среднюю',
      allRow: 'Все.',
      editKey: 'Необходимо изменить содержание',
      editValue: 'Изменить следующим образом:',
      warningTip: 'Примечание: после внесения изменений отверстия и фасоны будут автоматически очищены',
      allEdge: 'Все края'
      },
    add: {
      title: 'Добавить панель',
      continue: 'Подтвердить и продолжить',
      matCodeErr: 'Материал не может быть пустым.',
      thickErr: 'Толщина не должна быть пустой.',
      colorErr: 'Цвет не может быть пустым',
      longErr: 'Длина изделия не должна быть пустой.',
      widthErr: 'Ширина изделия не должна быть пустой.',
      countErr: 'Количество не менее 1'
      },
    delete: {
      tip: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
      errTip: 'Пожалуйста, выберите хотя бы одну панель для этой операции!',
      errTip1: 'Пожалуйста, выберите хотя бы одну панель для повторного оформления.',
      confirm: 'Подтвердите удаление'
      },
    restore: {
      confirm: 'Подтвердить восстановление'
      },
    restoreConfirm: 'После восстановления остаток будет возвращён в список остатков или на склад остатков. Вы уверены, что хотите восстановить этот остаток?',
    restoreBatchConfirm: 'Вы уверены, что хотите восстановить выбранные остатки?',
    save: {
      errTip: 'Нет информации, которую можно сохранить!',
      title: 'Сохранить программу',
      subTitle: '(Примечание: История хранится только один год)',
      name: 'Название программы',
      historyName: 'Историческая программа',
      successTip: 'Сохранить успешно!',
      fieldTip: 'Ошибка сохранения!'
      },
    exportErr: 'Нет панелей, невозможно экспортировать',
    exportPicErr: 'Неизвестная ошибка при экспорте рисунка отверстий панели, пожалуйста, свяжитесь с нами, чтобы исправить',
    plankNotFound: 'Соответствующая доска не найдена! Убедитесь, что вы рисуете панель!',
    noPlankName: 'Имя панели не найдено',
    plankDataErr: 'Ошибка данных на досках, проверьте внимательно, чтобы избежать производственных потерь',
    exportThreeViewErr: 'Невозможно экспортировать три вида отверстий, свяжитесь с послепродажной обработкой',
    heighGlossWarning: 'Примечание: когда материал является высокой световой пластиной, изменение задней панели материала не сможет восстановить высокую световую пластину!',
    reset: 'восстановить по умолчанию',
    settingHead: {
      title: 'Настройка заголовка списка открытых материалов',
      head: 'Часы',
      customHeadName: 'Пользовательское название заголовка',
      example: 'Пример',
      tip: 'Советы по действию: можно перетаскивать заголовок таблицы влево и вправо',
      headerNameEmpty: 'Заголовок не может быть пустым',
      duplicateHeader: 'Дублирующийся заголовок'
      },
    copyLine: 'Нажмите, чтобы скопировать текущую строку ниже.',
    copySuccess: 'Успешно скопированы данные {name}',
    arranging: 'Всего {count} досок размером менее 1220 мм находятся в процессе оптимизации раскроя...',
    overSize: {
      title: 'Метаметр для пластин',
      subTitle: 'Перечень надлинейных панелей',
      overSizeTip: 'Гиперлинейка панелей',
      nonWorkInfo: 'Невозможно обработать детали',
      mergeFrameDoorWholeTip: 'Примечание: этот компонент является целым для слияния дверных рам',
      conflictWorkInfo: 'Подробности конфликта',
      warning: 'Было обнаружено, что размер доски слишком длинный, что привело к невозможности типографии! Измените размер панели или добавьте оригинал соответствующего размера.',
      checkInfo: 'Посмотреть подробнее',
      tipContent: 'Система проверяет наличие надлинейных пластин в наборной доске, ниже приведены специальные рекомендации по добавлению пластины, вы можете вручную изменить длину и ширину пластины после нажатия кнопки < span class = "bold color - 0" под таблицей < span class = "bold color - 0" > "Добавление одним нажатием" < / span >, после быстрого добавления продолжить типографию, или вы можете сделать это в < span class = "bold color - 0" > Настройка оригинала - специальная пластина < / span >',
      add: 'Один нажатие',
      addPlank: 'Добавить оригинал',
      error: 'Гиперлинейка панелей, неудачная типография',
      successTip: 'Добавлен успешно! Переформатируется.',
      warningTip: 'Пожалуйста, заполните доску шириной!'
      },
    arrangeErr: 'Внутренние данные пластины ненормальны, невозможно выполнить типографское производство',
    nonDelete: 'Невозможно удалить',
    addOverSizeTip: 'Наличие суперфутов, пожалуйста, добавьте снова',
    addPlankSuccess: 'Добавить специальную доску успешно',
    addPlankFail: 'Ошибка добавления специальной большой платы',
    paibanFeedback: 'Отзывы о типографии',
    cuttingAndPaoban: 'режущий бегун',
    lowUtilizationRate: 'Низкий коэффициент использования',
    unreasonableLayout: 'Печать неразумна.',
    feedbackSuccessTip: 'Обратная связь удалась!',
    feedbackFailTip: 'Ошибка обратной связи!',
    mixedLayoutScheme: 'Нынешняя схема смешивания'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'Данные панели изменились, но не сохранен план, нажмите, чтобы определить план сохранения, а затем выполнить последующие действия',
    paibanRequestFailed: 'Запрос на раскладку не выполнен, повторите попытку',
    accordingPlankCountOrder: 'Сортировка по количеству больших панелей от высокого до низкого',
    editOrder: 'Изменить серийный номер',
    dragOrder: 'Сортировка перетаскиванием',
    inputOrder: 'Порядок ввода',
    editOrderTip: 'Последовательность',
    range: 'диапазон',
    unsupportRotateTip: 'Некоторые большие доски были повернуты, временно не поддерживается переформатирование, повернуты большие серийные номера:',
    slotErrTip: 'Текущая доска имеет паз для обработки с наклейкой, не поддерживает переформатирование!',
    lockedPaibanTip: 'Большая доска заблокирована и не может быть переформатирована',
    batchBujianErrTip: 'Текущая доска не существует в исходных данных листа, вы можете выбрать переформатирование в библиотеке дополнений / форматирования',
    useFolderIsNot: 'Обнаружено, что место сохранения файла "{type}" не существует! Пожалуйста, проверьте, не был ли файл удален. Если вы используете USB-накопитель, пожалуйста, проверьте, правильно ли он подключен',
    useFolderIsNot1: 'Если вы не установили местоположение загрузки файла, выберите каталог',
    downloadNC: 'Скачать NC',
    downloadNC1: 'Скачать NC файл',
    reArrange: 'Переформатирование',
    reArrangeSpecifiedMaterialGroup: 'Переформатировать указанные группы панелей',
    specifiedMaterialRelayoutMoreResultTip: 'После переформатирования указанных групп панелей дополнительные результаты раскладки предоставляться не будут',
    searchMaterialGroup: 'Поиск групп панелей',
    saveToHistory: 'Сохранить в историю',
    moreSetting: 'больше',
    cutIndexRe: 'Используйте клавишу ctrl+z для отмены предыдущего действия',
    followExportTag: 'Скачать файл метки NC',
    followExportPaibanImg: 'Скачать NC для экспорта файлов диаграмм',
    followExportWorkerShop: 'Скачать NC Экспорт заказа на поставку',
    tagTemplateSelect: 'Выбор шаблонов меток',
    showCuttingSequence: 'Показать порядок резки',
    showPlankSize: 'Показать размер панели',
    sendToFactory: {
      title: 'В мастерскую',
      fileType: 'Тип файла метки'
      },
    checkData: 'Проверяется целостность данных. Это...',
    dataLoading: 'Работает над загрузкой. ......',
    addToBujianStore: 'Добавляется склад запасных частей. Это...',
    updateTaskStatus: 'Обновляется статус миссии. Это...',
    sending: 'Отправляется в мастерскую.',
    waitLoadding: 'ожидание',
    loadding: 'в процессе',
    finish: 'завершить',
    loadSetting: 'Настройки загрузки',
    loadPreference: 'Загрузить настройки предпочтений',
    dealTemplate: 'Обработка шаблонов',
    initTagData: 'Инициализация данных метки',
    prepareDrawData: 'Подготовка данных для построения меток',
    drawDataText: 'Данные построения меток',
    genPdfTagFile: 'Создать файл метки PDF',
    genPicTagFile: 'Создать файл изображения метки',
    uploadFile: 'Загрузить файл',
    dealNCFile: 'Обработка NC - файлов',
    zipFile: 'Создать локальный сжатый файл',
    plankCount: 'Количество больших панелей',
    rollCount: 'Количество копий',
    totalRate: 'Общий коэффициент оптимизации',
    rate: 'Коэффициент оптимизации',
    useArea: 'Оптимизированная площадь',
    materialList: 'Список материалов',
    saveSurplus: 'Склад излишков',
    workeShop: 'Закупочные заказы',
    batchTagging: 'Товарные вкладки',
    batchTaggingTip: 'Внизу выберите лист, на котором необходимо заполнить этикетку.',
    holeSlotErr: 'Обнаружена аномальная глубина отверстия в пластине!',
    knivesErr: 'Мы не можем найти обработанный нож!',
    checkDetail: 'Подробнее',
    deepErr: {
      title: 'Аномальная глубина отверстия пластины',
      errStatistic: 'На {count} местах на поддоске обнаружены аномалии',
      errText: 'Необычная часть',
      markErrPart: 'Вставка аномалий'
      },
    warningTip: 'Двойная обработка высокооптических панелей: сначала обработать < span class = "font - style" > высокооптическую поверхность < / span >, затем обработать < span class = "font - style" > матовую поверхность < / span >; Односторонне обработанная высокооптическая пластина: прямая обработка < span class = "font - style" > матовая поверхность < / span >',
    showDetail: {
      tip1: 'Нажмите для выбора отдельных панелей',
      tip2: 'Посмотреть вкладку'
      },
    arrangeTip: '(Поддерживается фасонная вставка)',
    plankOpration: 'Операции с панелями',
    rotate: 'Повернуть на 90 градусов',
    notCare: 'Пластинка без текстуры',
    editRemark: 'Изменить примечание',
    clearRemark: 'Очистить примечание',
    recalcIndex: 'Перерасчет точки падения и последовательности резки',
    recalcIndexSuccess: 'Перерасчет точки падения и последовательности резания успешно',
    storageArea: {
      title: 'зона временного хранения листов',
      empty: 'Бесплатное временное хранение',
      storageTip: 'Можно перетащить листы сюда для временного хранения.'
      },
    subtleArrange: 'Тщательная типография',
    addPlank: 'Добавить большую доску',
    deletePlank: 'Удалить большую доску',
    deletePlankErr: 'В настоящее время большая доска существует, не может удалить большую доску!',
    useSurplus: {
      title: 'Использование остатков'
      },
    dragWarning: 'Пожалуйста, перетащите доску на большую доску!',
    areaWarning: 'Невозможно разместить панель, обратите внимание на размер свободного пространства',
    subtlePage: {
      cut: 'Резка остатков',
      lineTip: 'Если ручная резка неверна, вы можете использовать ctrl+z, чтобы вернуться к предыдущей точке резки',
      cancelCut: 'Завершение обрезки',
      cutPoint: 'конгруэнтная отсоса остаточной обрезки',
      storageArea: 'зона заготовки листов',
      cutErr: 'Разрезать можно только на большой доске, не прикасаясь к ней!',
      saveErr: 'Пожалуйста, выберите отрезанный остаток.',
      cutErr2: 'Разрезать можно только на большой доске, не выходя за ее пределы!',
      selectTip: 'Пожалуйста, выберите отрезанный лист.',
      noCutPath: 'Нельзя вырезать прямоугольник.',
      cutOperate: 'Операции по обрезке остатков',
      line: 'Ручное обрезание',
      cutErrtip: 'В точке резки есть перекрестные проблемы, пожалуйста, перекройте',
      cutErrtip2: 'Точки обрезки будут превышать лимит точки: 9, пожалуйста, перекройте'
      },
    shortCut: 'Комбинации клавиш',
    updownRoll: 'Сверху - вниз',
    leftRightRoll: 'Скользящее влево и вправо',
    zoomScale: 'Увеличить',
    dragCanvas: 'Перетащите страницу',
    mouseRoll: 'Колесо мыши',
    mouseRight: 'Правая кнопка мыши',
    mouseMultiSelect: 'Выбор нескольких панелей одновременно',
    mouseLeft: 'Левая кнопка мыши',
    doublePlank: 'Двойной щелчок по доске',
    keyboard: 'клавиатура',
    picSymble: 'Легенда',
    funished: 'готовое изделие',
    holeSlotConflict1: 'Конфликт с отверстиями',
    plankErr: 'Конфликт панелей',
    frontSlot: 'лобовая вытяжка',
    backSlot: 'Обратная вытяжка',
    frontHole: 'Позиция переднего отверстия',
    backHole: 'Отрицательное положение отверстия',
    resetScale: 'Сбросить масштаб',
    maxLong: 'самый длинный',
    tempErr: 'Ошибка добавления, неправильное расположение шаблона или слишком большой шаблон!',
    sendErr: 'Ошибка отправки в цехе, проверьте правильность шаблона метки и данных шаблона после отправки',
    someTips: 'Вы экспериментируете с облачным набором гетероморфных остатков / гетероморфных вложенных функций в течение ограниченного времени, обратите внимание, чтобы избежать производственных проблем!',
    nestingTips: 'Ограниченная по времени бесплатная пробная версия функции [Расширенная вложенная верстка нестандартных форм] истекла. Чтобы продолжить использование, обратитесь к отделу продаж для покупки!',
    frameDoorTip: 'Обнаружено, что в этом расположении есть склеенные рамковые двери, обратите внимание, что рамковые двери необходимо закрыть перед вторичной обработкой на станке для резки!',
    cutOrderErr: 'Порядок резки неправильный, нажмите, чтобы пересчитать точку падения и порядок резки!',
    holeSlotConflict: 'Обнаружен конфликт между отверстиями / вылет листов',
    exportSetting: 'Параметры экспорта',
    currentTagTemp: 'Шаблоны тегов',
    specialPaibanErr: 'Есть пластины со специальной технологией или наклейкой для обработки канавки, временно не поддерживается переформатирование!',
    moreResult: 'Больше результатов',
    moreResultTip: 'Большая доска с наклейкой в канавке, большая доска не будет участвовать в переформатировании',
    batchBujian: 'Пакетное дополнение',
    batchOperation: 'Массовые операции',
    batchEditPlankSize: 'Изменить размер большой доски',
    editPlankSize: 'Изменить размер',
    editWay: 'Изменения',
    editByType: 'Изменить по типу',
    editByPlankNumber: 'Изменить по номеру доски',
    editContent: 'Изменить содержание',
    editContentTip: 'Выберите тип панели, который необходимо изменить',
    editContentTip1: 'Выберите номер доски, который необходимо изменить.',
    editStart: 'начало',
    editEnd: 'Конец',
    bigPlank: 'Большая доска',
    editSize: 'Изменить размер',
    bigPlankWidth: 'Ширина панели',
    bigPlankHeight: 'Длина большой доски',
    bigPlankLengthMarking: 'Маркировка длины большой доски',
    markedAs: 'Идентифицировать как',
    maxAddTen: 'Добавить максимум 10',
    minValue: 'минимальное значение',
    differentKnifeErr: 'Большая доска с разными ножами для раскраски выбрана, размер не может быть изменен',
    noEditablePlank: 'Нет подходящих больших досок для изменения',
    skipBrandPlankTip: 'В выбранном диапазоне есть {count} брендовых больших досок, которые не поддерживают изменение размера и были пропущены',
    nonBrandToBrandTip: 'Эту маленькую панель нельзя перетащить на большую панель с фирменной цветовой картой!',
    brandToNonBrandTip: 'Эту маленькую панель нельзя перетащить на большую панель без фирменной цветовой карты!',
    brandToOtherBrandTip: 'Эту маленькую панель нельзя перетащить на большую панель другой фирменной цветовой карты!',
    editNo: 'номер',
    editAllPlank: 'Все большие доски',
    editBigPartSize: 'Изменить размер доски',
    disPlaySetting: 'Настройки отображения',
    stored: 'На складе',
    onlySurplus: 'Смотреть только остатки',
    UnuseSurplus: 'Излишки не учитываются при расчете коэффициента использования',
    usePlankAdsorption: 'адсорбционная функция пластины',
    dataDefaultCollapsed: 'Сброс данных по умолчанию',
    unit: 'блок',
    cutSurplus: 'Остаток',
    frontWarningTip: 'Двойная обработка высокооптических панелей: сначала обработать < span class = "font - style" > матовую поверхность < / span >, затем обработать < span class = "font - style" > высокооптическую поверхность < / span > < span >;  &nbsp; Односторонне обработанная высокооптическая пластина: прямая обработка < / span < span class = "font - style" > Высокая световая поверхность < / span >',
    selectTip: 'Пожалуйста, выберите нижнюю панель, которая требует дополнения!',
    plankKeyWordPlaceholder: 'Введите имя или номер панели',
    surplusStoreSuccess: 'Хранилище успешно',
    editCutOrder: 'Изменить порядок резки',
    setCutPoint: 'Установите точку падения.',
    specialPaibanChangeErr: 'Есть панели со специальными процессами или пазами для боковой обработки, которые временно не поддерживают переключение схемы набора!',
    storedSuccess: 'Дополнение успешно! Выберите панель для управления дополнениями!',
    noSurplus: 'Не найден доступный остаток',
    selectErrTip: 'Оставшиеся пластины не могут быть дополнены, сначала выберите нормальную пластину',
    noRoomIDTip: 'Эта доска не имеет идентификатора комнаты, не может быть пополнена в хранилище, сначала выберите другую доску',
    noPlank: 'Доска не найдена',
    noPaibanData: 'Данные без типографии, не могут быть выполнены',
    historyNameErr: 'Введите имя программы',
    tempErrTip: 'Обнаружено, что вы не добавили шаблон для пятигранного бурения, чтобы экспортировать файл обработки пятигранного бурения, обратите внимание: после добавления требуется переформатирование',
    changeDataTip: 'Примечание: Обнаружено ли изменение в ваших данных Создать новый исторический файл для сохранения этого изменения?',
    upgrade: 'обновление',
    upgradeTip: 'Вы можете нажать кнопку ниже, чтобы обновить версию',
    plankOverEdge: 'Ошибка загрузки NC! Пожалуйста, проверьте, есть ли накладки или панели снаружи.',
    useSurplusTip: 'Вычет остатков',
    noDataExport: 'Нет данных, которые можно экспортировать',
    noPlankExport: 'Нет данных, которые можно экспортировать',
    lockTip1: 'Нажмите для разблокировки, после разблокировки можно',
    lockTip2: 'Изменить расположение и атрибуты панели',
    unlockTip1: 'Нажмите для блокировки, которая не может быть выполнена после блокировки',
    unlockTip2: 'Изменить расположение и атрибуты панели',
    plankLockErr: 'Большая доска заблокирована и не может быть размещена.',
    lockPartEditTip: 'Пластина заблокирована и не может быть отредактирована',
    glassEquipmentTip: 'Когда производственной линией является стеклорезка, лист не может быть перемещен',
    expandedTip: 'Пластина имеет специальную технологию вытягивания канавки, не поддерживает редактирование операции!',
    sameWidthPlankTip: 'Включен набор пил, панель не может двигаться',
    expandedArrangeTip: 'Пластина имеет специальную технологию вытягивания канавок, необходимо перепечатать!',
    dragErrTip: 'Невозможно разместить, проверьте свойства материала, цвета и толщины панели!',
    subtleSaveTip: 'В настоящее время выполнена операция на панели, но не сохранена, выйти?',
    rollTip: 'На большой доске есть сквозные отверстия / проходные канавки, не рекомендуется копировать!',
    glossRollErr: 'Высокоскоростные панели запрещены',
    lockDeleteErr: 'Панель заблокирована и не может быть удалена',
    deleteConfirmTip: 'Операция удаления не может быть восстановлена',
    deleteContinueTip: 'Ты продолжаешь?',
    deleteConfirm: 'Подтвердите удаление',
    selectPlankTip: 'Пожалуйста, выберите панель для этой операции.',
    storeFailTip: 'Сбор остатков не удался! Пожалуйста, проверьте, есть ли накладки или панели снаружи.',
    repeatStoreErr: 'В настоящее время вырезанные остатки уже находятся на складе.',
    surplusStoreFail: 'Ошибка входа в хранилище, проверьте, является ли элемент панели прямоугольным или L - образным!',
    plankConfilictErr: 'Не поддерживается размещение точек здесь, это будет противоречить другим панелям',
    surplusErrTip: 'Не поддерживается размещение точки здесь, что создает неправильный остаток',
    changeArrageSuccess: 'Успешное переключение программы',
    trialProduction: {
      trialProductionSample: 'Шкаф пробного производства',
      trialProduced: 'Я попробовал производство.',
      trialWarning: '{fontStyleStart}Если{fontStyleEnd} вы не прошли проверку производства шкафа для образцов, вы несете личную ответственность за все потери и неблагоприятные последствия для себя, других лиц и облачного программного обеспечения',
      trialSlotTip: 'При пробном производстве тщательно проверьте размер, глубину, расположение и правильное расположение канавки с положительным и отрицательным отверстиями',
      trialSlotTip1: 'Избегайте зеркального отражения шкафа.',
      trialSlotTip2: 'Вопрос',
      pleaseUploadTrial: 'Пожалуйста, загрузите фотографии из шкафа для пробных образцов после сборки.',
      uploadTrial: 'Загрузить шкаф для образцов'
      },
    awaitPlankStore: {
      store: 'хранилище листовых материалов',
      notTip: 'Больше не напоминать о незарегистрированном',
      justLookCurrent: 'Смотреть только текущий заказ',
      notInPushStorage: 'Не на складе',
      beInStorage: 'На складе',
      searchPlaceholder: 'Введите заказ для поиска в библиотеке',
      plankUploading: 'Пластинка сохранена.',
      oneClickStorage: 'Клавиша для ввода в хранилище',
      notUsePlank: 'Нет доступных панелей',
      notPlank: 'Бесплатное временное хранение',
      dragPlankInHere: 'Можно перетащить листы сюда для временного хранения.',
      surplusCannotBeStorage: 'Остаток нельзя складировать',
      plankHasBeenDeduction: 'Скрыты или отсутствуют исходные данные, которые не могут быть сохранены',
      plankLoadErr: 'Ошибка загрузки информации',
      taskTitle: 'Загрузка панелей в репозиторий',
      dataGenErr: 'Ошибка генерации данных',
      pushSuccess: 'Хранилище успешно',
      pushErr: 'Произошла неизвестная ошибка, не удалось войти в хранилище',
      awaitBoxExistPlank: 'Товарно - материальные запасы, подлежащие сортировке, хранятся на незарегистрированных досках, и рекомендуется использовать их после складирования',
      mergeFrameDoorWholeTip: 'Этот компонент является целым для слияния дверных рам, и после сохранения система автоматически разбивает его на отдельные блоки для управления',
      checkPlankStatus: 'Проверяется состояние панели. Это...'
      },
    batchSetCut: 'Установить точку сброса',
    applyTo: 'подходит для:',
    ncDownloadLifeText: {
      checkData: 'Проверяем данные.',
      checkDone: 'Проверка данных завершена',
      checkDataText: 'Обнаружение данных',
      loadSetting: 'Настройки загрузки',
      settingLoadDone: 'Настройка Загрузка завершена',
      loadSettingText: 'Настройка загрузки',
      downloadNc: 'Скачать NC',
      ncDownloadDone: 'NC Скачать полностью',
      downloadText: 'Скачать NC',
      loadPreferenceSetting: 'Загружаются настройки предпочтений',
      PreferenceSettingLoadDone: 'Настройки предпочтений для завершения загрузки',
      loadPreferenceText: 'Загрузить настройки предпочтений',
      dealTemp: 'Обрабатываются шаблоны',
      TempDealDone: 'Обработка шаблонов завершена',
      dealTempText: 'Обработка шаблонов',
      beBeingGenTagFile: 'Создание файла {fileType}',
      genTagFileDone: 'Создание файла {fileType} завершено',
      genTagFileText: 'Создание файла {fileType}',
      zip: 'Создается локальный сжатый файл',
      zipDone: 'Создание локального сжатого файла завершено',
      genZipText: 'Создание сжатого файла',
      fileTypeText: 'изображение'
      },
    surplusCommonTemp: 'Обычные шаблоны',
    plankErrTip: 'Текущая схема использования имеет небольшие доски, которые не могут быть напечатаны большими досками!',
    brandPlankErrTip: 'В текущем плане материалов есть брендовые детали без доступных брендовых листов для раскладки!',
    overSizeTip: 'Недостаточно большой или большой размер.',
    uselessPart: 'На текущей большой доске нет доступных малых досок, пожалуйста, переверстайте',
    splitArranged: 'Слишком много листов, пожалуйста, переверстайте или печатайте партиями',
    arrangedErrTip: 'Ошибка набора, есть недостаточное количество больших досок или ультрафутов маленьких досок',
    knivesModalTitle: 'Нет отверстий. Нож не найден.',
    cannotDownloadByKnivesErr: 'Невозможно загрузить NC, система обнаруживает наличие следующих отверстий и не может найти нож',
    viewPart: 'Посмотреть вопрос на доске',
    deductionModalTitle: 'Выберите объект вычета',
    bujianDeduction: 'Маленькая накладка',
    paibanDeduction: 'Минус панель резервной зоны',
    surplusDeduction: 'Ограниченная накладка',
    unlockPaiban: 'Снятие блокировки остатков, участвующих в наборе',
    maintain: 'Поддерживать блокировку остатков, участвующих в наборе',
    lockModalText: 'Наличие избыточной платы, занятой другими заказами, переиздание',
    lockNewSModalText: 'Текущее использование избыточной платы занято другими заказами, продолжать загрузку NC',
    rePaibanWarn: 'Оставшаяся большая доска занята другими заказами, может быть недостаточно большой доски, пожалуйста, переформатируйте список открытых материалов',
    sawRePaiban: 'Примечание: Вы используете пиломатериалы для резки, добавлен фасонный набор панелей, требуется переформатирование для вывода NC - файлов',
    togglePlankTip: 'Пластина имеет специальную технологию вытягивания канавки, не поддерживает операции положительного и отрицательного переключения!',
    stepCuttingMsg: 'Глубина слоистой резки должна быть меньше толщины пластины',
    stepCuttingMsg2: 'Глубина стратификации может вводить только цифры больше 0.',
    flipPlankTip: 'Открыл отверстие канавки шунт машина для обработки одной панели, не допускается работа опрокидывания!',
    genNoCutTagNotSupportExportPic: 'Открыта вкладка для создания несмываемых элементов, пока не поддерживается экспорт изображений',
    allSmallPlanksAreNoCutNotInLayout: 'В настоящее время доски не являются частью досок, не участвуют в наборе',
    canStillExportHoleSlotOrPrintTag: 'Вы все еще можете продолжать экспортировать файлы обработки отверстий или распечатывать теги',
    desMaterialNoCutNotSupportSwitchLine: 'Текущая производственная линия была открыта для указанного материала, пока не поддерживается прямое переключение производственной линии',
    desMaterialNoCutSettingChanged: 'Система обнаруживает, что настройки указанного материала панели не были изменены, пожалуйста, переформатируйте, чтобы убедиться, что производство точно',
    continueDownload: 'Продолжить загрузку',
    desMaterialNoCutErrorTip: 'Укажите, что материал листовой пластины не загружается в пластине, где есть отверстие / фасон, выделенный для обработки гравировальной машины, загрузочный отверстие / фасон распределяются на пять или шесть сторон обработки бурения, продолжать загрузку файла',
    clearReuseRelation: 'Нажмите, чтобы очистить связь повторного использования',
    layoutReuseTip: 'Быстрое копирование раскладки большой панели; изменения панели автоматически снимают связь повторного использования',
    hasBeenReused: 'Уже использовано повторно',
    layoutReuse: 'Повторное использование раскладки',
    specialProcessNotSupported: 'На панели есть специальные процессы, эта операция не поддерживается',
    conflictNotSupported: 'Обнаружен конфликт панелей, эта операция не поддерживается',
    noAvailablePlankForReuse: 'Нет доступных панелей для повторного использования',
    noMatchingPlankFound: 'Подходящая панель не найдена',
    reuseBoard: 'Повторное использование {number} панели',
    influenceTip: {
      title: 'Функции, влияющие на коэффициент оптимизации',
      empty: 'Нет',
      groupParams: 'Параметры раскладки',
      surplusNoRoll: 'Остатки без переворота',
      surplusCustomTrim: 'Индивидуальное значение обрезки',
      otherPlateCustomTrim: 'Индивидуальная обрезка для специальной панели',
      knifeDiameter: 'Диаметр пилы',
      surplusNoFlip: 'Остатки без переворота',
      surplusNotLayout: 'Остатки не размещаются на указанных пластинах',
      plankEdgeOff: 'Обрезка',
      surplusCustomTrim2: 'Изменение размера обрезки остатков',
      other: 'Другие функции, которые могут быть затронуты',
      enabled: 'Включено',
      plankThicknessStacking: 'Складывание толщины досок',
      edgePreMilling: 'Предрезка кромок досок',
      multiMaterialCuttingBlade: 'Многоматериальный режущий инструмент',
      sawSpecialShapePart: 'Панели с фигурными вырезами для пильных и гравировальных станков',
      longPlankCutting: 'Двухэтапное обработка длинных досок'
      }
    },
  paibanImg: {
    title: 'Управление типографскими диаграммами',
    exportCustomPaibanImg: 'Экспорт настраиваемой типографики',
    customPaibanImg: 'Настройка графика',
    isCustomName: 'Название настраиваемого типографики',
    template: 'Шаблоны: типографики',
    addTem: 'Добавить шаблон',
    canvasIndexSearch: 'Поиск по серийному номеру',
    symbol: 'Значок набора',
    frontSlot: 'лобовой желоб',
    backSlot: 'Обратный жёлоб',
    frontHole: 'Правильное лицо',
    backHole: 'Противоположное лицо',
    printNum: 'Показать максимум на листе бумаги',
    printUnit: 'Карта',
    edit: 'Редактор шаблонов',
    temName: 'Имя шаблона',
    rotate: 'Поворот типографики',
    showOverflow: 'Показывать данные на панели при переполнении текста',
    showHoleSlot: 'Показать информацию о пазе',
    bigPartCss: 'Корректировка стиля',
    partCss: 'Настройка стиля',
    addTemTip: 'Добавьте до 10 шаблонов!',
    exportTip: 'Выберите хотя бы один шаблон типографики для экспорта!',
    editSaveTip: 'Пожалуйста, убедитесь, что все необходимые заполнения будут заполнены, а затем сохранены!',
    exportDXF: 'Экспорт DXF',
    exportDxfGeneral: 'Универсальный 2D DXF',
    exportDxf3d: 'Специализированный 3D DXF',
    exportDxfGeneralTip: 'Подходит для ручной обработки, резки по чертежу или проверки результатов раскроя',
    exportDxf3dTip: 'Подходит для импорта в сторонние системы для производства; поддерживает интегрированные лазерные станки Huiya'
    },
  historyPage: {
    matchErrBySpecialTip1: 'Следующие специальные большие панели больше не могут найти совпадения, будет проблема с переформатированием страницы набора, если в этой истории используется схема смешивания, игнорируйте этот совет',
    specialPlankInfoErrTip2: 'Ошибка получения информации на специальной большой доске повлияет на функцию переформатирования страниц',
    download: 'Загрузить локально',
    allType: 'Сохранить все',
    handleSave: 'Сохранить вручную',
    specialPlank: 'Особый',
    surplusPlank: 'Избыточный',
    autoSave: 'Автосохранение',
    allArrange: 'Весь набор',
    searchPlaceholder: 'Поиск по названию заказа / партии вёрстки / номеру заказа',
    saveHistoryName: 'Название сохранённой истории',
    trailProduction: {
      title: 'Шкаф пробного производства',
      lastTime: 'Дата последнего испытания',
      recordList: 'Протокол пробного производства',
      start: 'Начать пробное производство',
      date: 'время',
      outputFrom: 'Выходное положение',
      empty: 'Нет данных',
      record: 'Загрузка фотографий из шкафа пробного производства',
      tip1: 'Примечание: Текущие заказы на пробное производство используют производственные данные по умолчанию',
      tip2: 'Примечание: Текущий заказ на пробное производство не использует последние параметры технологических параметров, вы можете пойти в комнату пробного производства, чтобы восстановить!',
      download: 'Загрузить файл обработки'
      },
    deleteTip: 'Подтверждаете ли вы удаление следующих исторических записей?',
    startDate: 'Дата начала',
    endDate: 'дата окончания',
    lastWeek: 'Неделя',
    lastMonth: 'Последний месяц',
    lastSeason: 'Последний март',
    toArrangePage: 'Перейти на страницу',
    notArrangedTip: 'Эта запись не была напечатана, пожалуйста, перейдите к списку открытых материалов!',
    toMaterialPage: 'Перейти на страницу списка',
    lessSelectTip: 'Пожалуйста, выберите хотя бы одну запись для этой операции.',
    downloadNc: 'Загрузить файл обработки'
    },
  workShopPage: {
    warningTip: 'Эта функция для ограниченного времени тестирования, пожалуйста, рационально организуйте производство вашего заказа!',
    fileManager: 'Управление производственной документацией',
    selected: 'Выбран',
    suplement: 'Дополнение',
    size: 'размер',
    saveToStore: 'Добавить в хранилище',
    enterArrange: 'Входит в типографию. Это...',
    deleteTip: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    arrangeTip: 'Анализируются данные дополнения, пожалуйста, подождите. Это...',
    store: 'Запасной склад',
    downloadFile: 'Загрузка производственных документов',
    notBujianFile: 'Файл дополнения не найден',
    productLineDelete: 'Производственная линия была удалена, и файл NC не может быть загружен!'
    },
  basePlankManager: {
    saveTip: 'Примечание: Сохранение по возврату автомобиля',
    offsetSize: 'Размер обрезки',
    overSizeTip: 'Когда размер слишком большой, автоматически выбирайте большие размеры для набора',
    addTip: 'При наборе, если панель превышает фут, всплывающее окно автоматически добавляет специальную большую панель',
    defaultOversizePlankValue: 'Установите размеры больших специальных листов по умолчанию',
    onlyLayoutTooBig: 'Сверхфутовые доски',
    settingRemark: 'Примечание: Функция здесь настроена в настройках справа',
    searchPlaceholder: 'Поиск материалов / цвета',
    syncData: 'Данные из шкафа синхронизации',
    syncDataM: 'Синхронизация данных',
    deletePlank: 'Удалить специальную доску',
    addPlank: 'Новые специальные листы',
    matCodePlaceholder: 'Пожалуйста, выберите доску.',
    thickPlaceHolder: 'Выберите толщину',
    widthErr: 'Ширина листа не должна быть пустой.',
    heightErr: 'Длина листа не должна быть пустой.',
    matCodeErr: 'Материал не должен быть пустым.',
    colorErr: 'Цвет листа не должен быть пустым.',
    editPlank: 'Редактирование панелей',
    deleteTip: 'Данные не могут быть восстановлены после удаления, подтверждается ли удаление данных?',
    plankKnifeSelect: 'Выбор ножа для раскройки оригинала',
    plankKnifeSelectTip: 'Когда пластина попадает в несколько правил, приоритет толщины пластины больше, чем материал пластины',
    knifeSelectTip: 'Примечание: Встроенный набор временно не поддерживает эту функцию',
    knife: 'Раскроющий нож',
    matcodeInput: 'Пожалуйста, введите материал.',
    thickInput: 'Введите толщину листа.',
    default: 'Система по умолчанию',
    unessential: 'Это указано как: необязательное заполнение',
    emptyTip: 'Примечание: При совпадении оригинала без заполнения этого элемента эти данные не будут различаться!',
    defaultUse: 'Выбор по умолчанию',
    editMatcode: 'Редактирование материалов',
    syncTip: 'Будет получены данные из {fromMc} и заменены данными управления исходными листами в существующем облачном макете. Синхронизировать?',
    sameErr: 'Такие же данные уже существуют.',
    cancelDelete: 'Отменено Удалено',
    syncErr: 'Ошибка синхронизации',
    syncSuccess: 'Синхронизация завершена',
    syncDataTip: 'Синхронизация данных {fromMc}',
    editErrTip: 'Наличие незаполненной информации, пожалуйста, проверьте!',
    numberCheck: '{type} может содержать только цифры!',
    deleteStandardPlate: 'Удалить стандартный лист',
    createStandardPlate: 'Новые стандартные листы',
    editStandardPlate: 'Редактирование стандартных панелей',
    trimmingDimension: 'Размер обрезки',
    front: 'вверх',
    back: 'вниз',
    left: 'левый',
    right: 'право',
    frontTrim: 'Верхняя обрезка',
    backTrim: 'Нижняя обрезка',
    leftTrim: 'Левый сюйбянь',
    rightTrim: 'Правая обрезка',
    customTrim: 'Изменить значение кромки',
    trimValue: 'значение обрезки',
    notEmpty: '{type} не может быть пустым!',
    edgeDir: 'Обрезка ({type})',
    brandPlank: 'Фирменный лист',
    brandPlankTip: 'Примечание: Удаление и изменение фирменных листов выполняется в библиотеке ресурсов плит клиента Cabinet',
    brand: 'Бренд',
    supplier: 'Поставщик',
    brandPlaceholder: 'Выберите бренд',
    supplierPlaceholder: 'Выберите поставщика',
    brandInput: 'Введите бренд',
    supplierInput: 'Введите поставщика',
    addBrandPlank: 'Добавить фирменный лист',
    deleteBrandPlank: 'Удалить фирменный лист',
    editBrandPlank: 'Редактировать фирменный лист',
    searchBrandPlaceholder: 'Поиск бренда/поставщика/материала/цвета'
    },
  bujianAndStore: {
    bujianStore: 'Запасной склад',
    awaitStore: 'Библиотека печатных материалов',
    depositAwaitStore: 'Хранить в библиотеке',
    pushToAwaitStore: 'Поместить в библиотеку',
    useTwoTableArrange: 'Использовать две формы',
    confirmUseTwoTableTip: 'Продолжает ли текущая выделенная панель, содержащая библиотеку дополнений и библиотеку для форматирования?',
    confirmAddPlankToAwaitStore: 'Подтверждаете ли вы добавление выбранной панели в библиотеку, подлежащую набору?',
    pushStoreSuccess: 'Хранилище успешно',
    dataGenErr: 'Ошибка генерации данных',
    unknownErr: 'Произошла неизвестная ошибка, не удалось войти в хранилище'
    },
  surplusPage: {
    surplusMaterial: 'Перечень излишков',
    surplusStore: 'Склад излишков',
    recycleBin: 'Склад излишков',
    recycleBinTip: 'Данные избыточных материалов в корзине будут автоматически удалены по истечении 90 дней',
    "deleteReason-0": 'Удаление вручную',
    "deleteReason-1": 'Вычет при верстке',
    "deleteReason-2": 'Отгрузка через мобильную операцию Guigui',
    surplusShape: 'форма остатка',
    batchTransfer: 'Массовая передача',
    createNewSurplusStore: 'Новый склад',
    pushStoreSetting: 'Параметры складирования излишков',
    surplusStoreName: 'Название склада',
    surplusStoreName2: 'Название склада',
    addSurplusStore: 'Добавить склад',
    inventoryCeiling: 'Верхний предел запасов',
    autoTransferTip: 'После удаления остатки в хранилище автоматически переходят в список остатков.',
    asIndexPushStore: 'Хранить в порядке складирования',
    pushToSurplusMaterial: 'Перечень складированных излишков',
    surplusStoreTable: {
      number: 'номер',
      name: 'Название склада',
      quantity: 'Количество хранимых остатков (шт)',
      capacity: 'Верхний предел запасов излишков (шт)',
      rules: 'Правила складирования излишков',
      remark: 'примечание',
      operation: 'операция'
      },
    editSurplusStore: 'Редактировать остаточную библиотеку',
    addSurplus: 'Добавить остатки',
    importSurplus: 'Импорт остатков',
    downloadSurplusTemplate: 'Загрузить шаблон импорта остатков',
    batchExportSurplus: 'Экспорт текущего списка остатков',
    surplusBatchImportExport: 'Экспорт избыточных партий',
    surplusMaterialStorageCode: 'Код складирования излишков',
    generateQRCodeSuccess: 'Создание QR - кода успешно',
    generateQRCodeFailed: 'Ошибка создания QR - кода',
    refreshQRCode: 'Обновить QR - код',
    refreshQRCodeFailed: 'Ошибка обновления QR - кода',
    cancelRefresh: 'Обновление отменено.',
    refreshQRCodeTip: 'Обновить ли QR - код, текущий QR - код будет недействительным после обновления.',
    refreshQRCodeConfirm: 'определить',
    refreshQRCodeCancel: 'отменить',
    wechatScanTip: 'Открывая микросхему, можно вручную добавлять остатки в хранилище.',
    deletSurplus: 'Удалить остатки',
    editSurplus: 'Изменение остатков',
    surplusNoRoll: 'Включить обработку без копирования',
    type: {
      all: 'Все формы'
      },
    allMatcode: 'Все материалы',
    allThick: 'Полная толщина',
    surplusName: 'Название остатка',
    rectSurplus: 'прямоугольный остаток',
    LTypeSurplus: 'Л - образный остаток',
    noMatchSup: 'Соответствующие данные не запрашивались',
    jumpTo: 'Перейти',
    page: 'страница',
    newMatcode: 'Новые материалы',
    newColor: 'Новый цвет',
    autoCreateColor: 'Нажмите обратно, чтобы автоматически создать цветовую карту',
    nameLimit: 'Введите до 10 имен.',
    nameLimitNameErr: 'Название не может быть пустым.',
    tempLongTip: 'Длина листа может быть только цифрами.',
    minLongLimit: 'Короткая длина может вводить только цифры.',
    minLongEmptyTip: 'Длина короткая не может быть пустой.',
    minLongLimitMax: 'Длина короткая не должна превышать длину листа.',
    widthLimit: 'Ширина листа может быть только цифрами.',
    minWidthLimit: 'Короткая ширина может вводить только цифры.',
    minWidthEmptyLimit: 'Короткая сторона не может быть пустой.',
    minWidthLimitMax: 'Ширина короткая не должна превышать ширины листа.',
    thickLimit: 'Толщина листа может быть только цифрами.',
    thickEmptyLimit: 'Толщина листа не должна быть пустой.',
    countInputLimit: 'Количество может быть только положительным.',
    countEmptyLimit: 'Количество не может быть пустым.',
    remarkMaxlimit: 'Введите до 50 слов.',
    orderAddressMaxlimit: 'Введите до 100 слов в адрес заказа.',
    orderIdMaxlimit: 'Введите до 100 слов в номер заказа.',
    createTime: 'Добавить время',
    deleteTime: 'Время удаления',
    deleteReason: 'Причина удаления',
    branchName: 'Склад остаточных материалов',
    orderAddress: 'Адрес заказа источника',
    orderId: 'Номер заказа источника',
    lockStatus: 'Состояние блокировки',
    lockOrder: 'Заблокировать заказ',
    enableSurplusLock: 'Включить функцию блокировки остатков',
    isCloseSurplusLock: 'После того, как функция выключена, все остаточные материалы будут разблокированы, продолжать ли',
    confirm: 'Подтвердить закрытие',
    surplusTransfer: 'Перенос остатков',
    targetSurplusStore: 'целевой склад',
    enableSurLockTip: 'После включения каждый набор блокирует используемые остатки, чтобы предотвратить использование других заказов',
    addMainRule: 'Добавить главное правило',
    surplusRules: 'Правила складирования излишков',
    mainRulesTip: 'Отношения между первичными правилами да или, т.е. до тех пор, пока выполняется одно основное правило, остатки будут храниться',
    mainRulesTip1: 'После добавления правил излишки, попавшие в правила, будут храниться в первую очередь на этом складе, который после его заполнения будет помещен в другие свободные склады',
    rule: 'правило',
    addSubRule: 'Добавить правило',
    subRuleTip: 'Взаимосвязь между подзаконными актами есть и должна быть выполнена одновременно со всеми подзаконными актами в рамках основного правила, прежде чем они будут введены в хранилище.',
    bigPlankMatCode: 'Большой материал',
    bigPlankThick: 'Толщина плиты',
    bigPlankColor: 'Цвет большой доски',
    greaterEqual: 'Больше чем равно',
    lessEqual: 'Меньше чем равно',
    capNumberCheck: 'Верхний предел запасов может вводить только целое число!',
    capEmptyCheck: 'Верхний предел запасов не может быть пустым!',
    surNameEmptyCheck: 'Название хранилища не может быть пустым!',
    mainRuleLimit: 'Главное правило вышло на верхний предел.',
    delMainRuleTip: 'Удалить главное правило',
    matCodeEmptyCheck: 'Материал не может быть пустым!',
    thickEmptyCheck: 'Толщина доски не может быть пустой!',
    textureEmptyCheck: 'Большие цвета не могут быть пустыми!',
    enableWarehouseSecondCon: 'Включить вторичное подтверждение складирования',
    surplusWarehouseConfirm: 'Подтверждение складирования',
    surplusWarehouseConfirm1: 'Подтверждение складирования',
    closeSurplusConfirm: 'Закрыть подтверждение входа в хранилище (может быть перезапущено в настройках страницы управления остатками)',
    position: 'Место хранения',
    nameRepeatTip: 'Текущее имя остатка уже существует, пожалуйста, измените и перезапустите в хранилище',
    surLimitTip: 'Текущие складские запасы достигли верхнего предела или не соответствуют правилам складирования',
    surFailTip: 'Ошибка складирования, наличие повторяющихся имен излишков или хранение излишков в бункере до верхнего предела или не соответствует правилам складирования',
    surplusExistTip: 'Часть излишков уже в хранилище, операция не удалась',
    surplusExistTip2: 'В настоящее время остаточный материал уже находится в хранилище и не может быть складирован',
    currentPage: 'Текущая страница',
    totalPage: 'Выбрать все'
    },
  printPage: {
    goto: 'Немедленно отправляйтесь',
    surplusSizeTittle: 'Небольшой размер остатка',
    surplusSizeErrTip: 'Размер остатка слишком мал, пожалуйста, идите на соответствующую производственную линию, чтобы установить минимальный размер остатка!',
    opacityTip: 'Техническая поддержка со стороны & lt; & lt; умных карт & gt; & gt;',
    opacityTip2: 'Текущий аккаунт не покупает смарт - карты; Если вы уже купили, пожалуйста, свяжите учетную запись шкафа в программном обеспечении лотереи',
    loadFontTip: 'Загружается файл требуемых ресурсов шрифта, пожалуйста, подождите',
    leftAlign: 'Выравнивание по левому краю',
    rightAlign: 'Выравнивание по правому краю',
    topAlign: 'Выровнять вверх',
    bottomAlign: 'Выровнять снизу',
    horizontalAlign: 'Горизонтальное выравнивание',
    verticalAlign: 'Выровнять вертикально - посередине',
    horizontalSplit: 'Горизонтальное равномерное распределение',
    verticalSplit: 'Вертикальное равноденствие',
    norTag: 'Обычная этикетка оригинала',
    surTag: 'Большие накладки',
    genTag: 'Создать метку',
    all: 'Полная выборка',
    deleteWarning: 'Доброе напоминание',
    print: 'печать',
    defaultTemplate: 'Шаблоны по умолчанию (60 x 40)',
    editTemplate: 'Изменить шаблон',
    deleteTip: 'После удаления шаблона он не может быть восстановлен, подтверждается ли удаление шаблона?',
    tagSetting: 'Настройки метки',
    rememberSetting: 'После внесения изменений запоминаются параметры',
    genCutingTag: 'Создать метку обрезки',
    genSurplusTag: 'Создать этикетку',
    genPlankTag: 'Создание больших вкладок',
    genPartTag: 'Создать вкладку',
    genNoCutTag: 'Создать вкладку',
    tagPosition: 'Местоположение метки',
    tagPositionTip: '(Для маркировки машины необходимо заполнить координаты X / Y ниже)',
    Xposition: 'Координаты X',
    Yposition: 'Координаты Y',
    genPlankSuffix: 'Большие вкладки создают суффикс имени файла',
    arrangeMirror: 'Отражение диаграммы вкладок',
    drillPlankBase: 'пятигранная опора',
    drillPlankBaseTip: 'Ошибка получения базовых данных на листе загрузки, попробуйте позже!',
    suitAuto: 'Сортировка этикеток для автоматической загрузки:',
    colorLabel: 'Создание цветных меток',
    colorRevert: 'Создать метку',
    displayEnAndZh: 'Название комнаты / шкафа / доски Показать на английском языке',
    displayEnAndZhTip: 'Поддерживаются только имена комнат / шкафов / панелей по умолчанию, и эта функция не вступает в силу после изменения имени',
    up: 'вверх',
    down: 'Вниз',
    default: 'по умолчанию',
    printSetting: 'Параметры печати',
    oneToMore: 'Несколько страниц.',
    perPage: 'Каждый',
    coloumn: 'ряд',
    tagMargin: 'Разрыв между метками',
    coloumnMargin: 'Расстояние между столбцами',
    specialMark: 'Специальные метки',
    opacity: 'Транспарентность',
    opacityTip3: 'Фотографии в формате BMP требуют выбора цвета для обеспечения прозрачности',
    suite: 'Самоадаптация',
    svgListTip: 'Не открывать вкладку для создания панели, отметьте слева',
    size: 'размер',
    lightSide: 'Увидеть край света',
    locFrontSide: 'передняя сторона шкафа',
    openSide: 'Направление открытия.',
    extraTip: 'Совет: При первом использовании прямой печати добавьте в настройки принтера новый лист бумаги этого размера, длинный и широкий, а затем распечатайте его с помощью новой бумаги (например, оригинальный размер бумаги 60×40, новый размер бумаги 40×60).',
    noMore: 'Больше нет',
    prepareData: 'Готовьте данные. Это...',
    genTagFile: 'При создании тегов, не выполняйте переключение страниц, минимизацию браузера, прокрутку вверх и вниз тегов и другие действия!',
    waitGen: 'Пожалуйста, подождите, пока метка не будет загружена.',
    tempLoading: 'Шаблоны вкладок загружены позже',
    front: 'перед',
    open: 'открыть',
    toEdit: 'Перейти к редактору',
    simplifyOneCodeTip: 'Примечание: Свойства штрих - кода, установленные в этом шаблоне вкладки, не поддерживают использование функции « Простой штрих - код», измените свойства штрих - кода (рекомендуется свойство штрих - кода: CODE128)',
    plankTemp: 'Шаблоны: Метки',
    surplusTemp: 'Шаблоны: Оставшиеся метки',
    enableSubTag: 'Включить дополнительную этикетку',
    enableSubTagTip: 'Можно настроить в разделе «Дополнительные настройки» > «Настройки дополнительной этикетки малой плиты» > «Настройка действующего источника данных для генерации дополнительной этикетки». После включения дополнительная этикетка создается только если у заданного источника данных есть значение на дополнительной этикетке, иначе не создается.',
    goSet: 'Перейти к настройкам',
    mainTag: 'Основная этикетка малой плиты',
    subTag: 'Дополнительная этикетка малой плиты',
    downloadSubTagTip: 'Экспортируемые этикетки содержат дополнительную этикетку. Автоматическая линия этикетирования временно не может создавать дополнительные этикетки. Продолжить вывод?',
    embeddedSubTagTip: 'Функция дополнительной этикетки не поддерживается. Откройте веб-основанный макет в облаке, чтобы использовать его.',
    subTagPerSaveTip: 'Права дополнительной этикетки истекли. Пожалуйста, закройте дополнительную этикетку и сохраните снова.',
    subTagPerexportTip: 'Экспортируемый производственный файл содержит платные права дополнительной этикетки. Эта функция истекла и требует закрытия и повторного вывода.',
    tempNamePlaceHolder: 'Введите имя шаблона',
    editTip: 'Вы можете перетащить левую кнопку на правую вкладку, чтобы выполнить редактирование шаблона вкладки',
    oneCode: 'штрих-код',
    image: 'Изображения',
    arrow: 'стрелка',
    editPage: {
      digitLimitation: 'Ограничение числа цифр',
      title: 'Редактор шаблонов меток',
      reset: 'восстановить по умолчанию',
      exit: 'Выход из редактирования',
      tagInfo: 'Информация о вкладке',
      tagName: 'Название метки',
      tagSize: 'Размер этикетки',
      tagData: 'Данные метки',
      dragTip: 'Нажмите левую кнопку мыши, чтобы вытащить вкладку',
      dataTip: 'Выберите данные в правой панели свойств',
      text: 'текст',
      dataSource: 'данные и информация',
      graph: 'График',
      typograpyPic: 'Типограмма',
      barCode: 'штрих-код',
      QRCode: 'QR-код',
      plankMark: 'Маркировка листов',
      holeSlotPic: 'пазовая диаграмма',
      edgeBandPic: 'Боковая диаграмма',
      visibleEdgePic: 'Увидеть край света',
      holeSlotPicZoom: 'Масштаб диаграммы',
      rotateDeg: 'угол поворота',
      colorDeep: 'Глубина цвета',
      surplusMark: 'Маркировка остатков',
      surplusSizePic: 'График остаточных размеров',
      dataSize: 'Размер данных',
      extraList: 'Дополнительный список',
      QRCodeFormat: 'Формат QR - кода',
      formatQR: 'Формат QR',
      formatDM: 'Формат DM',
      locIndex: 'Номер шкафа',
      plankFrontSign: 'Маркировка панели',
      genNCSuffix: 'Создать суффикс NC',
      table: 'таблица',
      inputPlaceholder: 'Двойной щелчок для ввода текста',
      attribute: 'свойство',
      fontFamily: 'Тип шрифта',
      fontSize: 'Размер шрифта',
      fontWeight: 'Широкий шрифт',
      flipOverProcessing: 'Обработка переворота',
      showSideMachiningSequenceDiagramBorder: 'Показать границу диаграммы последовательности обработки стороны',
      showSideMachiningSequenceNumber: 'Показать номер последовательности обработки стороны',
      autoRow: 'Автоматический перенос строк',
      rowMargin: 'Расстояние между строками',
      autoFontSize: 'Автоматическое изменение размера шрифта',
      statisticsDimension: 'Статистическое измерение',
      noLimit: 'без ограничений',
      sameOrderNo: 'Тот же заказ',
      sameRoom: 'В одной комнате',
      sameWardrobe: 'Шкаф',
      alignWay: 'Выравнивание',
      JustifyLeft: 'Выровнять слева',
      JustifyRight: 'Выровнять справа',
      JustifyCenter: 'Выравнивание по центру',
      otherOpration: 'Другие операции',
      attributeReset: 'Сброс параметров',
      barCodeSize: 'Размер штрих - кода',
      installPic: 'установочный чертеж',
      plankCode2: 'Штрих - код панели (noMark)',
      frontCode: 'Положительный штрих - код',
      backCode: 'Отрицательный штрих - код',
      orderRemark: 'Примечания к заказам',
      NCFileName: 'Загрузить имя файла',
      NCFileNameTip: 'Название файла не должно содержать китайский и не должно превышать 10 бит.',
      showOpenSide: 'Показать направление открытия',
      limitFixed: 'Количество десятичных знаков',
      showFrontHS: 'Показать лобовое отверстие',
      showBackHS: 'Показать отверстие с обратной стороны',
      showPartEdge: 'Закрытие панелей',
      showPlankSize: 'Показать размер панели',
      tempNamePlaceholder: 'Введите имя метки',
      deleteAreaTip: 'Выберите блок для удаления',
      suitShunt: 'Настройка адаптации слотов',
      suitShuntTip: 'После выбора, части отверстий, которые не имеют последующей обработки после分流, не будут генерировать штрих-коды',
      noHoleSlot: 'Беспорядочный слот также показывает штрих - код.',
      rotate: 'Ротационный штрих - код',
      barcodeAtrribute: 'Свойства штрих - кода',
      imgSize: 'Размер изображения',
      graphStyle: 'Графический стиль',
      noEdgeDisplay: 'Закрыть & 0 без показа',
      allEdgeNoDisplay: 'Закрытие не отображается',
      isShowDiffEdgeColor: 'Показать цвета на каждой стороне',
      hideSameEdgeColorAsPlank: 'Скрыть цвет на каждой стороне, когда он такой же, как цвет панели',
      hideSameEdgeColorAsPlankTip: 'Встроенная облачная вёрстка пока не поддерживается',
      imgRotate: 'Изображение вращается',
      circleD: 'Диаметр рамы',
      roomNo: 'Номер комнаты',
      roomOrder: 'Номер шкафа (по номеру)',
      alphabetically: 'Сортировать по буквам',
      numberOrder: 'Сортировка по числам',
      specialMarkup: 'Специальные символы',
      smallPlateMarking: 'Маркировка панелей',
      arrow: 'стрелка',
      triangle: 'Треугольник',
      sixSideDrillPlankBase: 'пятигранная опора',
      boldSettingTip: 'Не поддерживается жирным шрифтом PDF',
      frontEdge: 'Показать переднюю часть шкафа',
      visibleEdge: 'Показать & край света',
      lineCount: 'Количество слов в строке'
      },
    autoSaveToHistory: 'Автоматически сохранены в истории!',
    firstPrintTip: 'При первом использовании прямой печати добавьте в настройки принтера бумагу этого размера, длинную и широкую, а затем используйте новую бумагу для печати.',
    tagDownloading: 'Метки загружаются. Это...',
    cutLaveEnd: 'Оставшиеся метки создаются за каждой большой доской.',
    deleteTemplate: 'Удалить шаблон',
    copyTemplateRenderUrl: 'Скопировать ссылку шаблона',
    noPermission: 'Шаблон, у которого нет разрешения на копирование ссылки',
    moreOperation: 'Больше действий',
    importTemplate: 'Импорт шаблона',
    importTemplateLink: 'Скопируйте ссылку шаблона в поле ниже, чтобы импортировать шаблон',
    importTemplateLinkPlaceholder: 'Скопируйте ссылку шаблона в поле ниже, чтобы импортировать шаблон',
    noDeleteTemplate: 'Шаблон по умолчанию не может быть удален',
    tip1: 'Ссылка для копирования шаблона отсутствует',
    tip2: 'Ссылка на данные шаблона скопирована',
    tip3: 'Ссылка на шаблон не может быть скопирована, пожалуйста, попробуйте позже',
    tip4: 'Не удалось распознать ссылку импортируемого шаблона. Пожалуйста, скачайте снова и импортируйте.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'В зависимости от цвета, материала, толщины, размера большой доски, сгруппированы в разные папки (файлы с наклейкой вместе)',
    notOpeFolderPermission: 'Не разрешено использовать этот каталог',
    notFindFolder: 'Невозможно обнаружить этот каталог в текущем клиенте',
    productLineUniversal: 'Все производственные линии',
    effectCondition: 'Для вступления в силу изменения этой настройки требуется переформатирование.',
    addPath: 'Добавить путь',
    downloadPositionChangeByType: 'Расположение загрузки сгенерированных файлов изменено на {type}',
    isDeleteFolder: 'Подтвердить удаление использованного места хранения файлов?',
    netWorkIsNotSafe: 'Ваша сетевая среда кажется небезопасной, мы не можем включить эту функцию, и вы можете вернуться к нам',
    NotSupportBrowse: 'Ваш браузер пока не поддерживает эту функцию, загрузите последнюю версию < a href = > https://www.microsoft.com/zh-cn/edge/download "target =" blank "> Edge < / a > Использование браузера',
    notSupportDisk: 'Не может быть выбран каталог системного уровня, например [рабочий стол] [CPD]',
    useFolderDownload: 'Загрузка производственных документов в распакованном виде',
    downloadPosition: 'Загрузить расположение файла',
    changeUseFolder: 'изменить',
    folderNameSetting: 'Параметры папок',
    mainFolder: 'Папка первого уровня',
    exportNameSetting: 'Экспорт файлов обработки по номеру заказа',
    fileMax: 'Наименование файла максимум',
    char: 'символ',
    overTip: 'Больше, чем часть не отображается (пакет сжатия тегов и файл json будут названы в папке первого уровня)',
    example: 'Пример',
    engravingFolder: 'Папка Скульптор',
    electronicSawFolder: 'Папка электронной пилы',
    labellingFolder: 'Папка',
    sideHoleDrillFolder: 'Папка бокового отверстия',
    fiveDrillFolder: 'Папка с пятигранным сверлом',
    sixDrillFolder: 'Папка с шестигранным сверлом',
    PTPFolder: 'Папка PTP',
    labellingTagFolder: 'Каталог изображений',
    surplusFolder: 'Параметры больших панелей для остаточных файлов',
    surplusBigPlankSetting: 'Размещение файла раскраски / изображения метки / файла наклейки отдельно',
    surplusBigPlankSettingTip: 'После открытия остаточного файла NC, изображение метки и файл метки будут помещены в отдельную папку',
    folderMergeSetting: 'Параметры объединения папок',
    folderMerge: 'Объединение папок',
    mergeName: 'Имя объединения',
    subMergeFolder: 'Объединить в подкаталоги по толщине цвета материала',
    subFolderName: 'Имя папки',
    splitChar: 'Разделитель',
    splitTip: '(Не поддерживается ввод /:? < > <... > > * и другие символы)',
    folderAutoAdd: 'Начальное значение увеличения числа папок',
    resetTip: '(Ежедневный сброс нуля на исходное значение)',
    emptyErrTip: 'Информация не может быть пустой',
    repeatErrTip: 'Имя файла повторяется',
    mergeDataTip: 'Должен быть материал пластины толщина цвета длина ширина или увеличение числа файлов или толщина цвета пластины',
    engravingFileSetting: 'Настройка файла гравировальной машины',
    engravingSplitZF: 'Поместить положительные / отрицательные файлы гравировальной машины в разные папки',
    engravingSplitZFTip: 'Подходит для автоматической маркировки,',
    engravingSplitWorkstation: 'Гравировальная машина позиция бойынша папкаларға бөлінеді',
    engravingSplitWorkstationTip: 'Гравировальная машина и машина для резки гравировальной машины поддерживается',
    holeFileSetting: 'Параметры перфорации файла',
    holeFileSingle: 'Размещение перфорированных файлов в отдельных папках по различным заказам'
    },
  moreSettings: {
    generalSetting: 'Общие настройки',
    outSyncTip: 'При несинхронизации данных с шкафом создается окно подсказки',
    secondarySwitchShow: 'Содержание второго уровня, управляемое переключателем в настройках гравировальной машины, все еще отображается после выключения переключателя',
    isFrameDoorTip: 'При обработке рамковых дверей создается подсказка',
    exPaibanTip: 'Создание подсказок при наборе',
    isDesMaterialNoCutTip: 'Укажите панель, материал которой не загружается, с отверстием, выделенным гравировальной машине / фасадом, чтобы создать подсказку всплывающего окна',
    surpTagThresholdTextHalf1: 'Когда остаточная (не обрезанная) площадь меньше',
    surpTagThresholdTextHalf2: 'Не создавать этикетку остаточного материала',
    innerShapeToolMatch: 'Скульптор обрабатывает внутреннюю фасон автоматически выбирая подходящий инструмент',
    innerShapeToolMatchTip: '(Скульптор обрабатывает внутреннюю фасонку с меньшим диаметром, чем резец, и эта функция может быть включена, если ошибка размера не может быть обработана)',
    innerShapeToolMatchTip2: 'Примечание: После включения будет использоваться наименьшая фреза, пожалуйста, разумно установите минимальную фрезу "длина инструмента" и "однократную максимальную глубину обработки", только в облачной типографии',
    surNotLayout: 'Определить остаточную пластину',
    surNotLayoutTip: 'После открытия 1. лист с остатками не может быть указан в списке с именами панелей с именами ниже. При наборе вы можете выбрать, вступает ли эта типография в силу.',
    addPlank: 'Добавить имя панели',
    addPlankTip: 'Добавить хотя бы одно имя',
    thisInput: 'введите здесь',
    surNotLayoutMat: 'Оставшийся материал не указан на доске',
    subTagSetting: 'Настройки дополнительной этикетки малой плиты',
    subTagDataSource: 'Настройка действующего источника данных для генерации дополнительной этикетки',
    subTagDataSourceTip: 'После включения можно добавить источники данных, управляющие генерацией дополнительной этикетки. Дополнительная этикетка создается, если на ней есть этот источник данных и у источника есть значение.',
    addSubTagDataSource: 'Добавить источник данных',
    addSubTagDataSourceTip: 'Нельзя добавлять повторяющиеся источники данных',
    addSubTagDataSourceTip1: 'Добавьте хотя бы один источник данных',
    addSubTagDataSourceTip2: 'Источник данных не может быть пустым, выберите значение',
    reuseMatchingPlankName: 'Повторное использование по названию доски',
    reuseMatchingPlankNameTip1: 'При отключении этой функции повторное использование раскладки сопоставляет панели с одинаковыми материалом, цветом, толщиной, размерами, текстурой и свойствами высокого глянца',
    reuseMatchingPlankNameTip2: 'При включении этой функции, помимо вышеуказанных условий сопоставления, также добавляется сопоставление по названию доски'
    },
  lineManager: {
    add: 'Добавить производственную линию',
    engraving: 'Загрузочное оборудование',
    holeSlotEquip: 'Оборудование для обработки отверстий',
    workSetting: 'Параметры обработки',
    noUse: 'не включен',
    warningTip: '* Примечание: После настройки следующих функций, пожалуйста, не сохраняйте страницу стыковки клиентского устройства шкафа, избегайте сброса параметров!',
    engravingSetting: 'Настройка открывающей машины',
    workWay: 'Обработка',
    cutedSpecial: 'Специальные отверстия для обработки:',
    noWork: 'Этот параметр не работает для шаблонов по умолчанию для пятигранного бурения',
    onlyCut: 'Только раскрой.',
    onlyFrontHoleSlot: 'Только передние отверстия для обработки листов',
    onlyHoleSlot: 'Только для обработки листов с положительной и отрицательной стороны отверстия',
    sideHoleSetting: 'Настройка бокового отверстия',
    cutHoleSlot: 'Обработанные отверстия',
    minSize: 'Короткие боковые размеры',
    maxSize: 'Длинный размер',
    minSize2: 'Все на панели mm',
    minSize3: '& Экзотическая часть',
    onlyFrontHoleSlotTip: 'Набор страниц только на досках с отверстиями спереди',
    onlyFrontHoleSlotTip2: 'Не содержит боковых отверстий',
    holeAndSlot: 'отверстие и паз',
    empty: 'пустота',
    singleHole: 'Одноотверстие',
    singleSlot: 'Одиночный слот',
    diameterRange: 'Диаметр отверстия',
    hDeepRange: 'Диапазон глубины отверстия',
    widthRange: 'Диапазон ширины паза',
    sDeepRange: 'Диапазон глубины желоба',
    to: 'до',
    specialHS: 'Специальные отверстия и фасоны',
    allowRoll: 'Разрешить распылителю переделывать специальные отверстия',
    engravingPath: 'фасонная графитовая носовая летательного аппарата для обработки листов на распылителе',
    curve_range: 'Внешняя часть длиннее',
    curve_range2: 'Все фасонные части панели',
    curveArea: 'Экзотическая площадь',
    drillSetting: 'Настройка пятигранного бурения',
    engravingCuted: 'Обработанные отверстия на распылителе на пятигранном',
    engravingCutedSpecial: 'Обработанные фасонные части панели на пятигранном',
    genCuttingPath: 'Формирование данных раскроя',
    otherCuted: 'Прочее оборудование обработанные отверстия на 5 / 6 поверхности',
    noGen: 'Не создается',
    genCut: 'Формирование и обработка',
    genNoCut: 'Создано, но не обработано',
    cutTip: 'Примечание: Эта опция действительна только для пользовательских файлов пятигранного бурения',
    maxShortSize: 'Максимально короткий размер',
    maxLongSize: 'Максимальная длина края',
    normalSlot: 'Обычный лоток',
    specialSlot: 'Специальный лоток',
    combinSetting: 'Параметры комбинированного устройства',
    allowShortSize: 'Разрешить короткие боковые размеры',
    equipment1: 'Оборудование I',
    equipment2: 'Оборудование II',
    noSameTip: 'Примечание: Два устройства не могут выбрать одно и то же',
    workRange: 'Оборудование I',
    rangeWarning: 'Примечание: Можно установить только один диапазон обработки оборудования, а не один диапазон обработки оборудования будет полностью обработан на втором устройстве, пожалуйста, будьте осторожны!',
    deleteWarning: 'Невозможно восстановить после удаления производственной линии (все настройки под этой линией будут удалены), подтверждается ли удаление производственной линии?',
    top: 'верх',
    inputCheck: 'Минимальное значение {msg} не может быть больше максимального значения',
    lockTip: 'Производственная линия заблокирована, операция запрещена!',
    reNameTip: 'Производственные линии по умолчанию не могут изменять имена',
    permissonTip: 'Идентификационные данные истекли, пожалуйста, откройте эту страницу снова из шкафа!',
    permissonErr: 'Без этого права, пожалуйста, обновите версию учетной записи!',
    permissionOneMacErr: 'У вас есть доступ к {idx} линиям производства для интегрированного оборудования. Если вам нужно добавить больше, пожалуйста, свяжитесь с продавцом!',
    permissionSawErr: 'Нет прав на использование пилы гравировальной машины, пожалуйста, свяжитесь с продажей, чтобы купить полный алюминиевый пильный дополнительный пакет для использования',
    getAuthError: 'Ошибка получения прав на устройство!',
    sawAddNumber: 'Количество линий по производству электронных пил, которые вы можете использовать в настоящее время, исчерпано, и если вам нужно увеличить, свяжитесь с продажами!',
    newLine: 'Создание новой линии производства {idx}',
    deleteCheck: 'Не все можно удалить',
    deving: 'В стадии разработки',
    combinTip: 'Нажмите ниже для настройки комбинации устройств',
    noUseEquip: 'Оборудование не включено',
    equipmentSelectTip: 'Когда комбинированное оборудование выбирает распылитель, распылитель не может выбрать электронную пилу',
    lineLoading: 'Данные загружаются',
    strenchType: 'Тип выпрямителя',
    aioProcessTip: 'Вы включили устройство « One Machines», способ обработки по умолчанию для обработки листов с положительным и отрицательным отверстием',
    aioProcessTip2: 'Специальные отверстия, обработанные частично гравировальной машиной после включения монолитной машины',
    aioProcessTip3: 'Примечание: Эта функция несовместима с гравировальной машиной, которая включает обмен осями XY. Используйте ее с осторожностью.',
    specialHoleTip: 'ПРИМЕЧАНИЕ: При использовании вышеуказанных функций « обработанных специальных отверстий» установите « способ перфорации сквозного отверстия» и « способ перфорации сквозного отверстия» для однократного пробоя',
    specialHoleTip2: 'Примечание: При использовании вышеуказанных функций « обработанных специальных отверстий» установите гравировальный станок « способ перфорации сквозного отверстия» и « способ перфорации сквозного отверстия» для однократного пробоя',
    fiveSixNotTake: 'Этот параметр не работает для шаблонов по умолчанию для пятигранного бурения',
    onlyFrontSide: 'Обрабатывается только спереди.',
    onlyBackSide: 'Обрабатывается только обратная сторона',
    less: 'меньше',
    equal: 'Равно',
    greater: 'более',
    or: 'или',
    and: 'А',
    bothFrontBack: 'Обработка спереди и сзади',
    shareDataErrTip: 'Эти данные применяются {operatorPhone}, IP: {actionIp}',
    restoreParams: 'Параметры восстановления',
    loadMore: 'Загрузить больше',
    currentCombinationEquipment: 'Текущий выбор комбинированного оборудования, открывающее устройство не позволяет переключаться на стеклорезку',
    selectEquipmentType: 'Выберите тип устройства',
    ruleRemark: 'Примечания к правилам',
    remarkPlaceholder: 'Это аннотированная информация, которая может указать, какие процессы обрабатывает это правило, чтобы избежать забвения, после заполнения сохранить производственную линию в действии',
    onlyNoSideHoleSlotSmallPlank: 'Только маленькие доски без боковых отверстий и пазов'
    },
  cuttingDock: {
    title: 'стыковка с открытой загрузкой',
    autoStockCode: 'Автоматически загружать код',
    stationStart: 'Начало работы',
    stationStartCode1: 'Станция 1 Начальный код',
    stationStartCode1Placeholder: 'Введите начальный код станции 1',
    stationStartCode2: 'Станция 2 Начальный код',
    stationStartCode2Placeholder: 'Введите код ввода 2.',
    stationEnd: 'Конец рабочего места',
    stationEndCode1: 'Код окончания позиции 1',
    stationEndCode1Placeholder: 'Введите код окончания рабочего места 1',
    stationEndCode2: 'Станция 2 Конечный код',
    stationEndCode2Placeholder: 'Введите код окончания позиции 2',
    frontBackStart: 'Начинается с противоположной стороны.',
    frontBackEnd: 'Положительный и отрицательный конец',
    frontStartCode: 'Положительный код начала',
    frontStartCodePlaceholder: 'Введите код начала спереди',
    frontEndCode: 'Код положительного конца',
    frontEndCodePlaceholder: 'Введите код положительного конца',
    backStartCode: 'Код обратного начала',
    backStartCodePlaceholder: 'Введите обратный начальный код',
    backEndCode: 'Код обратного конца',
    backEndCodePlaceholder: 'Введите обратный код конца',
    plankStart: 'Начинается опрокидывание листов.',
    plankEnd: 'Конец опрокидывания пластины',
    plankRollCode1: 'Код поворота позиции 1',
    plankRollCode1Placeholder: 'Введите код поворота позиции 1',
    plankRollCode2: 'Код поворота позиции 2',
    plankRollCode2Placeholder: 'Введите код поворота 2.',
    autoBaitingCode: 'Код автоматической раскройки',
    autoBaitingCode1: 'Станция 1 Код раскрутки',
    autoBaitingCode1Placeholder: 'Введите код загрузки станции 1',
    autoBaitingCode2: 'Станция 2 Код раскрутки',
    autoBaitingCode2Placeholder: 'Введите код загрузки 2.',
    thickMarkPermission: 'У вас нет разрешения на маркировку толщины большой плиты. Пожалуйста, свяжитесь с отделом продаж для покупки',
    thickMark: 'Маркировка толщины большой плиты',
    preStartEquipment: 'Предпусковое оборудование',
    firstKnifePreCode: 'Загрузить код заранее',
    secondKnifePreCode: 'Код предварительного запуска второго и последующего ножей.',
    rowInsert: 'Вставить строку',
    pumpPause: 'Вакуумный насос выключен.',
    pumpPauseTip: 'Примечание: Однопозиционное оборудование должно заполнять как рабочее место 1, так и рабочее место 2 одним и тем же « кодом автоматической загрузки» и « кодом интерпретации передней части двухсторонней обработки».',
    pumpPause2Tip: 'Примечание: однопозиционное оборудование должно заполнять как рабочее место 1, так и рабочее место 2 одним и тем же « кодом остановки вакуумного насоса».',
    pumpPauseCode1: 'Станция 1 Код остановки вакуумного насоса',
    pumpPauseCode1Placeholder: 'Пожалуйста, заполните код остановки вакуумного насоса на станции 1.',
    pumpPauseCode2: 'Код остановки вакуумного насоса 2',
    pumpPauseCode2Placeholder: 'Пожалуйста, заполните код остановки вакуумного насоса на станции 2.',
    annotationCode1: 'Позиция 1 Двойная обработка фронтального кода комментариев',
    annotationCode1Tip: 'Оборудование для автоматической загрузки различных команд спереди',
    annotationCode1Placeholder: 'Введите позицию 1 Двойная обработка фронтального кода комментариев',
    annotationCode2: 'Позиция 2 Двойная обработка фронтального кода комментариев',
    annotationCode2Placeholder: 'Введите позицию 2, двухстороннюю обработку фронтального кода комментариев.',
    upSpeedTip: 'Заполните общую скорость ускорения.',
    cutThickTip: 'Пожалуйста, заполните общую толщину резки.',
    sizeErrTip: 'Пожалуйста, установите правильный размер для экспорта типографики в маркер!',
    offEdgeKnifeDiameter: 'Введите диаметр обрезки.',
    slowDownSpeedTip: 'Ошибка ввода параметров замедления углового сечения',
    permissionErr: 'Текущая бесплатная версия, не может быть сохранена',
    labellingTempErr: 'Выберите шаблон',
    autoRollInputTip: 'Открыть вкладку для автоматического вращения, введите действительное значение',
    offlineTempFormat: 'Текущий формат файла наклейки отключен, пожалуйста, подтвердите',
    autoStockCode1: 'Станция 1 Автоматическая загрузка кода',
    autoStockCode1PlaceHolder: 'Введите код автоматической загрузки станции 1',
    autoStockCode2PlaceHolder: 'Введите код автоматической загрузки 2',
    autoStockCode2: 'Станция 2 Автоматическая загрузка кода',
    pauseCode: 'Приостановить код',
    pauseCodePlaceHolder: 'Введите код паузы',
    cuttingToolMaxDepthTip: 'Максимальная глубина обработки {errKey} ножа в библиотеке ножей не может быть больше длины ножа',
    cuttingParams: {
      title: 'параметры резки',
      stationWidth: 'ширина станка',
      stationWidthTip: 'При использовании крупных панелей из остатков расположение мелких панелей по ширине допускается только в заданном диапазоне размеров',
      holeSlotMainSide: 'концентратор отверстия',
      holeMainSide: 'концентратор отверстия',
      slotMainSide: 'концентратор паза',
      workPriority: '(Функциональный приоритет: Настройка поверхности обработки специального отверстия > Расположение пробивного отверстия следует за непробиваемым отверстием на этой пластине > Специальные отверстия, установленные в шунте отверстия, имеют приоритет на лицевой стороне большой пластины > концентратор отверстия > концентратор отверстия)',
      holeSlotSet: 'Параметры обработки в прорезях',
      hingeRollWork: 'Выпрямитель и отверстие в шарнирном стакане для обработки на обратной стороне большой пластины',
      followWork: 'Пробиваемые отверстия следуют за панелью без отверстий.',
      autoMatchSide: 'Пропорционально распределить положительное и отрицательное отверстие',
      backHSRate: 'Доля отверстий с обратной стороны',
      matchTip: 'Эта настройка не сработает ни на высокой световой панели, ни при включении схемы набора для вычисления фасонов, ни при подборе рисунка.',
      specIalHoleAndSlotSurface: 'Настройка поверхности обработки специальных отверстий',
      specialRuleTip: 'Выберите специальные отверстия',
      specialSlotsHoles: 'Тип отверстия',
      holeType: 'Тип отверстия',
      specialRules: 'правило',
      normalHole: 'Обычное отверстие',
      normalSlot: 'Обычный паз',
      holeDiam: 'Диаметр отверстия',
      slotLongSide: 'Длина паза',
      slotShortSide: 'Короткая кромка паза',
      FixedmachSurface: 'неподвижная поверхность обработки',
      deleteRuleTip: 'Исключить ли это правило',
      blankFront: 'Большой фасад',
      blankBack: 'Обратная сторона большой доски',
      addRules: 'Добавить правило',
      addRulesTip: 'Когда одна и та же доска попадает в несколько правил, правило, которое имеет самый высокий серийный номер, может перетаскивать любую строку, чтобы изменить порядок правил',
      highGlossSetting: 'Настройка световой панели',
      heighGlossFront: 'При наборе листы расположены на больших досках.',
      highGlossPlankNoRotate: 'Панель с высоким блеском не вращается',
      highGlossAutoRoll: 'Автоматизированное опрокидывание больших пластин только с обратными отверстиями',
      highGlossAutoRollTip: "<span class='color-o-4'>(После включения только большие доски с обратными отверстиями и отверстиями автоматически переворачиваются при размещении, становятся односторонними досками. Используйте вместе с данными имени файла \"Высокоразрядный откидной лист\")</span>",
      customHighGlossReverse: 'Высокоразрядный откидной лист',
      sideSlotPut: 'Размещение в боковой канавке',
      optimize: 'Функциональная оптимизация.',
      sysDefault: 'Система по умолчанию',
      plankInSide: 'Внутренняя сторона большой доски',
      plankOutSide: 'Внешняя сторона большой доски',
      specialNotWork: 'Эта функция не работает на фасонных панелях.',
      commonSide: 'Совместная резка',
      commonSetting: 'Общие настройки',
      plankThickRange: 'Толщина листов меньше равной',
      useCommonSide: 'При совместном обрезании',
      zeroTip: 'Разрыв между наборами должен быть изменен вручную на 0, обработан до разрезанной стороны, когда поднять нож через эту сторону, эта функция включена, не будет поддерживать обработку наклонного ножа, обратите внимание!',
      useTip: 'После включения этой функции обработка наклонного ножа не будет поддерживаться, обратите внимание!',
      commonSpeed: 'Комбинированное ускорение',
      highSpeed: 'Скорость фрезерования',
      min: 'минута',
      notWorkTip: 'Когда обработка листов соответствует общей обрезке, общее ускорение не вступает в силу',
      changeStartPoint: 'Двойное переключение начальной точки',
      changeStartPointTip: 'При включении двумерного переключения начальной точки, несовместимого с функцией обмена осями XY, используйте осторожно',
      flatOffset: 'смещение в плоскости станка',
      xRowChange: 'Коррекция координат по оси X',
      bigplankPointChange: 'Точка отсчета координат',
      reverseXRowChange: 'Координаты X',
      changebigplankPointTips: 'Включение этой функции несовместимо с функцией « Обмен осями XY, переключение точек начала с двумя станциями», используйте ее с осторожностью',
      reverseYRowChange: 'Коррекция Y - координат',
      plankMirrorTip: 'Используйте эту функцию при зеркальном отображении листов, обработанных на открывающей машине',
      notSameSize: 'Двухместный стол разных размеров',
      maxSize1: 'Максимальный размер.',
      notSameSizeTip: 'После включения двух рабочих столов разных размеров, функция объединения с двумя рабочими документами несовместима, используйте осторожно',
      maxSize2: 'Второй максимальный размер',
      autoSelectTip: 'Двухпозиционное оборудование, два рабочих стола разных размеров при использовании этой функции автоматически выберет соответствующее место для обработки больших панелей',
      bigFlatLimit: 'Большие рабочие места обрабатывают только большие панели, которые не могут быть обработаны небольшими рабочими местами:',
      surplusSetting: 'Параметры остатка',
      surplusPosition: 'Место расположения излишков',
      cutHoleWay: 'Порезка',
      knifeFlat: 'Противоположный базис',
      flat: 'столешница',
      plankFlat: 'Большая поверхность',
      freeHeightZ: 'Высота Z в свободное время',
      relativeHeight: 'Относительно большая высота верхней поверхности',
      cutDeepZ: 'Проницаемость Z глубина',
      cutDeepH: 'способ перфорации через отверстие',
      setDisableDoubleSidedThroughHole: 'Параметры не вступят в силу',
      addHolesToRulesDisableDoubleSided: 'После добавления соответствующих сквозных отверстий (отверстий насквозь) в правила ниже, переворот дважды для пробивки не вступит в силу',
      onceThrough: 'Пробей один раз.',
      rollThrough: 'Перевернутый дважды.',
      cutDeepS: 'Пробиваемый способ',
      plankCutDirection: 'Направление разреза листов',
      clockDirSwitch: 'Настройка направления фрезерных отверстий / внутренней фасонной резки',
      millHoleSlotDir: 'направление фрезерных пазов',
      millInternalCurveDir: 'направление внутренней фасонной резки',
      sDirection: 'по часовой стрелке',
      nDirection: 'против часовой стрелки',
      curveReplenish: 'Директива по дуговой вставке',
      curveReplenishTip: 'Эта функция может быть выбрана при появлении зазубренных дисков',
      noGen: 'Не генерировать инструкции G17 / G18 / G19',
      arcInstruction: 'Префикс команды дуговой вставки',
      example: 'Примеры',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'Дуговая резка обозначена I и J.',
      coverRate: 'Коэффициент перекрытия при фрезеровании составляет:',
      roughTip: 'Используйте эту функцию, когда внутри канавки остаётся заусенец.',
      clearCurve: 'Неоткрытые при фрезеровании пазы автоматически очищают закругленные углы:',
      curveUseTip: 'При фрезеровании канавки необходимо очистить закругленный угол, выберите эту функцию, обратите внимание, что она не работает на соединении',
      slotCutWay: 'фрезерный режим подачи',
      outToIn: 'Выфрезерование канавок изнутри',
      inToOut: 'Фрезерный желоб изнутри наружу',
      zShapProcess: 'верхний и нижний Z - образные фрезерные пазы',
      zShapProcessTip: 'Только для переднего и заднего вытягивания канавки действует, скорость перекрытия пути ножа по умолчанию радиус ножа',
      zSlotCuttingOverlapRate: 'Z - образная фрезерная канавка',
      zSlotCuttingOverlapRateTip: 'Текущая скорость перекрытия может привести к замедлению обработки, пожалуйста, проверьте машину после переработки.',
      slotWorkLimit: '(Действует только в том случае, если слой фрезы > 1)',
      minKnifeChange: 'Уменьшение количества смен инструмента при обработке',
      preventBreakage: 'Предотвращение облома перемычки краевого паза',
      preventBreakageTip: 'Эта настройка действует только для пазов на лицевой стороне при раскладке и может использоваться вместе с функцией «Настройка поверхности обработки специальных отверстий»',
      preventBreakageTip1: 'Может решить ситуацию, когда паз слишком близко к краю панели, и перемычка (оставшаяся соединительная часть) в этом месте легко ломается из‑за концентрации напряжений при резке',
      preventBreakageDistance: 'Расстояние от края панели',
      preventBreakageLength: 'Длина прикромочного участка',
      preventBreakageSlot: 'пазы',
      preventBreakageCutDeep: 'Глубина первого реза',
      workSpeedOp: 'Оптимизация скорости обработки',
      obliqueCut: 'Наклонить нож при резке',
      obliqueCutTip: 'Когда толщина плиты не указана, она действует для всех плит с толщиной меньше',
      obliqueThickLabel: 'Пользовательская эффективная толщина наклонного реза',
      obliqueThick: 'Изменение толщины наклонного реза',
      backObliqueThick: 'Изменение толщины наклонного реза',
      effectiveThickness: 'Эффективная толщина',
      effectiveThicknessTip: 'Эффективная толщина не может быть пустой, пожалуйста, введите!',
      effectiveThicknessDuplicateTip: 'Эффективная толщина не может повторяться, измените значение',
      obliqueCutData: 'Расстояние наклонного врезания',
      backOblique: 'Наклонение боковой кромки',
      obliqueSpeed: 'Скорость наклона',
      obliqueSpeedTip: 'Скорость наклона',
      arcSpeed: 'Скорость обработки кривых',
      cuttingPreDistance: 'Расстояние до выхода ножа',
      backKnife: 'редуктор резания',
      openKnifeSpeed: 'Скорость захвата',
      retractionCompensation: 'компенсация расстояния резания',
      retractionCompensationTip: 'Максимальное 20',
      cutCornerSlow: 'замедление по углу резки',
      addRow: 'добавленный',
      bettwenDistance: 'Расстояние до и после поворота',
      cuttingSpeed: 'Скорость резания',
      stepCutting: 'Слойная резка',
      splitSlot: 'Дважды разрезать.',
      splitPlank: 'Порезать доску дважды.',
      splitPlank2: 'Отрежьте доску дважды.',
      minSafeThick: 'Толщина больше',
      splitPlankTip: '(Эта функция не действует на фасонных панелях)',
      splitPlankTip2: '(Несовместимо: компенсация резания)',
      cutPlankMethod: 'Метод резки панели',
      cutPlankMethodTip: 'Резка четырех сторон дважды',
      cutPlankMethodTip2: 'Резка только последнего края дважды',
      specialShapCut: 'Отрезать фасонную пластину дважды',
      specialShapCutTip: '(После включения все фасонные панели разрезаются дважды)',
      bridgeRetention: 'Метод мостиков с точками удержания',
      bridgeRetentionTip: '(Примечание: 1. Эта функция временно не поддерживает внешние фасонные панели. 2. Не поддерживает наклонную подачу ножа. 3. Минимальный размер детали для создания соединительного мостика — 30 мм.)',
      bridgeRetentionDesc: 'Помогает устранить вибрацию или смещение плиты, когда внутри много вырезов и траектории резки не хватает опоры.',
      bridgePunchArea: 'Площадь сквозной вырезки превышает общую площадь',
      bridgeSize: 'Размер мостика',
      bridgeGenMethod: 'Способ генерации',
      bridgeAddTip: 'Можно добавить не более 10 записей',
      bridgeCount: 'Количество мостиков',
      bridgePlankLength: 'Длина плиты (L)',
      maxWH: 'Длина или ширина меньше',
      areaLimit: 'Площадь меньше',
      secondDeep: 'глубина второй резки',
      splitPlankThickSetting: 'Настройка слоистой резки',
      saveCustomSpeedTip: 'Скорость обработки не может быть пустой.',
      saveLayeredCuttingTip: 'Сумма трех стратифицированных разрезов должна быть равна толщине пластины.',
      saveLayeredRepeatTip: 'Слойная резка открытого материала не рекомендуется, чтобы толщина свойства высокого света одного и того же материала устанавливала разные слои данных, пожалуйста, удалите лишние данные!',
      splitPlankThick: 'Толщина слоя различных пластин',
      movePlankSetting: 'Настройка панели защиты',
      newCutSequence: 'Новый алгоритм резки',
      newCutSequenceText: 'По умолчанию самое сильное вакуумное всасывание в центре большой пластины, последняя резка этой области',
      positionTip: 'Нажмите на соответствующую область, чтобы выбрать',
      suctionPosition: 'вакуумное положение тяги',
      strongArea: 'зона сильного всасывания',
      minSuctionPlank: 'Минимальная всасываемая пластина',
      safeWidth: 'ширина',
      safeHeight: 'длина',
      safeTip: 'Если мы не сможем отсосать пластину, мы сначала разрежем ее.',
      scattered_layout: 'Дисперсионный набор листов',
      lastCutPointEnable: 'Настройка точки входа последней вырезаемой детали на большом листе',
      lastCutPointEnableTip: 'При включении точка входа последней вырезаемой детали на каждом большом листе будет генерироваться по заданной позиции точки',
      lastCutPoint: 'Положение точки входа',
      lastCutPointTip: 'При включении последняя вырезаемая деталь на каждом большом листе будет использовать эту точку входа',
      leftTop: 'Верхний левый',
      rightTop: 'Верхний правый',
      leftBottom: 'Нижний левый',
      rightBottom: 'Нижний правый',
      specifyTheMaterial: 'Назначенный материал',
      shapeSecondCutenable: 'Вторичная резка фасонных пластин',
      addMaterial: 'Добавить материал',
      plankMaterial: 'Материал панели',
      specifyTheMaterialTip: 'Функция вторичной резки вступает в силу после включения панелей, удовлетворяющих материалу формы',
      dispersePaibanTipOne: 'После включения на каждой большой доске будет по крайней мере одна пластина, соответствующая минимальному размеру всасывания.',
      dispersePaibanTipTwo: '2) Обратите внимание, что после использования может увеличиться количество пластин',
      totalThickLimit: 'Сумма тройной стратификации должна быть равна толщине пластины.',
      offsetFollowStep: 'Ремонт также сопровождается слоистой резкой.',
      longPlankTip1: '1. После включения или отключения этой функции записи раскладки, сохранённые в истории, при загрузке NC требуют повторной раскладки',
      longPlankTip2: '2. После включения этой функции необходимо установить код паузы вакуумного насоса в разделе «стыковка с открытой загрузкой — Вакуумный насос выключен», иначе не удастся решить проблему изгиба длинной пластины при резке',
      longPlankTip3: '3. Включённые ниже условия фильтрации проверяются последовательно по уровням; только панели, соответствующие условиям фильтрации предыдущего уровня, могут перейти к условиям фильтрации следующего уровня для оценки.',
      secondCutting: 'Объект вторичной резки',
      normalPlank: 'Обычная доска',
      normalPlankTip: 'Обычные панели: панели для дверей, не относящихся к шкафу, такие как поперечные и вертикальные перегородки в шкафу, и панели, добавленные непосредственно в список открытых материалов',
      designatedTarget: 'Указанные объекты',
      filterLevel1Label: 'Фильтр 1 уровня',
      filterLevel1Category: 'тип панели',
      filterLevel2Label: 'Фильтр 2 уровня',
      filterLevel2Category: 'ограничение размеров',
      filterLevel3Label: 'Фильтр 3 уровня',
      filterLevel3Category: 'прочее',
      specifiedBoardForceEnable: 'Игнорировать размер/другие фильтры, принудительно включить',
      curveMaterialFilterTip: '(После выбора «Фигурная панель» панель должна быть фигурной до фильтрации по материалу)',
      cuttingSettings: 'Настройки резки',
      plankSizeLimitSuffix: ' панели',
      specifiedBoard: 'Укажите имя панели для резки',
      specifiedBoardTip: 'После открытия, когда имя панели содержит имя панели, добавленное ниже, вступает в силу вторичная резка',
      addPlankName: 'Добавить имя панели',
      plankNameEmpty: 'Имя панели не может быть пустым, введите',
      plankNameRequired: 'Пожалуйста, добавьте хотя бы одно имя панели',
      plankLongLimit: 'Когда длинные края превышают',
      plankShortLimit: 'Краткое превышение',
      cuttingSplit: 'Разделить на две части',
      longExpand: 'Выбросы при первой резки: выбросы при длинной кромке',
      firstExpand: 'Первый разрез',
      longExpandTip: 'Длиннобоковой выброс',
      longLimit: 'Длинное превышение',
      cuttingSplitTip: 'Условия двухкратной резки длинных пластин',
      shortExpand: 'Краткобоковой выброс',
      expandTip: 'Длинные / короткие боковые размеры увеличены на X мм, а длинные и короткие боковые выбросы - на длинные края',
      pumpOffWay: 'Режим вакуумного закрытия',
      afterOnePlank: 'После резки одной длинной пластины',
      afterAllPlank: 'После того, как разрезать всю доску',
      numberFixed: 'Число зарезервированных десятичных знаков',
      bufferCode: 'Настройка буферной команды',
      layoutGap: 'Настройка промежутка между наборами',
      layoutGapTip: 'Примечание: Разрыв между наборами, установленный на 0, может перекрываться',
      wasteCutting: 'Автоматическое удаление отходов',
      zkPointCustomize: 'Настройка опорной точки вращения для обработки наклонных отверстий Z',
      sawSetting: 'Параметры пилы',
      cuttingLimit: 'Размер отсечения больше',
      waste: 'Отходы',
      wasteSizeLimit: 'Минимальный размер не должен быть меньше 100 мм.',
      topLeft: 'Слева, сверху.',
      topLeftD: 'левый верхний угол',
      bottomLeft: 'Слева, внизу.',
      bottomLeftD: 'Нижний левый угол',
      topRight: 'Справа, сверху.',
      topRightD: 'Верхний правый угол',
      bottomRight: 'Справа, внизу.',
      bottomRightD: 'Нижний правый угол',
      firstTime: 'первый раз',
      secondTime: 'Второй раз',
      thirdTime: 'Третий раз',
      startCutting: 'Начинается резка',
      thickRange: 'Толщина ≥',
      longCut: 'Длиннолистовая обработка',
      edgeSetting: 'Настройка кромки',
      cuttingOrder: 'Порядок резки:',
      cuttingOrderTip: 'Этот способ сопряжен с риском беговой доски, используйте его с осторожностью.',
      plankFirst: 'Сперва разрезать доску.',
      wasteFirst: 'Первичная резка отходов',
      offTip: 'При закрытии настройка кромки будет следовать параметрам резки',
      edgeCutDirection: 'направление обрезки',
      lGapTip: 'Положение расположения зазора на большой пластине L - образного остаточного материала автоматически регулируется в диагональном направлении цилиндра позиционирования, за исключением высокой остаточной пластины, и несовместимо с функцией обмена осями xy',
      cylinderDir: 'ориентация цилиндра',
      onlyLong: 'Только длинные края.',
      backCutOrder: 'Отрицательная последовательность обрезки',
      backFirst: 'На обратной стороне начинается ремонт.',
      backSecond: 'Обрезка задних отверстий',
      frontReCut: 'Перекройка фасада',
      frontReCutTip: 'Сделайте край цилиндра более гладким, чтобы не было следов.',
      useNewCut: 'Включить новые правила обрезки',
      newCutTip: 'Эта функция используется при двухсторонней обработке фасада с большим размером обрезки.',
      fixedTip: 'Примечание: количество зарезервированных цифр 0 или 1 может дублировать набор',
      cuttingSlow: 'Буферизация поверхности нижней пластины',
      holeSlow: 'Буферизация поверхности перфоратора',
      slotSlow: 'Буферизация поверхности пластин с вытяжными пазами / фрезерными отверстиями / фрезерными пазами',
      slowCode: 'Использование буферных команд',
      code: 'инструкция',
      bufferOffset: 'Смещение высоты буфера поверхности детали',
      zkRotatePoint: 'Точка опоры вращения',
      zkRotateDir: 'Увеличить направление угла вращения',
      restSizeLimit: 'Остальной размер меньше',
      useSaw: 'Использовать пилу',
      unGenSawPath: 'Не генерировать путь продольной резки пилы',
      suitMachine: 'Подходит для обработки полностью алюминиевых сварных пластин',
      plankBack: 'Задняя сторона большой доски',
      plankLeft: 'Большая доска слева',
      plankRight: 'Большая доска справа',
      plankFront: 'Большая передняя сторона',
      frontSide: 'Передняя сторона',
      backSide: 'Задняя сторона',
      rightSide: 'справа',
      leftSide: 'слева',
      singleMachineLimit: 'Односторонняя обрабатывающая панель спереди образует путь к обрезке и сначала ремонтирует кромку',
      singleMachineLimitTip: 'Универсальная машина, резка пилы не работает.',
      setBatchPositionWaring: 'Совет: Если вам нужно отменить быстрое изменение режима точки вниз, отмените галочку и измените кнопку вниз',
      setBatchPosition: 'Изменить точку сброса',
      setBatchPositionAs: 'Изменить направление ножа следующим образом:',
      activeBatchPosition: 'Выбрано {activePartCount} досок',
      specialFrontSide: 'Специальные отверстия, установленные в шунте отверстия, расположены спереди большой пластины.',
      rollCountTip: 'Расчет количества копий после включения шунтирования в соответствии с количеством обратных отверстий, фактически обработанных гравировальной машиной',
      specialFrontSideTip: 'Текущая производственная линия не поддерживает переключение производственной линии из - за открытия « специального отверстия, установленного в шунте отверстия, приоритетного расположения на передней части большой пластины» или « включения шунта отверстия в соответствии с фактической обработкой обратного отверстия в гравировочной машине»',
      doubleTrim: 'Двусторонняя обрезка',
      trim: 'Ремонт кромок',
      trimTwoSide: 'Ремонт обеих сторон',
      trimFourSide: 'Четыре стороны.',
      rightInmShow: 'Как показано на рисунке справа',
      currentTrimDir: 'Настройка края для текущего выбора',
      cylinderTip: 'Для установки цилиндров',
      onlyShort: 'Только короткие края.',
      singleTrim: 'Однопанельный путь к обрезке',
      hierarchyCutTwice: 'Слойная резка с вытяжными канавками',
      knifeDia: 'Размер ножа меньше равного',
      slotDeep: 'Глубина канавки больше равной',
      cutTwiceSlot: 'Когда, слоистый режущий желоб',
      twiceSlotDeep: 'Глубина разреза второго слоя составляет',
      cutTwiceCondition: 'Условия резки',
      zkPointCustomizeTip: 'Включение XY - осевого свопа приводит к противоположному направлению обработки и точке отсчета',
      zkPointCustomizeTip1: 'Устройство, открывающее своп оси xy, не работает',
      isCustom: 'Открыть настройку',
      useCutCon: 'Условия использования пилы',
      singleSetPlankSizeSpeed: 'Установите скорость обработки в диапазоне размеров',
      singleSetPlankSizeSpeedTip: '(1) При выполнении заданного ниже размера пластина обрабатывается с установленной скоростью обработки. Минимальная скорость вступления в силу, когда пластина соответствует нескольким правилам одновременно.',
      addSpeedRules: 'Добавить правило',
      speedRules: 'правило',
      shortSideSize: 'Короткие боковые размеры',
      lessThanEqual: 'Меньше чем равно',
      and: 'А',
      longSideSize: 'Длинный размер',
      processingSpeed: 'Скорость обработки',
      trimLenCompensation: 'Компенсация длины обрезки:',
      trimGenerateAPath: 'Изменить значение границы 0 без создания пути:',
      cuttingMethod: 'Способ резки',
      horizontalCutting: 'Горизонтальная резка',
      verticalCutting: 'Вертикальная резка',
      openKnifeDistance: 'Замедление расстояния'
      },
    labelingSettings: {
      title: 'Настройка метки',
      output: 'Файл автоматической метки вывода',
      specification: 'Формат файла',
      codeFrontGenerate: 'Автоматически загрузить код перед кодом метки',
      templateOffline: 'Использовавшийся шаблон вышел из строя!',
      templateNotSupport: 'Этот шаблон не поддерживается, выберите другой!',
      rollLabelling: 'Параметры наклейки',
      flipSetting: {
        title: 'Параметры поворота',
        engravingFlipProcess: 'Режим наклейки гравировальной машины',
        flipTip: 'Включите эту функцию, когда гравировальный станок должен быть перевернут.'
        },
      rotateSetting: {
        title: 'Параметры вращения вкладок',
        rotateTip: 'Включите условия вращения по требованию, если открывается одновременно, приоритет для вступления в силу выберите заданное значение',
        horizontal: 'Плита поперечная',
        vertical: 'Вертикальная сторона листов',
        either: 'Плиты поперечные или вертикальные'
        },
      countertopSetting: {
        title: 'Настройка рабочего стола',
        startPoint: 'начальная точка станции',
        upLeft: 'левый верхний угол',
        upRight: 'Верхний правый угол',
        downLeft: 'Нижний левый угол',
        downRight: 'Нижний правый угол',
        baseExchange: 'Коррекция координат',
        exchangeX: 'Настройка оси X',
        exchangeY: 'Коррекция оси y'
        },
      offset: 'Смещение координат',
      offsetTip: 'Общие координаты наклейки находятся в центре доски, некоторые устройства должны быть отрегулированы',
      label_rotate_offset: 'Смещение координат после вращения вкладки',
      label_rotate_offset_tip: 'При большой разнице в положении смещения до и после вращения вкладки необходимо настроить',
      label_rotate_offset_err_tip: 'Открывает вкладку после того, как координаты смещаются, координаты осей X и Y должны быть заполнены',
      imgSetting: {
        title: 'Параметры изображения',
        suffix: 'Суффикс изображения:',
        code: 'Режим кодирования изображений:',
        codeTip: 'PNG и JPEG синхронизируют изменения в форматах кодирования типографики, а встроенная облачная типография не поддерживает эту функцию.',
        imgRatio: 'Разрешение пиктограммы:',
        slowDown: 'Это снижает эффективность экспорта изображений с метками.',
        color: 'Настоящая красота',
        bit: 'чёрно-белый',
        resolution: 'Разрешение пиктограммы',
        resolutionPlaceholder: 'разрешение',
        labelPool: 'Пул тегов данных',
        showKey: 'Показать поле',
        dragTip: 'Можно перетаскивать вкладки внутри пула',
        labelImgName: 'Название изображения',
        labelImgNameErrTip: 'Имя метки не может быть пустым',
        labelTip1: 'При настройке [штрих - код панели] или [серийный номер метки] должен использоваться один из них, иначе возникнут проблемы с покрытием изображения',
        labelTip3: '【Серийный номер метки】 - это серийный номер строки сверху вниз в списке раскроя, и строка, добавленная на страницу компоновки, не имеет этих данных',
        labelTip2: '3. Шаблон системы не вступает в силу для этой функции',
        delimiter: 'Разделитель',
        inputTip: 'Не поддерживается ввод /: < >. "* Равнозначные символы',
        numStart: 'Начальное значение серийного номера',
        example: 'Пользовательское имя изображения наклейки (пример)',
        stockNumOffset: 'Номер большой доски',
        divideFolders: 'Изображения метки разделены на разные папки в зависимости от размера доски',
        foldersTip1: 'Примечание: 1 Эта функция не поддерживает использование с функцией « Объединение файлов распылителя »',
        foldersTip2: 'Эта функция еще не вступила в силу для встроенного облачного набора',
        stickIntoFolders: 'Вставить файл метки в папку изображений',
        stickTip1: 'Примечание: 1, эта функция должна использоваться в сочетании с функцией « Скачать тег попутного экспорта» NC',
        stickTip2: '2. Правила генерации файлов в используемом шаблоне наклейки должны быть выбраны для того, чтобы функция « Создание одного файла» вступила в силу;',
        stickTip3: 'Эта функция еще не вступила в силу для встроенного облачного набора'
        },
      pdfSetting: {
        title: 'Настройки PDF-этикетки',
        pdfLabelName: 'Имя файла PDF',
        example: 'Имя файла PDF с индивидуальными настройками (пример)',
        address: 'Адрес проекта',
        orderNo: 'Номер заказа',
        firstFolder: 'Первый уровень папки',
        customerName: 'Имя клиента'
        },
      paibanImgSetting: {
        title: 'Настройка типографики',
        tip: 'Открыт экспорт настраиваемой типографики, ниже фиксированный шаблон не может быть экспортирован, если вы хотите экспортировать, закройте экспорт настраиваемой типографики в дополнительных настройках',
        reparation: 'Серийный номер графика автоматически компенсируется',
        figure: 'бит',
        inputTip: 'Введите цифры 1 - 99.',
        paibanImg: {
          export: 'Экспорт типографики',
          prefix: 'Префикс типографии',
          size: 'Размер типографики',
          format: 'Формат типографики',
          directional: 'Направление типографики',
          vertical: 'вертикальный',
          horizontal: 'Горизонтальный'
          }
        },
      autolabel: 'Автоматические настройки последовательности',
      customTemp: 'Вступление в силу только для пользовательских шаблонов',
      cuttingLabelOder: 'Маркировка в порядке вскрытия',
      labelToUp: 'Маркировка снизу вверх по результатам набора',
      labelToDown: 'Наклейка сверху вниз по результатам набора',
      labelDodge: 'Автоматическое устранение меток',
      nolabelForsurplus: 'Файл с наклейкой не создается',
      settingValue: 'Выберите заданное значение',
      enabelTip: 'После открытия, когда панель соответствует следующим заданным значениям, вкладка вращается',
      fixedHori: 'Выберите горизонтальную сторону вкладки, параллельную фиксированной стороне панели',
      fixedHoriTip: 'Вступает в силу только для нетактурных панелей, и при открытии этикетка вращается параллельно поперечной стороне этикетки и фиксированной стороне пластины',
      tagHori: 'Горизонтальная сторона метки',
      effectiveTarget: 'Объект вступления в силу',
      allPlank: 'Все доски',
      notcarePlank: 'Только без текстур.'
      },
    drillSettings: {
      title: 'Параметры бурения',
      enable: 'Включить дренажный пакет',
      toolTable: {
        use: 'Активировать',
        number2: 'Номер 2 - рядного бурения',
        number: 'Номер бурения',
        diameter: 'Диаметр долота',
        xOffset: 'Смещение X',
        yOffset: 'Смещение Y',
        moveZF: 'Скорость быстрого перемещения по оси Z',
        feedRate: 'Скорость обработки по оси Z',
        moveF: 'Скорость быстрого перемещения оси XY',
        benchmarkDrill: 'Базовое бурение',
        addKnife: 'Добавить нож',
        deleteKnife: 'Удалить нож'
        },
      prefix: 'Префикс дрели',
      suffix: 'Суффикс дрели',
      startCode: 'Код запуска дрели',
      endCode: 'Код окончания бурения',
      combineKnife: 'Коллективный нож',
      combineTable: {
        prefix: 'Префикс номера дрели',
        suffix: 'Суффикс номера бурения',
        mainHole: 'Главное отверстие',
        extraHole: 'Из отверстия',
        notes: 'Комбинированные примечания',
        firstUseNotes: 'Впервые включено примечание',
        addExtraHole: 'Добавить из отверстия',
        deleteExtraHole: 'Удалить из отверстия',
        example: 'Пример'
        },
      tagPool: {
        drillRowNumber: 'Номер бурения'
        },
      processSetting: {
        title: 'Параметры обработки',
        mode: 'Режим дренажной обработки',
        processTip: 'После выбора этого способа не вступает в силу функция дренажа',
        recentHole: 'Ближайшая перфорация (быстрая смена ножа)',
        groupHole: 'Перфорация по классам (смена ножей после завершения перфорации по классу)',
        drill_benchmark: 'Комбинированная опора под нож',
        drill_benchmark_Tip: '(Примечание: после выбора этого способа не вступает в силу функция бурения в комплекте)',
        mainHole: 'Главное отверстие',
        secondaryHole: 'Чтобы из отверстия (хвостовое отверстие)'
        },
      changeBenchDrillTip: 'Пожалуйста, введите номер бурения для этого выбора.'
      },
    NCExportSettings: {
      jumpSkipTip2: 'В зависимости от цвета и толщины большой доски, материал делится на разные папки (вместе с файлом с наклейкой), а файл с большой доской того же размера помещается в одну и ту же папку',
      title: 'Параметры экспорта NC',
      tab1: 'Настройка имени файла распылителя',
      tab2: 'Объединение имен файлов распылителя',
      tab3: 'Примечания в файле распылителя',
      tab4: 'Тип в файле открывателя',
      tab5: 'Папка открывающего устройства',
      tab6: 'Параметры команды обработки',
      tab7: 'Параметры формата файла',
      fileNameSettings: {
        twoStationAutoSort: 'двухпозиционная автоматическая сортировка',
        reparation: 'Номера больших номеров компенсируются',
        figure: 'бит',
        labelerBegin: 'Начинается маркировка',
        machineCenter: 'Центр обработки начинается',
        front: 'Положительный:',
        back: 'Обратная сторона:',
        customizeName: 'Пользовательское имя файла (формат):',
        example: 'Пользовательское имя файла (пример):',
        emptyTip: 'Идентификаторы положительных и отрицательных файлов не могут быть пустыми одновременно',
        labelPool: 'Пул тегов данных',
        dragTip: 'Можно перетащить или нажать кнопку Скопировать вкладку в поле ввода'
        },
      fileMerge: {
        engravingMerge: 'Объединение файлов распылителя',
        zfMerge: 'Положительное и отрицательное слияние',
        singleMerge: 'Объединение отдельных рабочих мест',
        doubleMerge: 'Двойное слияние',
        fEndCode: 'Код обратного конца',
        zBeginCode: 'Положительный код начала',
        displayfbInfo: 'Имя файла показывает положительную и отрицательную информацию',
        fBeginCode: 'Код обратного начала',
        zEndCode: 'Код положительного конца'
        },
      marginalNotes: {
        addPlankInfo: 'В начале открытого файла добавить информацию о текущей большой панели:',
        plankInfo: 'Большая информация:',
        addStationCodeFirst: 'В начале файла ввода добавить код станции:',
        addStationCodeSecond: 'Добавить код станции перед сменой ножа в открытый файл:'
        },
      fileType: {
        zAddtion: 'Z - координаты дополнены:',
        addSemicolon: 'Добавить запятую в конце строки NC:',
        semicolonTip: 'После галочки вступят в силу документы по обработке рога.',
        fileName: 'имя файла',
        defaultName: 'Имя файла по умолчанию',
        dedicatedName: 'Специальное имя файла устройства Starlight',
        xhNotes: 'Звёздный блеск E2 - 9 Комментарии',
        format: 'Файл выходной гравировальной машины',
        example: 'Пример файла: NC файл',
        stillGenerate: 'Обратный файл NC, содержащий обратный код окончания',
        generateTip: 'Эта функция не поддерживается с функцией объединения файлов',
        fileNameErrTip: 'Имя файла не может содержать ни одного из следующих символов: /: * "'
        },
      categorize: 'В зависимости от цвета, материала и толщины больших панелей классифицируются по различным папкам (вместе с файлами меток):',
      simplifyG: 'Краткое описание команды G',
      ZToW: 'Код переключается с оси Z на ось W.',
      knives: 'Штурмовой инструмент',
      lineBreakSetting: 'Параметры форматирования строк',
      codeFormatSetting: 'Параметры формата кодирования файлов',
      utf8bom: 'UTF - 8 с бомом',
      oneCodeSetting: 'Настройка штрих - кода',
      simplifyOneCode: 'Создание штрих - кода для тегов простого формата',
      codeLocation: 'Параметры расположения кода',
      generateLocation: 'Код конца рабочего места генерируется перед кодом конца с обратной стороны.',
      emergencySetting: 'Настройка на случай непредвиденных обстоятельств',
      show: 'Показать параметры аварийности',
      emergencyCode: 'аварийный код',
      params: 'параметр',
      emergencyTip: 'Некоторые функции могут быть реализованы в сотрудничестве с персоналом после продажи.',
      holeSetting: 'Параметры перфорации файла',
      holeFileCategorize: 'Размещение перфорированных файлов в отдельных папках по различным заказам',
      holeTip: 'Облачная типография клиента встроенного шкафа не работает',
      specialCodeErr: 'Не поддерживается ввод специальных символов!',
      copySuccess: 'Репликация удалась!',
      copyErr: 'Не удалось скопировать, попробуйте перетащить тег!',
      lengthLimit: 'Поддерживается ввод только 15 цифр!',
      plankInfo: 'Сведения о панелях',
      otherInfo: 'другая информация',
      uniqueBarCode: 'Уникальный штрих - код.',
      uniqueBarCodeForPack: 'Уникальный штрих - код для досок (специально для упаковки)',
      machineOrder: 'Загрузить имя файла Создать серийный номер обработки',
      folderSetting: 'Поместить файл в одну папку',
      labelImageINCFolder: 'Изображение с наклейкой следует за файлом с наклейкой в папке NC',
      custom: 'индивидуальный',
      folderSettingTip: 'Примечание: Встроенный набор временно не поддерживает эту функцию',
      settingMoveTip: 'Исходная функция "{func}" перемещена на страницу "{module}"!',
      fileManagerFunction: 'Размещение перфорированных файлов в отдельных папках по различным заказам',
      gotoSetting: 'Перейти к настройкам',
      singleFileTitle: 'Параметры обработки отдельных файлов',
      slectSingleProcess: 'Выберите отдельный процесс вывода',
      slectSingleProcessTip: 'Есть платные процессы вторичной обработки, удалите их и сохраните снова',
      setSingleRegularSize: 'Задать размер обычных отверстий и пазов для отдельного вывода',
      holeRange: 'Диапазон действия отверстия',
      slotRange: 'Диапазон действия паза',
      holeRangeTip: 'Диапазон действия отверстия не может быть пустым, заполните!',
      slotRangeTip: 'Диапазон действия паза не может быть пустым, заполните!',
      yhzc: 'Прямой паз на дугообразном участке',
      xbgy: 'Скошенный угол Haitang и скошенная ручка',
      nbyx: 'Внутренняя нестандартная форма',
      secondaryProcessingMerge: 'Объединение файлов вторичной обработки',
      secondaryProcessingMergeName: 'Имя объединённого файла',
      secondaryProcessingMergeTip: 'При включении, если у экспортируемой плиты несколько процессов вторичной обработки, они будут объединены в один файл',
      singleFileSetting: 'Выход отдельных файлов обработка наклонной стороны',
      straightArcSlot: 'Вывод отдельного файла в прямое отверстие'
      },
    aioMachineSetting: {
      openFunction: 'Стыковка должна включать следующие функции.',
      openCarving: 'Включите гравировальную машину.',
      xyReverseFunction: 'Функция обмена осями XY',
      carvingStartSet: 'Начальная точка установки гравировочной машины установлена как',
      rightTop: 'Верхний правый угол',
      carvingEdgeSet: 'Перекройка передней части гравировальной машины',
      finalEdgeSame: 'То же, что и общий ремонт.',
      beginCode: 'Код начала программы',
      endCode: 'Код окончания программы',
      drillHole: 'пробивать отверстие',
      pullTrough: 'Вытягивание канавки',
      showDataTemp: 'Показать примеры данных',
      dataTemp: 'Примеры данных',
      title: 'Настройка единой машины',
      outputFile: 'Экспорт файлов',
      outputFileTips: 'Некоторые бренды единой машины, с обменом XY, слияние файлов, не пробивание профиля отверстия несовместимо, пожалуйста, используйте осторожно',
      fileType: 'Формат файла',
      select: 'Пожалуйста, выберите',
      diameter: 'Диаметр обрезного инструмента',
      jidongTip: 'Используйте полярную машину, пожалуйста, установите точку начала работы гравировальной машины в правом верхнем углу и включите функцию А.',
      skill: 'функция',
      clampHandLength: 'Длина зажима (l)',
      clampHandWidth: 'Ширина зажима (W)',
      clampHandMargin1: 'Зажим руку 1 от края (H1)',
      clampHandMargin2: 'Зажим руки 2 от края (H2)',
      duchClampHand: 'Отверстие',
      clampHandDirection: 'Направление зажима',
      left: 'слева',
      right: 'справа',
      top: 'Верхняя сторона',
      bottom: 'Нижняя сторона'
      },
    oneDragTwo: {
      title: 'Два гравировальных станка.',
      outputMachineFile: 'Выход, перетаскивание, обработка документов',
      outputMachineFileTips: 'Включите перетаскивание двух гравировочных машин после того, как функция объединения с файлом открывающей машины несовместима, используйте осторожно',
      fileType: 'Формат файла',
      select: 'Пожалуйста, выберите',
      machineStart: 'начальная точка станции',
      positionClose: 'При закрытии будет следовать настройке начала рабочего места в параметрах резки',
      engravingPlus: 'Скоростная гравировальная машина'
      },
    sawEngraving: {
      title: 'Пило - гравировальный станок',
      preLayNav: 'Настройка пилорамы',
      preLayKnifeInput: 'поперечный диаметр пилы',
      enableSaw: 'Включить резьбонарезную машину',
      sawAioTip: 'У вас нет разрешения на вывод данных для сварной панели AIO. Обратитесь в отдел продаж для подключения функции.',
      cutSet: 'Параметры резки сварных пластин',
      weldingPlank: 'Сварная пластина',
      doorFrame: 'Дверной каркас',
      doorFrameTip1: 'Радиус пилы должен быть меньше или равен толщине пилы',
      doorFrameTip2: '2.Не поддерживается нестандартная компоновка пластин 3.Автоматическое пространство для компоновки',
      sawUsing: 'Использование пил',
      trim: 'Ремонт кромок',
      cutBlank: 'Вырезание',
      backTrimOblique: 'Обработка обратной кромки',
      holeSlotOblique: 'Ремонт отверстий',
      plankThicknessUnit: 'Единица толщины доски',
      sawUseCond: 'Условия использования пилы',
      exportPartData: 'Вывод файлов данных на панели (ban, mpr, xml и т.д.)',
      sawAioTip2: 'Подходит для пиломатериалов без копирования',
      hasUsing: 'Используйте доступный путь.',
      onlyUse: 'Использовать только тогда',
      cutMethod: 'Режим резки',
      oneKnifePull: 'Один нож пробил большую доску.',
      onlyOneKnifePull: 'И только после этого протянул нож.',
      enableSawThick: 'Включить толщину пилы',
      edgedDir: 'Закрытый край',
      sameWidthPart: 'На каждой доске только одна и та же ширина.',
      emptyPath: 'При резке не создается пустой путь',
      sawUsePlank: 'Сварные пластины обрабатываются пилами.',
      paibanGap: 'Разрыв между наборами сварных пластин',
      minSurplusWidthDiff: 'Минимальная разность по ширине совпадения',
      minSurplusWidthDiffTip: 'Только если разница в ширине между пластиной и остаточным материалом меньше этого значения, пластина будет расположена на остаточном материале',
      sawReplaceEnable: 'Путь резания прямой пилой заменен пилой',
      minSawLength: 'Минимальное расстояние для замены пилой',
      keepDistance: 'Расстояние между последовательно расположенными более широкими листами для пути резания прямой пилой',
      keepDistanceTip: 'Примечание: оставьте достаточное пространство, чтобы избежать разрезание соседних досок',
      sortByLength: 'Сортировать по длине листов',
      sortByLengthTip: 'Направление разреза - это последовательное разрезание снизу вверх, ряды - сначала по ширине, а затем по длине',
      plankAtTop: 'Небольшая доска наверху.',
      plankAtBottom: 'Маленькая доска внизу.',
      useSawTipOne: 'После включения только небольшие пластины с свойствами сварной пластины в шкафу будут обрабатываться пилой, а не сварной пластиной, чтобы разрезать прямой нож',
      useSawTipTwo: 'При использовании « настраиваемого порядка сортировки больших пластин» после включения сварные пластины не будут печататься с использованием стандартных больших пластин, будут использоваться только специальные большие пластины',
      useSaiTipThree: 'После включения этой функции необходимо использовать пиломатериалы',
      surplusStoreAndLabeling: 'Отрезанные остатки могут храниться и печататься на этикетках',
      surplusMinLength: 'Минимальная доступная длина остатка',
      surplusMinSize: 'Минимальный размер остатка',
      crossCutOnlyMinSurplusSize: 'Путь поперечного реза будет создан только при достижении минимального размера остатка',
      surplusStoreAndLabelingTip: 'В верхней или нижней части большой пластины образуется голубая зона остаточного материала, которая может быть нормально складирована и напечатана на этикетке',
      surplusStoreAndLabelingTip2: '2, сварочные пластины не вступят в силу функция "автоматической обрезки остатков")',
      surplusStoreAndLabelingTip3: '(После включения',
      backCutSurplus: 'Обратный отсек',
      cutSurplusTip: 'После включения установите порядок обрезки на обратной стороне как "после обработки отверстия на обратной стороне".',
      top: 'сверху',
      bottom: 'Внизу.',
      left: 'Слева.',
      right: 'справа',
      dockTip: 'Для обработки стыковочных сварных пластин требуется прямоугольная пластина с четырехсторонней обшивкой, как и общая обрезка, и ручное управление в однорядном наборе',
      sawToLayoutTip: 'При включении этой функции в комплекте между панелями зарезервированы только разрезные швы толщиной пилы.',
      sawToLayoutTip2: 'Пильный набор временно не поддерживается',
      tempPaiabanTip: 'После включения резки пилы не поддерживается добавление фасонных панелей непосредственно в набор, если вы хотите добавить, перейдите к списку открытых материалов для добавления и сортировки!',
      generateCutSurplusPath: 'Создать поперечный путь для первого отсечения остатков',
      curSurplusPathTip: 'После включения установите порядок обрезки на обратной стороне как "после обработки отверстия на обратной стороне".'
      },
    robotArmDocking: {
      autoLine: 'Автоматическая линия стыковка',
      autoLineTip: 'У вас нет разрешения на использование автоматических линий или количество автоматических линий, которые вы можете открыть, недостаточно',
      title: 'стык манипулятора',
      enable: 'Включить стыковку манипулятора',
      enableTip: 'После открытия, при выходе производственного документа, выдается стыковочный файл манипулятора'
      },
    laserCuttingMachine: {
      title: 'лазерная машина',
      enable: 'Включить лазерную машину.',
      backSafeHeight: 'Высота Z при отрицательном свободном режиме (H)',
      laserDistance: 'Расстояние между положительным и отрицательным лазерным ножом и поверхностью пластины при резке',
      coordinateAxis: 'Координатная ось',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Настройки резки',
      backKnifeStore: 'Резцовый склад',
      noSupportOriginalMaterialKnife: 'Временно не поддерживается функция « Выбор оригинального ножа для разгрузки»',
      laserKnifeTip: 'Раскрытие: для обработки непробиваемых форм внутри',
      laserKnifeTip2: 'Лазерный нож: обработка пробитого желоба, внутренняя фасада, наружная раскраска профиля колеса',
      laserKnifeTip3: 'Примечание: обратная ось Z по умолчанию использует относительные координаты, соответствующие расстоянию от стола',
      laserKnifeTip4: 'Нож не может быть меньше одного.',
      laserKnifeTip5: 'Нельзя удалить нож.',
      laserKnifeTip6: 'Обнаружено отсутствие крючка, выберите хотя бы один.',
      laserKnifeTip7: 'Лазерный нож не может обрабатывать внутреннюю непроницаемую форму, автоматически отменяет галочку « раскройки»',
      laserKnifeTip8: 'В ножевой библиотеке выберите инструмент с опцией « открывать», иначе невозможно обработать внутреннюю непрорезанную фасон',
      laserKnifeTip9: 'диаметр лазерного ножа и диаметр лазерного ножа лазерного блока не совпадают, проверьте',
      laserKnifeTip10: 'диаметр разгрузочного ножа и диаметр разрезного ножа лазерной машины не совпадают, проверьте',
      laserKnifeTip11: 'Параметры стыковки оборудования изменены, пожалуйста, переформатируйте',
      noLaserPermission: 'Без разрешения на использование лазерной машины, пожалуйста, свяжитесь с продавцом, чтобы купить разрешение на использование лазерной машины после использования',
      laserOpenCode: 'Код открытия лазера',
      laserCloseCode: 'Код закрытия лазера',
      laserToolSettings: 'Параметры лазерных ножей'
      },
    firstSave: 'Убедитесь, что пользователь впервые использует облачную типографию, после сохранения настроек обратите внимание, является ли направление ремонта в файле разумным, чтобы избежать ненужных потерь',
    knives: {
      xOffset1: 'Смещение координат X',
      yOffset1: 'Смещение Y - координат',
      zOffset1: 'Смещение координат Z',
      insert: 'Вставить строку',
      delete: 'Удалить строку',
      tip: '(Примечание: После внесения изменений в информацию о библиотеке ножей или настройки настроек пользователям, производящим типографию в шкафу, необходимо перезагрузить клиент шкафа, чтобы применить последние изменения!)',
      number: 'номер',
      name: 'название',
      diameter: 'Диаметр ножа',
      sawDiameter: 'Толщина пилы',
      cutting: 'Раскрой.',
      use: 'использование',
      moveZF: 'Скорость быстрого перемещения по оси Z',
      axis_offset: 'Смещение оси',
      arc_radius: 'радиус дуги',
      cutZF: 'Скорость обработки по оси Z',
      moveF: 'Скорость быстрого перемещения оси XY',
      cutF: 'Скорость обработки оси XY',
      startCode: 'Код начала смены ножей.',
      stopCode: 'Код окончания смены ножа',
      startCode2: 'Код начала смены ножа 2.',
      stopCode2: 'Код окончания смены ножа 2.',
      knifeLength: 'Длина ножа',
      maximum_single_depth: 'Максимальная глубина однократной обработки',
      specialShapeKnifeTip: 'Действует только для внутренних инопланетян.',
      preStartCode: 'Код предварительного запуска',
      punchHoles: 'пробивать отверстие',
      pullSlots: 'Вытягивание канавки',
      millHoles: 'Фрезерное отверстие',
      millSlots: 'Фрезерный желоб',
      sawBlade: 'Пильное полотно',
      doubleSaw: 'Включить двухпозиционный код начала смены ножей',
      singleStation: 'Единый пост',
      doubleStation: 'Двойной пост',
      sawBladeTip: 'Эта функция не работает для буксировки двух гравировочных машин и одной машины.',
      serialNum: 'номер',
      sawWidth: 'Ширина ножа',
      sawType: 'Тип пилы',
      cutDirection: 'Направление резания',
      moveSpeed: 'Пустая скорость',
      cutSpeed: 'Скорость обработки',
      endCode: 'Код окончания смены ножа',
      sawDownCode: 'Код ножа',
      sawUpCode: 'Код захвата',
      abscissa: 'Префикс горизонтальных координат',
      ordinate: 'Префикс продольных координат',
      sawHor: 'Поперечная пила',
      sawVer: 'Продольная пила',
      towardsZero: 'Вырезать 0 координат',
      awayFromZero: 'Удаление от 0 координат',
      diameterDesc: 'Диаметр ножа',
      xOffset: 'Горизонтальное смещение координат',
      yOffset: 'Продольный сдвиг координат',
      zOffset: 'Смещение координат высоты',
      offsetX: 'Смещение X',
      offsetY: 'Смещение Y',
      offsetZ: 'Смещение Z',
      offsetNo: 'Номер смещения',
      knifeWidth: 'Ширина ножа',
      drill: 'Нож.',
      cut: 'обработка',
      speed: 'скорость вращения',
      type: 'тип',
      millHoleSlot: 'Фрезерные отверстия / пазы',
      rapidFeedSpeed: 'Скорость быстрой подачи',
      typeOption1: 'сверло',
      typeOption2: 'фреза',
      typeOption3: 'Стильный нож',
      typeTip: 'Установите тип инструмента, задний отверстие будет соответствовать соответствующему типу инструмента для обработки'
      },
    other: {
      title: 'другие',
      tip: '(Примечание: однопозиционное оборудование должно заполнять один и тот же код автоматической загрузки как для рабочего места 1, так и для рабочего места 2)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'Больше настроек',
    sideStartCode: 'Обработка спереди для создания кода переключения',
    useArcCode: 'Директива о вставке дуги',
    coordSwitch: 'Коррекция координат',
    updownCoordSwitch: 'Коррекция координат высоты',
    xCoordSwitch: 'Горизонтальная настройка координат',
    yCoordSwitch: 'Вертикальная коррекция координат',
    knifes: {
      number: 'номер',
      diameter: 'Ширина ножа',
      type: 'тип',
      moveSpeed: 'Скорость быстрой подачи',
      doSpeed: 'Скорость обработки',
      startCode: 'Код начала смены ножей.',
      endCode: 'Код окончания смены ножа'
      },
    ymSetting: 'Параметры подключения',
    flanking: 'Боковая обработка',
    frontProcess: 'Положительная обработка',
    oldSetting: 'Настройки старой версии',
    equipParamsSetting: 'Параметры устройства',
    holeSetting: 'Параметры перфорации',
    raminoSetting: 'Параметры подключения Ramino',
    mortiseTenonSetting: 'Параметры соединения',
    straight: 'Прямая сумма',
    eccentric: 'Эксцентричность',
    pbSize: 'Размер верхней и нижней поломки',
    slotOverlapRate: 'перекрытие фрезерных пазов',
    breakingBoardDirection: 'Вверх - вниз',
    coordinateValue: 'Значение координат',
    codeFormat: 'Формат кодирования файлов',
    suffixSetting: 'Параметры суффикса файла',
    insertRow: 'Вставить строку',
    deleteRow: 'Удалить строку',
    equipmentParams: {
      equipPauseCode: 'Код остановки устройства',
      wiggleCode: 'Колебание кода',
      equipStartCode: 'Код запуска устройства',
      flipPauseCode: 'Перевернутый код паузы',
      equipEndCode: 'Код окончания устройства',
      equipStartCodePlaceholder: 'Введите код запуска устройства',
      retractingCode: 'Код команды захвата',
      retractingCodePlaceholder: 'Введите код команды захвата.',
      flipPauseCodePlaceholder: 'Введите код паузы опрокидывания',
      equipEndCodeTip: 'Введите код конца устройства',
      sideChangeSetting: 'Параметры бокового переключения',
      workTip: 'Начать обработку по умолчанию слева ① против часовой стрелки',
      frontTurnCode: 'Сверху начинается код.',
      frontTurnEndCode: 'Код окончания сверху',
      frontTurnCodePlaceholder: 'Введите код начала.',
      frontTurnEndCodePlaceholder: 'Введите код конца.',
      leftTurnCode: 'Код начала слева',
      leftTurnEndCode: 'Код конца слева',
      leftTurnCodePlaceholder: 'Введите код начала слева',
      leftTurnEndCodePlaceholder: 'Введите код конца слева',
      downTurnCode: 'Ниже начинается код.',
      downTurnEndCode: 'Конец кода ниже',
      downTurnCodePlaceholder: 'Введите начальный код ниже',
      downTurnEndCodePlaceholder: 'Введите код конца',
      rightTurnCode: 'Код начала справа',
      rightTurnEndCode: 'Код конца справа',
      rightTurnCodePlaceholder: 'Введите код начала справа',
      rightTurnEndCodePlaceholder: 'Введите код конца справа',
      topFlipCode: 'Код опрокидывания - вверх',
      downFlipCode: 'Код поворота - вниз',
      leftFlipCode: 'Код поворота - слева',
      rightFlipCode: 'Код поворота - справа',
      cylinderOutCode: 'Код выпуска цилиндра',
      cylinderbackCode: 'Код возврата цилиндров',
      cylinderbackDirective: 'команда возврата цилиндров',
      moveDirective: 'Переместить команду',
      moveAxisCode: 'Переместить ось',
      pushAxisCode: 'вал толкателя цилиндра',
      swingAxisCode: 'Колебательный вал',
      moveCode: 'Мобильный код',
      punchCode: 'Код обработки',
      free: 'Пусто.',
      punchPart: 'Обрабатывающая часть',
      cutFaceCode: 'Обработка плоского кода',
      horVerCutFace: 'Горизонтальная продольная плоскость',
      horCutFace: 'плоскость поперечного подъёма',
      verCutFace: 'Вертикальная плоскость подъёма',
      specifySmallBoardMaterialNoCut: 'Выберите материал без',
      specifySmallBoardMaterialNoCutTip: 'Пластина, содержащая соответствующие ключевые слова в материале пластины, будет генерировать только пять или шесть поверхностей для обработки файла отверстия, без раскрутки',
      addMaterialKeyword: 'Добавить ключевые слова материала',
      keyword: 'ключевые слова'
      },
    tagPool: 'Пул тегов данных',
    dragTip: 'Можно перетаскивать вкладки внутри пула',
    knives: 'Обрабатывающий нож:',
    directives: 'Директива по обработке:',
    slot: 'Прямая обработка',
    cirWork: 'Дуговая обработка',
    cirInter: 'дуговая вставка',
    cirOption1: 'По часовой стрелке: G03 против часовой стрелки: G02',
    cirOption2: 'По часовой стрелке: G02 против часовой стрелки: G03',
    coordinate: {
      xPointSymbol: 'Горизонтальные координаты:',
      yPointSymbol: 'Продольные координаты:',
      zPointSymbol: 'Координаты подъема:',
      upright: 'Положительное значение',
      negative: 'Отрицательное значение'
      },
    encodeFormat: {
      format: 'Формат кодирования файла:',
      wrap: 'Параметры формата переноса строк:',
      formatOption1: 'Формат UTF - 8',
      formatOption2: 'Формат ANSI'
      },
    suffix: 'Суффикс файла установлен:',
    enableFP: 'Включить фронтальную обработку',
    slotSetting: 'Настройка лотка',
    slotMillSetting: 'Настройка вытяжных канавок / фрезерных отверстий',
    millSlot: 'Поддержка фрезерных отверстий',
    millingSlotOverlapRate: 'перекрытие фрезерных пазов',
    millingHoleSlotOverlapRate: 'коэффициент перекрытия фрезерных пазов',
    takeUpDirective: 'Приказ о приёме ножей',
    workSeparately: 'Положительный / отрицательный проход в два этапа',
    secondSlotLong: 'Длина второго лотка',
    enableOld: 'Включить настройки старых боковых отверстий',
    default: 'Настройки по умолчанию',
    customizable1: 'Настройка 1',
    customizable2: 'Настройка 2',
    customizable3: 'Настройка 3',
    customizable4: 'Настройка 4',
    knifeSetting: 'Настройка ножа',
    soltTip: '(Включая фрезерные отверстия / пазы)',
    specialSetting: 'Специальные параметры',
    ramino: 'Ламино',
    sun: 'Шип',
    please: 'С нетерпением жду',
    designatedKnives: 'Назначить нож',
    designated: 'указанный',
    workOrder: 'Команда обработки',
    other: 'другие',
    nameSetting: 'Параметры суффикса',
    repeatErr: 'Номер повторяется, пожалуйста, переустановите'
    },
  electronicSaw: {
    importMaterial: 'Импорт исходного листа',
    formSetting: 'Параметры формы электронной пилы',
    fileFormat: 'Формат файла выходного листа:',
    isSmallFile: 'Экспорт файлов изображений:',
    fileGroupRule: 'Файлы электронной пилы в зависимости от цвета, материала, толщины пластины различных таблиц:',
    roomsByCategory: 'Файлы электронной пилы делятся на разные таблицы в зависимости от комнаты:',
    delimiter: 'Разделитель:',
    fileName: 'Имя файла открытого списка:',
    fineNameTip: 'Имя файла открытого списка не может быть пустым!',
    fileNamePlaceholder: 'Настройка списка открытых материалов',
    outputFileEncoding: 'Формат кодирования выходного списка:',
    utf8: 'UTF - 8 с BOM',
    cellTab: 'Создать табуляцию ячеек:',
    texture: 'Текстура означает:',
    special: 'Инородное представление:',
    notSpecial: 'Не чужеродный.',
    genSimpleLabelBarcode: 'Создание штрих - кода для тегов простого формата',
    uniqueBarCode: 'Уникальный штрих - код.',
    uniqueBarCodeTip: 'Создать простой формат после открытия функции штрих - кода не работает',
    roboticArmDocking: 'стык манипулятора',
    customeForm: 'Настройка формы',
    tagPool: 'Пул тегов данных',
    tagPoolTips: 'Можно перетаскивать или нажимать кнопку Скопировать вкладки внутри пула',
    displayHead: 'Не показывать заголовок',
    addTableHead: 'Добавить заголовок',
    deleteTableHead: 'Удалить заголовок',
    generateExample: 'Создать образец формы вывода',
    importExample: 'Импорт образца формы',
    importExampleTip: 'Импортировать образец формы только для ссылки на пользовательскую электронную пилу',
    importExampleErrTip: 'Пока нет списка импортируемого сырья, пожалуйста, импортируйте список сырья',
    outputExample: 'Пример формы вывода',
    outputExampleTip: 'Настройка шаблона вывода формы',
    outputExampleErrTip: 'Образец формы вывода еще не создан, создайте образец формы вывода',
    defaultTableHead: 'Заголовок таблицы по умолчанию',
    deleteHeadErrTip: 'Нет заголовков, которые можно удалить!',
    genNonString: 'Создание типов данных в нетекстовых форматах',
    genNonStringTip: 'Созданная таблица данных Электронная пила не может быть идентифицирована, если вы можете попытаться включить',
    revertWidth: 'Длина и ширина поперечных пластин'
    },
  lockModal: {
    passwordInput: 'Введите пароль',
    lockPassword: 'Блокировать пароль',
    lockPasswordInput: 'Введите пароль разблокировки',
    passwordInputPlaceholder: 'Введите четырехзначный код.',
    editPassword: 'изменить пароль',
    confirmPassword: 'Подтверждение пароля',
    setLockPwd: 'Настройка пароля разблокировки',
    pwdFormatErr: 'Ошибка формата пароля',
    sendMessageTo: 'Код проверки SMS будет отправлен',
    captchaPlaceholder: 'Введите код проверки.',
    sendCaptcha: 'Отправить код подтверждения',
    sendSeccess: 'Сообщение отправлено успешно',
    sendFail: 'Ошибка отправки SMS, попробуйте позже',
    updateSeccess: 'Параметры успешно установлены',
    editSuccess: 'Изменение пароля успешно',
    lockSeccess: 'Удалось разблокировать',
    lock: 'разблокировать',
    lockSeccessTip: 'Удалось заблокировать',
    inputErrLimit: 'Количество ошибок в настоящее время ограничено, пожалуйста, переустановите пароль разблокировки!'
    },
  dock56Drill: {
    equipType: 'тип устройства',
    equipment: 'оборудование',
    fiveDock: 'пятигранное сверло',
    sixDock: 'Шестиугольное сверло',
    fileType: 'Тип генерируемого файла',
    templateOffline: 'Использовавшийся шаблон вышел из строя!',
    showExample: 'Показать примеры данных',
    conNoticeTip: 'Внимание при стыковке:',
    conNoticeTip1: '1. Скульптурные машины, включившие « XY - осевой своп», должны включить функцию «Автоматическая адаптация оборудования для обработки отверстий и канавок с переключением» в скульптурной машине.',
    conNoticeTip2: '2. Для отображения или обработки фасонной части пластины на пятигранном бурении требуется конфигурация данных фасонной части в шаблоне',
    conNoticeTip3: 'После первого использования пятигранного бурения или замены шаблона выполните пробное производство шкафа < / span > < span style = "color: # f00", а затем выполните обычное производство после подтверждения правильности',
    conNoticeTip4: 'При пробном производстве тщательно проверьте размер, глубину, расположение и правильное расположение канавки с положительным и отрицательным отверстием, < span style = "color: # f00" > Избегайте проблем с зеркалом шкафа < / span >',
    example: 'Примеры данных',
    commonSetting: 'Общие параметры',
    throughHoleSetting: 'Прорыв с двух сторон.',
    throughSlotSetting: 'Двойной проход.',
    nonHolesNotFiles: 'Прямоугольная пластина без отверстий не выводит файл:',
    frontFileIdentifier: 'Идентификатор положительного файла:',
    oppositeFileIdentifier: 'Идентификатор отрицательного файла:',
    oppositeFileIdentifierTips: 'Способ генерации: оригинальный 13 - битный код панели + символ идентификации',
    arcDescription: 'Описание дуги',
    linePoints: 'Описание формирования отрезка',
    arcCommand: 'Описание дуговой команды',
    slotWidthSplit: 'Широкий слот разбит на несколько узких слотов обработки:',
    slotSplitWidth: 'Ширина ячейки после демонтажа:',
    mm: 'Примечание: Объект демонтажа - обычный прямоугольник',
    isNotMergeSlot: 'Соседние равноширинные вытяжные канавки:',
    slotPunchTip: 'Эта функция работает только для лотков задней панели и ящиков, использующих пользовательские шаблоны',
    sizeRange: 'Соседние размеры меньше равны',
    enableWorningTip: 'Эта функция не может быть включена одновременно с направлением расположения передней крышки.',
    longDirection: 'Направление размещения листов на длинные края',
    horizontal: 'Горизонтальный',
    vertical: 'вертикальный',
    slotDirection: 'Направление расположения пяти / шестигранных желобов или фасонов',
    default: 'Система по умолчанию',
    frontLeft: 'Передний и левый',
    frontRight: 'Предыдущая и правая',
    backLeft: 'После и слева',
    backRight: 'После и справа',
    frontDirection: 'Направление расположения передней кромки',
    enableTip: 'Примечание: Действует только для облачной типографии',
    fixedOn: 'Закреплены в:',
    front: 'Впереди.',
    back: 'Сзади.',
    left: 'Слева.',
    right: 'справа',
    coordinateValue: 'Количество зарезервированных координат:',
    decimalPlaces: 'бит',
    slotLengthCompensation: 'компенсация длины паза',
    curveholesLengthCompensation: 'угол расчистки внутренней фасии',
    slotCompensationEqualZero: 'Компенсация кромки канавки до 0',
    slotCompensationNotEqualZero: 'Компенсация кромки канавки с расстоянием до 0',
    slotCompensationTip: 'Использовать эту функцию при возникновении небольшого неочищенного угла или недостаточной длины',
    curveholesCompensationEqualZero: 'Компенсация внутренней асимметрии до нуля',
    curveholesCompensationTip: 'Рекомендуемый вход: радиус внутреннего фасонного инструмента фрезерования',
    curveholesCompensationTip2: 'Использовать эту функцию при появлении небольших незарезанных углов во внутренних фасонах прямоугольной обработки наружного контура пластины',
    specialParameter: 'Специальные параметры',
    output5FDrillSlotKnifeCode: 'Номер XML2',
    output5FDrillShapeKnifeCode: 'Номер фрезерного инструмента XML2',
    plankTexture: 'Тексты панелей XML2',
    offset: 'Компенсация фрезерных инструментов XML2',
    mprConHoleDir: 'Пять / шесть сторон бурения MPR файл боковое отверстие Z координатная база',
    plankTop: 'Верхняя поверхность пластины',
    plankBottom: 'Нижняя поверхность пластины',
    codeInfo: 'Файл формата ban содержит Code информацию:',
    bomFile: 'Вывод файла в формате bom:',
    plankHeight: 'Описание высоты панели:',
    plankNum: 'Описание номера доски:',
    backZpoint: 'Отрицательные координаты Z:',
    plankThick: 'Толщина пластины',
    slotDeep: 'Глубина паза',
    outputMprFile: 'Тип документа',
    oldMPR: 'Старая версия MPR',
    newMPR: 'Новая версия MPR',
    mprFileZside: 'Пять / шесть сторон бурения MPR файл боковое отверстие Z координатная база',
    fileTypeOffline: 'Текущий выбранный тип файла с пятью или шестью сторонами сверления отключен, пожалуйста, убедитесь!',
    permissionErr: 'Личные данные утеряны, пожалуйста, откройте эту страницу снова из шкафа!',
    banFileSetting: 'Параметры файла формата ban',
    banFileCodeInfo: 'Файл формата ban содержит Code информацию:',
    huahuaLine: 'Березовый автомат',
    huahuaLineTip: '(Несовместимо с базовым стандартом размещения этикетки)',
    huahuaPartFlag: {
      longSide: 'Длинная сторона меньше',
      shortSide: 'Или короткая сторона меньше',
      partFlag: 'Создать идентификатор панели',
      tip: '(На этикетке показано, что необходимо добавить данные « Идентификация панели - разметка доски», соответствующие данные будут автоматически добавлены в файл березовой автоматической линии)'
      },
    plankPutWay: 'Режим размещения листов',
    plankPutWayTip: 'Если текущая производственная линия включена, настройка метода размещения листов не поддерживается',
    autoHandle: 'Автоматический предохранитель',
    manualHandle: 'Установить вручную',
    fixedFront: 'Закрытие передней кромки',
    plankNamePlacement: 'Размещение по имени плиты',
    plankNamePlacementTip1: '1. После настройки, если имя плиты содержит заданное поле, соответствующая сторона плиты будет зафиксирована на указанной стороне устройства',
    plankNamePlacementTip2: '2. Приоритет этой настройки выше, чем у настройки способа размещения плит выше',
    plankNamePlacementTip3: '3. Функция действует только для облачной вёрстки; если на текущей производственной линии включена автоматическая линия Huahua, отдельная настройка размещения плит не поддерживается',
    addRow: 'Добавить строку',
    plankNameTip: 'Пожалуйста, введите название плиты',
    plankSide: 'Кромка плиты',
    deviceSide: 'Фиксация на устройстве',
    weldingPlatePlacementEnable: 'Закрепление плиты на клемме',
    onlyBluen: 'Действует только для облачной версии',
    fixedEdge: 'Закрытие передней кромки',
    fixedEdgeRule: 'Правило: Определить расположение плиты',
    fixedEdgeRuleItem1: 'Длинное ребро близко к зажиму',
    fixedEdgeRuleItem2: 'Закрытие края близко к зажиму',
    fixedEdgeRuleItem3: 'Избегание отверстий и специальных форм у зажима',
    fixedEdgeRuleItem4: 'Приоритетный порядок',
    satisfiedCondition: 'Условие выполнено',
    handDirection: 'Направление зажима.',
    handleMachineTip: 'Сделайте отверстие и фасон вращающимся способом, чтобы автоматически избежать стороны зажима, чтобы облегчить обработку листов',
    handleWidth: 'Ширина зажима',
    handleLength: 'Длина зажима',
    handleMaxWidth: 'Максимальная ширина обработки оборудования',
    usefulRange: 'Сфера действия',
    plankLongSide: 'Длинный край пластины',
    usefulRangeTip: 'Когда открывающая пластина размещена с длинным краем и длинный край пластины находится в пределах этого диапазона действия, приоритет отдается расположению канавки и фасона.',
    moveTip: 'Функция распознавания положительных и отрицательных файлов перенесена',
    millingOuter: 'Фрезерная экзопланета',
    millingInner: 'Фрезерная гетероморфность',
    drilling: 'Обрабатывающее отверстие',
    slotting: 'Обрабатывающая ванна',
    knivesTip1: 'Установите путь резки после фрезы, чтобы компенсировать радиус ее ножа',
    knivesTip2: 'Инопланетная резка временно не поддерживает XY осевой обмен гравировальных машин',
    internalCutting: 'Внутренняя фасонная резка, нож и нож находятся внутри пластины.',
    externalCutting: 'Внешний фасонный резец и нож расположены на внешней стороне пластины.',
    externalCuttingDirection: 'При внешней фасонной резке весь край, содержащий фасон, будет вырезан синхронно',
    allExternalCutting: 'Все внешние',
    onlyArcExternalCutting: 'Только внешняя дуга'
    },
  doorWallCabinet: {
    tempErrTip: 'Обнаружено, что вы не добавили шаблон для станка «дверь-стена-шкаф», поэтому экспортировать файл обработки невозможно. Примечание: после добавления необходимо заново выполнить раскладку.',
    title: 'Машина для изготовления стен и шкафов',
    guifang: 'Квадраттание',
    processingTechnology: 'Технология обработки',
    longPlateSecondarySquaring: 'Длинная пластина вторичная квадратура',
    slotOnDoorPlate: 'Отверстия на дверной панели',
    setting: 'Настройка машины для изготовления стен и шкафов'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Формат выходного файла',
    outputDefaultFileFormat: 'Вывод файлов формата по умолчанию',
    outputMPRFormat: 'Экспорт файлов формата MPR',
    fileFormatSettings: 'Параметры формата файла',
    wrapSettings: 'Параметры формата переноса строк:',
    enCodeSettings: 'Настройка формата кодирования файлов:',
    utf8bom: 'UTF - 8 с бомом',
    partCoordinate: 'Маленькие координаты',
    xPointSymbol: 'Горизонтальные координаты:',
    yPointSymbol: 'Продольные координаты:',
    zPointSymbol: 'Координаты подъема:',
    upRight: 'Положительное значение',
    negative: 'Отрицательное значение',
    plankMirroring: 'Отражение панелей',
    plankMirrorSetting: 'Настройка зеркала панели:',
    xAxis: 'Отражение оси X',
    yAxis: 'зеркало оси Y',
    mirrorTip: '(Использовать эту функцию при зеркальном отображении панели)',
    knifeTable: {
      type: 'тип',
      diameter: 'Диаметр',
      offsetX: 'Смещение X',
      offsetY: 'Смещение Y',
      offsetZ: 'Смещение Z',
      offsetNo: 'Номер смещения',
      drillVelocity: 'Снять нож [F] mm / min',
      cutVelocity: 'Обработка [F] mm / min',
      rotationSeep: 'Скорость вращения [S] r / min',
      insertRow: 'Вставить строку',
      deleteRow: 'Удалить строку'
      },
    labelPool: 'Пул тегов данных',
    dragTip: 'Можно перетащить или нажать кнопку Скопировать вкладку в поле ввода',
    procedure: 'Процедуры',
    beginCode: 'Код начала программы:',
    endCode: 'Код окончания программы:',
    zzdKnifeBeginCode: 'Код начала смены ножа шпинделя:',
    spindleCutter: 'шпиндельный нож',
    zzdKnifeEndCode: 'Код окончания смены шпинделя:',
    verticalDrill: 'Вертикальное сверло',
    czzBeginCode: 'Код запуска вертикального бурения:',
    czzEndCode: 'Код окончания вертикального бурения:',
    czzKnifeBeginCode: 'Код начала вертикальной смены бриллианта:',
    czzKnifeEndCode: 'Код окончания вертикальной смены бриллианта:',
    sidetrack: 'Боковое сверло',
    czBeginCode: 'Код запуска бокового бурения:',
    czEndCode: 'Код окончания бокового бурения:',
    czKnifeBeginCode: 'Код начала смены ножа бокового бурения:',
    czKnifeEndCode: 'Код окончания бокового бурения:',
    pauseCode: 'Код паузы:',
    zSafeHeight: 'Безопасное расстояние',
    spindleKnife: 'Безопасная высота шпинделя и вертикального бурения по оси Z',
    sideDrillZ: 'Безопасная высота оси Z бокового бурения',
    sideDrillXY: 'Безопасное расстояние по оси X / Y бокового бурения',
    auxiliaryFunction: 'Вспомогательные функции',
    xhDedicatedInfo: 'Создание специальной информации об устройствах & quot; Старлайт & quot;',
    xhCheckBox: 'данные',
    outputSettings: 'Параметры вывода:',
    partExegesis: 'Создать комментарий размера панели в файле',
    knifeNo: 'Номер ножа',
    specailKnifeNo: 'Номер обработанного ножа:',
    slotKnifeNo: 'Номер режущего инструмента:',
    fileNamePlaceholder: 'Настройка списка открытых материалов',
    slotDrill: 'нож выпрямителя'
    },
  glassEquip: {
    title: 'Стеклорезка',
    fileType: 'Тип документа обработки:',
    sizeReparation: 'Компенсация размеров листов:',
    cutPreSpace: 'Предусмотренное расстояние для резки листов:',
    divideIntoFolders: 'В зависимости от цвета, материала и толщины стекла классифицируются по различным папкам:'
    },
  translate: {
    search: 'Пожалуйста, введите китайский или официальный перевод для поиска слов',
    en: 'английский',
    es: 'Испанский',
    ar: 'Арабский',
    kz: 'Казахский язык',
    vi: 'вьетнамский язык',
    th: 'тайский',
    id: 'Индонезийский язык',
    ug: 'Уйгурский язык',
    customTranslate: 'Нажмите, чтобы добавить пользовательский перевод',
    customText: 'Пользовательский перевод',
    text: 'китайский',
    targetLang: 'Официальный перевод',
    zh_hant: 'Китайский стиль'
    },
  preLayoutSetting: {
    title: 'Параметры предварительного набора',
    titleTip: 'Можно предварительно установить параметры типографии, сначала типографии, затем выбрать производственную линию',
    settingTip: 'Параметры, установленные в производственной линии, должны соответствовать следующим параметрам предварительной типографии, чтобы вывести производственную документацию, только для открывающей машины',
    emptyKnife: 'Нож не заполнен.',
    noModify: 'Настройки Не изменяется, не нужно сохранять',
    reSet: 'Восстановление',
    gayPosition: 'Серый квадрат может переключать место размещения',
    surplusPosition: 'Расположение текущего остатка',
    click: 'нажать',
    grayStart: 'Серый квадрат может переключать начальную точку станции',
    currentStart: 'Начало текущей позиции',
    holeSlotSetting: 'Параметры обработки в прорезях',
    knifeDiameter: 'диаметр разреза',
    currentVersion: 'Текущая версия',
    on: 'открыть',
    off: 'закрыть',
    firstShort: 'Первая резка - короткий боковой выброс',
    firstLong: 'Первоначальная резка - объемный выброс',
    cuttingSplitLong: 'Длинная пластина разрезается дважды - длинная сторона превышает',
    cuttingSplitShort: 'Длинная пластина разрезается дважды - короткая сторона превышает',
    plankThick: 'Толщина не дверной панели ≥ ',
    singleDoorThick: 'Толщина дверной панели ≥ ',
    normalPlank: 'Обычная доска',
    confilictTip: 'Существуют конфликтные настройки: {confilictTotal} элементов',
    selectLine: 'Выбор производственной линии',
    selectLinePlaceholder: 'Пожалуйста, выберите производственную линию.',
    lineConfilictTip: 'Выбранная производственная линия конфликтует с {line}',
    preWay: 'Предварительный вариант',
    paibanErrTip: 'При изменении « длинного, короткостороннего объема» обработки длинных пластин это может привести к сбою типографии',
    paibanTip: 'В этой типографии есть большой материал, указанный для раскройки ножа, необходимо переформатировать',
    reLayout: 'Переформатировать текущую производственную линию',
    fetchErr: 'Ошибка получения предварительных настроек',
    resetSuccess: 'Восстановление успешно',
    resetConfirm: 'Вернуться к исторической версии?',
    prolineName: 'Название производственной линии',
    layoutGap: 'Разрыв между наборами',
    generalThickness: 'Объект вторичной резки - обычная толщина пластины',
    cutGeneralPlank: 'Объект вторичной резки - обычная доска',
    cutSingleDoor: 'Объект вторичной резки - дверная панель',
    secondary_cutting_board_list: 'Укажите имя панели',
    changeProline: 'Переключить производственную линию',
    backTip: 'Пожалуйста, вернитесь к глобальному форматированию и выберите производственную линию',
    preLayout: 'Разбивка по предварительной схеме',
    preWayEmpty: '(Пустой) Предварительный вариант',
    specialConfilictTip: 'Процесс дугового фрезерного основания повлиял на результаты типографии и требует переформатирования'
    },
  lunbo: {
    tips: 'Маленькие навыки работы',
    introduction: 'функции',
    qtDownloadText: 'Теплый совет: если есть неполная загрузка файла, пожалуйста, перейдите на облачную страницу для загрузки!'
    },
  sendModal: {
    paibanImgType: 'Тип файла'
    },
  authenticationModal: {
    title: 'Проверка авторизации сканирования',
    tip: 'Не закрывайте рамку, пока не будет выполнена лицензия!',
    countdownTip: '{countdown} после истечения срока действия',
    refreshTip: 'Обновить QR - код',
    qrcodeTip: 'Выполните операцию с помощью микрокода.',
    qrcodeTip2: 'Если сканирование не удается сохранить, вам нужно будет разрешить изменить права системы в общих настройках шкафа - настройках пользовательской авторизации.',
    waiting: 'Код ожидания',
    scanning: 'Подсчитывается код, ожидая подтверждения',
    success: 'Проверка прошла успешно',
    error: 'Не удалось проверить',
    expired: 'Срок действия QR - кода истек.',
    tip2: 'Для безопасности данных вашей учетной записи необходимо проверить текущую информацию оператора.',
    tip3: 'Для производства образцов шкаф должен быть, {fontStyleStart}несимметричным, чтобы избежать проблем с отражением{fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: 'У вас нет прав на создание двуязычных китайско-английских этикеток; сейчас доступен только предпросмотр. Для полноценного использования обратитесь в отдел продаж~',
    generateDualLanguageTagTip: 'Создать китайско-английские двуязычные ярлыки',
    dualLanguageTip2: 'Эта функция платная. Перед использованием обратитесь в отдел продаж для активации~',
    effectiveDataSource: 'Эффективные источники данных',
    partName: 'Название плиты'
    },
  userAccessToken: {
    createTime: 'Время создания',
    lastUsedTime: 'Время последнего использования',
    expireTime: 'Время истечения',
    status: 'Статус',
    tokenNamePlaceholder: 'Введите имя токена',
    expireTimeSelectPlaceholder: 'Пожалуйста, выберите время истечения',
    securityBannerTip: 'Не передавайте личный токен доступа другим и не раскрывайте его в браузере или другом клиентском коде. Для защиты учётной записи утекшие токены, обнаруженные публично, могут быть автоматически отключены.',
    expired: 'Истёк',
    valid: 'Действителен',
    remove: 'Удалить',
    previewOnceWarning: 'Этот токен показывается только один раз. Сохраните секрет в безопасном и доступном месте. Не передавайте другим и не раскрывайте в браузере или другом клиентском коде.',
    token: 'Токен',
    deleteConfirm: 'Удалить этот токен?',
    userAccessToken: 'Токен доступа пользователя',
    dayUnit: 'дн.',
    custom: 'Пользовательский',
    previewModalTitle: 'Новый личный токен доступа',
    addModalTitle: 'Добавить новый личный токен доступа'
    },
  bujianStore: {
    inputPlaceholder: 'Введите код платформы для поиска дополнительных малых досок',
    noData: 'Нет данных',
    loadingErr: 'Загрузка дополнительных малых досок не удалась',
    bujianStore: 'Библиотека дополнительных малых досок',
    awaitStore: 'Библиотека печатных материалов',
    noDrag: 'Невозможно разместить, нажмите кнопку, чтобы разместить доску в библиотеку дополнительных малых досок',
    outOfCanvas: 'Невозможно разместить, пожалуйста, проверьте свойства материала, цвета и толщины доски'
    },
  alginTexture: {
    tip: 'Эта операция удалит информацию о совмещении текстуры плиты. Подтвердите, хотите ли вы продолжить?',
    tip2: 'Эта операция повлияет на расстояние между плитами, вызвав проблемы в обработке. Подтвердите, хотите ли вы продолжить?',
    group: 'Группа текстуры',
    groupTemp: 'Группа текстуры первая',
    textureAlignmentPlank: 'Невозможно переместить панель выравнивания текстуры'
    },
  customizeFolder: {
    customizeFolder: 'Настройка папки',
    customizeFolderTip: 'Примечание: После включения настройки папки, ранее установленные правила разделения папок перестанут действовать',
    processingFilesTitle: 'Обработка данных файла',
    dragToFolderTip: 'Можно перетащить в левую папку как подпапку или файл',
    folderNameEmpty: 'Имя папки не может быть пустым',
    folderNameExists: 'Существует папка с таким же именем',
    fileNotFound: 'Не удалось получить правильный файл',
    fileCannotBeClassified: 'Этот тип файла не может быть помещен в любую категоризационную папку',
    cannotAddAtThisPosition: 'Невозможно добавить в это место',
    fileAlreadyExists: '【{name}】уже существует в этой папке',
    confirmDeleteFolder: 'Вы уверены, что хотите удалить эту папку?',
    confirmDeleteItem: 'Вы уверены, что хотите удалить 【{name}】?',
    confirmDeleteFolderWithChildren: 'Под этой папкой есть другие папки/файлы, вы уверены, что хотите удалить ее?',
    deleteFile: 'Удалить файл',
    addSubFolder: 'Добавить подпапку',
    editFolder: 'Редактировать папку',
    deleteFolder: 'Удалить папку',
    rootCannotDelete: 'Корневой каталог не может быть удален',
    newFolder: 'Новая папка',
    fileUsedCanDrag: 'Использовано - Можно перетаскивать многократно',
    fileDraggable: 'Перетаскиваемый',
    addFileToFolder: 'Добавить 【{fileName}】 в {folderName}',
    addFolderTitle: 'Добавить папку',
    editFolderTitle: 'Редактировать папку',
    folderNameLabel: 'Имя папки',
    folderNamePlaceholder: 'Пожалуйста, введите имя папки',
    sequenceStartLabel: 'Начальное значение последовательного увеличения',
    classifyMethodLabel: 'Метод классификации',
    nameLengthLimitLabel: 'Ограничение длины символов',
    tagInsertTip: 'Нажмите на тег, чтобы вставить его в имя папки',
    classifyTagInsertTip: 'Нажмите на тег, чтобы вставить его в имя папки, файлы будут классифицированы в соответствии с указанным тегом',
    engraving_front: 'Файл передней части граверной машины',
    engraving_opposite: 'Файл обратной стороны граверной машины',
    engraving_merge: 'Файл объединения граверной машины',
    engraving_mill: 'Вторичная обработка фрезеровки роговых канавок',
    engraving_haitang: 'Файл со скосным углом Haitang вторичной обработки',
    engraving_arc_slot: 'Вторичная обработка фрезеровки донной дуговой канавки',
    engraving_line_slot: 'Вторичная обработка пользовательского пути инструмента',
    engraving_straight_arc_slot: 'Вторичная обработка дуговой гибки части прямой паз',
    engraving_frame_door: 'Вторичная обработка скелетной двери файл',
    engraving_inner_shape: 'Вторичная обработка внутренней формы',
    engraving_hole: 'Вторичная обработка обычного отверстия',
    engraving_slot: 'Вторичная обработка обычного паза',
    engraving_single_file_merge: 'Вторичная обработка объединения файлов',
    electronic_saw: 'Электронный пилочный файл',
    glass: 'Файл стеклорезающей машины',
    glass_machine: 'Стеклорезающая машина',
    side_machine: 'Файл боковой дробилки',
    side_machine_xml3: 'Файл XML3 боковой дробилки старой версии',
    side_machine_txt: 'Файл TXT боковой дробилки старой версии',
    side_machine_nc: 'Файл NC боковой дробилки старой версии',
    dock56F: 'Файл пяти/шестигранного сверления',
    ptp: 'Файл PTP',
    aio: 'Файл многофункциональной машины',
    aio_anc: 'Файл ANC фронтальной многофункциональной машины',
    labeling_1: 'Файл этикеткирующей машины 1',
    labeling_2: 'Файл этикеткирующей машины 2',
    labeling_3: 'Файл этикеткирующей машины 3',
    robotic_arm: 'Файл роботизованного манипулятора',
    label_image: 'Файл изображения этикетки',
    label_pdf: 'Файл PDF этикетки',
    paiban_image: 'Файл типографского изображения',
    paiban_pdf: 'Файл PDF типографского изображения',
    engraving: 'Гравировальная машина',
    electronic: 'Электронная пила',
    side_hole: 'Боковая дробилка',
    drilling: 'Пяти/шестигранное сверление',
    labeling: 'Этикеткирующая машина',
    robotic: 'Роботизованный манипулятор',
    label: 'Этикетка',
    warningTip: 'Обратите внимание: Фигурные скобки 【{}】 и их содержимое должны оставаться нетронутыми, не удаляйте/не добавляйте вручную!',
    fileClassifyError: 'Этот файл не может быть классифицирован по {classifyNames}',
    folderClassifyByTextureColorThickSize: 'Классифицировать в разные папки по цвету, материалу, толщине и размеру большого щита (файлы этикеток вместе)',
    unnamed: 'Безымянный',
    specialText: 'Специальный',
    surplusText: 'Излишковый материал',
    normalText: 'Обычный',
    plankText1: 'Доска',
    resetTemplate: 'Сброс шаблона',
    resetTemplateConfirm: 'Вы уверены, что хотите сбросить шаблон?',
    clearTemplate: 'Очистить шаблон',
    clearTemplateConfirm: 'Вы уверены, что хотите очистить шаблон?',
    legendFixedFolder: 'Фиксированная папка',
    legendClassifyFolder: 'Классифицированная папка',
    legendFixedTag: 'Фиксированные данные',
    legendNormalTag: 'Динамические данные',
    legendClassifyTag: 'Классифицированные динамические данные',
    door_wall_aio: 'Машина для изготовления стен и шкафов',
    noPermission: 'У вас нет разрешения на использование пользовательских папок. Перед использованием обратитесь в отдел продаж для покупки этой функции.',
    enableCustomFolder: 'Включить пользовательские папки',
    exporttagTip: 'При одновременном экспорте тегов PDF и изображений, по умолчанию отправляется PDF'
    },
  paibanTask: {
    pausedTip: 'Приостановленные задачи',
    deleteTip: 'Вы уверены, что хотите удалить задачу «{taskBatch}»? После удаления восстановление невозможно.',
    continueTip: 'Продолжить задачу',
    completed: 'Выполнено',
    failed: 'Задача не выполнена',
    paused: 'Приостановленные задачи',
    pending: 'Ожидание задачи',
    running: 'Выполнение задачи',
    extraTip: 'Задача компоновки показывает данные только за прошедшую неделю. Пожалуйста, сохраните задачу в историю после завершения!',
    taskStatus: 'Статус задачи',
    createTaskTip: 'Создать задачу компоновки, перейти в компоновку',
    taskBatchTitle: 'Партия задач',
    relatedOrderNosTitle: 'Связанные номера заказов',
    progressTitle: 'Прогресс компоновки',
    boardCountTitle: 'Расход плит оценивается',
    optimizedAreaTitle: 'Оценка оптимизированной площади',
    productionLineTitle: 'Производственная линия',
    operationTitle: 'Действия',
    optimizeRateTitle: 'Оценка коэффициента оптимизации',
    optimizeRateTip: 'Оптимизация автоматически вырезанных излишков материала не учитывается.',
    optimizeRateTip2: 'Оценка коэффициента оптимизации конкретная на основе страницы компоновки',
    boardCountTip: 'Количество досок конкретное на основе страницы компоновки',
    optimizedAreaTip: 'Оптимизированная площадь конкретная на основе страницы компоновки',
    paibanSettingTip: 'Производственные настройки для текущей задачи были изменены. Текущие результаты компоновки могут конфликтовать с фактическими файлами экспорта производства. Рекомендуется повторная компоновка производства.',
    dataException: 'Ошибка данных, пожалуйста, обновите страницу и попробуйте снова'
    },
  paibanSetting: {
    advancedSetting: 'Расширенные настройки',
    advancedFeature: 'Расширенные функции',
    surplusCutSpeedUp: 'Автоматическое ускорение резки остатков',
    surplusCutSpeedUpTip4: 'Разработка функции в процессе, пожалуйста, подождите',
    surplusCutSpeedUpTip: 'Зазор при раскладке остатков автоматически устанавливается в 0',
    surplusCutSpeedUpTip2: 'Резка остатков автоматически пропускает уже прорезанные и подкроечные траектории, повышая эффективность',
    surplusCutSpeedUpTip3: 'Эта функция работает только для гравировальных машин и машин гравирования с одним поворотом (не используйте вместе с общим резом или общим ускорением)',
    surplusCutSpeedUpTip5: 'Эффективно только для гравировальных машин и машин гравирования с одним поворотом',
    featureDisplay: 'Отображение функций',
    featureDisplayTip: 'Эта страница только управляет отображением входов функций и не изменяет состояние включения и параметры самих функций'
    },
  alignedPlan: {
    deepSearch: 'Глубокий поиск',
    deepSearchTip: 'Эксклюзивная функция: увеличьте глубину расчёта повторной раскладкой для лучшего результата',
    deepSearchTip2: 'После обновления Deep Search повторная раскладка увеличит глубину расчёта. Сейчас доступен пробный режим',
    deepSearchTip3: 'Deep Search предлагает более экономную по плитам раскладку',
    deepSearchTip4: 'Сейчас нет прав на раскладку Deep Search. Свяжитесь с отделом продаж для покупки.',
    deepSearchTip5: 'После обновления Deep Search доступна выделенная серверная мощность для лучшего качества. Сейчас можно просмотреть'
    }
  }